import {
  getAvailableLendersByLenderCommissions,
  getHomeLoanTotalLoanAmount,
  getPreferredProduct
} from '__core/shared/util/salestrekker';
import templateTicketEditChecklistItem from './ticketEditChecklistItem.template.html';
import templateTicketInterviewOnClientPortal from './ticketInterviewOnClientPortal.template.html';
import templateTicketMoveOnBoard from './ticketMoveOnBoard.template.html';
import templateRedactDocument from './ticketRedactAttachment.html';
import templateTicketRefer from './ticketRefer.template.html';
import templateTicketShareOnClientPortal from './ticketShareOnClientPortal.template.html';
import templateTicketSignatureRequest from './ticketSignatureRequest.template.html';
import templateTicketStatusChange from './ticketStatusChange.template.html';
/* @ngInject */

export default (
  $q,
  $rootScope,
  $scope,
  $state,
  $stateParams,
  $filter,
  $timeout,
  $anchorScroll,
  $location,
  $mdMedia,
  $mdDialog,
  $mdDateLocale,
  $mdUtil,
  $window,
  cookies,
  clipboard,
  webpage,
  authenticationService,
  actionService,
  eventService,
  emailService,
  dateTimeService,
  organizationService,
  attachmentsService,
  accountService,
  accountsService,
  Field,
  Asset,
  LabelType,
  Liability,
  contactsService,
  partnersService,
  pepperResolveService,
  checklistsService,
  contactService,
  jobService,
  jobsService,
  jobTypesService,
  noteService,
  notesService,
  ticketService,
  ticketsService,
  workflowService,
  workflowsService,
  clientAccessService,
  documentService,
  documentsService,
  labelsService,
  assetFinanceService,
  homeLoanService,
  lendersService,
  messagesService,
  uiService,
  fileFactory,
  JobProgress,
  Ticket,
  TicketStatusHistory,
  TicketSharedWithClientProfile,
  TicketSharedWithClientProfileSection,
  TicketSharedWithClientProfileType,
  Contact,
  ChecklistItem,
  commissionsService,
  Commission,
  Note,
  Ownership,
  Income,
  incomeService,
  fieldService,
  helperService,
  pdfService,
  validationService,
  financeService,
  financesService,
  accessService,
  TicketPersonalLoanPurpose,
  TicketContactType,
  ContactEmploymentType,
  WorkflowType,
  flexService,
  ACCOUNT,
  PARTNER,
  CONTACT,
  NOTE,
  NAVIGATION,
  TICKET,
  DOCUMENT
) => {
  $scope.Model = {
    organizationCountry: helperService.getOrganizationCountry(),
    idLabelsOfClient: helperService.getIdLabelsOfClient(),
    currentTicket: {},
    currentWorkflow: {},
    availableWorkflows: [],
    availableAccounts: [],
    availableTicketAccounts: [],
    availablePartners: [],
    ticketPartners: [],
    availableOtherPartners: [],
    availableTickets: [],
    availableContacts: [],
    availablePersonOnlyClients: [],
    availableSpouses: [],
    availableNotes: [],
    availableTicketLabels: [],
    availableContactLabels: [],
    availableNoteLabels: [],
    availableJobs: [],
    availableJobLabels: [],
    availableAttachments: [],
    availableFileLabels: [],
    availableComplianceFileLabels: [],
    filteredNotes: [],
    availableChecklists: [],
    availableJobTypes: [],
    availableMessages: [],
    availableDocuments: [],
    standardDocuments: [],
    complianceDocuments: [],
    allItems: [],
    activityItems: [],
    importantItems: [],
    availableJobProgresses: JobProgress.available,
    availableIncomeTypes: incomeService.getAvailableIncomeTypes(),
    availablePdfTypes: helperService.getAvailablePdfTypes(),
    currentAssetFinance: {},
    currentHomeLoan: {},
    ticketTeamMembers: [],
    ticketClients: [],
    ticketContacts: [],
    ticketAvailableContacts: [],
    teamMembers: [],
    availableComplianceTypes: [],
    complianceDocumentsUploadTypes: [],
    activeTabList: 0,
    isTicketLabelSelected: true,
    preferredProduct: undefined,
    availableLenders: [],
    allLenders: [],
    availableLendersPerCountry: [],
    availableLendersDocuments: [],
    maximumBorrowing: {},
    currentLender: null,
    currentLendersDocuments: [],
    isCurrentLenderReady: false,
    outboundReferrers: [],
    filters: {
      currentNoteType: '',
      currentNoteTypeDisplay: 'Everything',
      currentNoteLabel: '',
      currentNoteLabelDisplay: 'All',
      currentNoteOwner: '',
      currentNoteOwnerDisplay: 'Owner',
      currentFile: 'Everything'
    },
    list: {
      importants: null,
      ticket: null,
      notes: null,
      jobs: null,
      jobWatcher: null,
      hasJobSelection: false,
      isJobCompleted: 'everything',
      checklist: null,
      hasChecklistSelection: false,
      attachments: null,
      hasAttachmentSelection: false,
      activity: null,
      complianceSelection: false,
      hasAttachmentComplianceSelection: false,
      isAttachmentArchive: false,
      isCombinePdfSelected: false
    },
    ticketFormContentStyle: { 'margin-left': '20%' },
    previousState: '',
    showMore: false,
    isClientPortalEnabled:
      $rootScope.CurrentOrganization.hasFeatureClientPortal() &&
      $rootScope.CurrentOrganization.canUseSMS(),
    isClipboardSupported: clipboard.supported,
    isNoteReady: false,
    isJobReady: false,
    isChecklistReady: true,
    isAttachmentsReady: false,
    isEdit: {
      ticketName: false,
      ticketValue: false,
      ticketCloseDate: false,
      ticketFinanceDueDate: false,
      ticketDescription: false,
      loanIdLenderApplication: false
    },
    idLenderApplication: '',
    videoConferenceUrl: null,
    isSidebarMinimized:
      cookies.get('stSidebar') && cookies.get('stSidebar') !== undefined
        ? cookies.get('stSidebar')
        : false,
    validation: {
      errors: [],
      needsAndObjectivesErrors: [],
      productRequirementsErrors: [],
      bidErrors: []
    },
    isReady: false
  };

  /*
   * Set webpage Title
   * --------------------------------------------------------------------------------
   */
  webpage.pageTitle('Loading, please wait');

  /*
   * Methods
   * --------------------------------------------------------------------------------
   */
  const loadLendersPerCountry = () => {
    lendersService
      .getAvailable({
        cca2: [$scope.Model.organizationCountry?.cca2]
      })
      .then((lenders) => {
        if (lenders?.length) {
          $scope.Model.availableLendersPerCountry = lenders;
        }
      });
  };

  const loadLendersDocuments = (idLenders) => {
    lendersService
      .getDocuments({ idLenders, types: ['LOGO', 'CALCULATOR', 'CALCULATOR_SCHEMA'] })
      .then((lendersDocuments) => {
        if (lendersDocuments && lendersDocuments.length) {
          $scope.Model.availableLendersDocuments = lendersDocuments;
        }
      });
  };

  const loadMessages = () => {
    messagesService.getAvailable({ type: ['email'] }).then((messages) => {
      $scope.Model.availableMessages = messages;
    });
  };

  const loadChecklists = () => {
    checklistsService.getAvailable({ isActive: true }).then((checklists) => {
      $scope.Model.availableChecklists = checklists;
    });
  };

  const loadDocuments = () => {
    documentsService.getAvailable({ isActive: true }).then((documents) => {
      if (documents && documents.length) {
        $scope.Model.availableDocuments = documents;
        const complianceIdLabels = _.map($scope.Model.availableComplianceFileLabels, 'id');
        $scope.Model.standardDocuments = documents.filter((d) =>
          _.every(d.idLabels, (l) => complianceIdLabels.indexOf(l) === -1)
        );
        $scope.Model.complianceDocuments = documents.filter((d) =>
          _.some(d.idLabels, (l) => complianceIdLabels.indexOf(l) > -1)
        );
      }
    });
  };

  const loadLabels = () => {
    labelsService
      .getAvailable({
        orderBy: 'name',
        coerceTo: 'string',
        isDescending: false,
        isActive: true
      })
      .then((labels) => {
        if (labels && labels.length) {
          $scope.Model.availableLabels = labels;
          $scope.Model.availableTicketLabels = _.filter(
            labels,
            (l) => l.type.name === LabelType.ticket.name
          );
          $scope.Model.availableContactLabels = helperService.sortContactLabels({
            labels: _.filter(labels, (l) => l.type.name === LabelType.contact.name)
          });
          $scope.Model.availableNoteLabels = _.filter(
            labels,
            (l) => l.type.name === LabelType.note.name
          );
          $scope.Model.availableJobLabels = _.filter(
            labels,
            (l) => l.type.name === LabelType.job.name
          );
          $scope.Model.availableFileLabels = _.filter(
            labels,
            (l) => l.type.name === LabelType.file.name
          );
          $scope.Model.availableComplianceFileLabels = _.filter(
            labels,
            (l) => l.type.name === LabelType.file.name && l.isLocked
          );
          loadDocuments();
          $scope.Model.isTicketLabelSelected = true;
        }
      });
  };

  const loadJobs = () => {
    $scope.Model.isJobReady = false;
    $scope.Model.availableJobs = [];
    jobsService
      .getAvailablePerTicket({ idTicket: $stateParams.dd, isActive: true })
      .then((jobs) => {
        if (jobs && jobs.length) {
          const iItems = jobs.filter(
            (i) =>
              (i.isPinned ||
                i.isJobOverdue($rootScope.CurrentTimeZone()) ||
                i.isJobDue($rootScope.CurrentTimeZone())) &&
              !i.isCompleted
          );
          for (let i = 0; i < iItems.length; i += 1) {
            const iIdx = helperService.findIndexById($scope.Model.importantItems, iItems[i].id);
            if (iIdx === -1) {
              $scope.Model.importantItems.push(iItems[i]);
            }
          }
          const importantIds = _.map($scope.Model.importantItems, 'id');
          $scope.Model.allJobs = jobs;
          if ($scope.Model.list.isJobCompleted === 'completed') {
            $scope.Model.availableJobs = _.filter(jobs, (i) => i.isCompleted);
          } else if ($scope.Model.list.isJobCompleted === 'uncompleted') {
            $scope.Model.availableJobs = _.filter(
              jobs,
              (i) => !i.isCompleted && importantIds.indexOf(i.id) === -1
            );
          } else {
            $scope.Model.availableJobs = _.filter(
              jobs,
              (i) => importantIds.indexOf(i.id) === -1
            );
          }
          const aItems = $scope.Model.availableJobs;
          for (let a = 0; a < aItems.length; a += 1) {
            const aIdx = helperService.findIndexById($scope.Model.allItems, aItems[a].id);
            if (aIdx === -1) {
              $scope.Model.allItems.push(aItems[a]);
            }
          }
        }
        $scope.Model.isJobReady = true;
        $scope.Model.showAssignedTo = $rootScope.CurrentAccount.isAdministrator;
      });
  };

  const loadJobTypes = () => {
    jobTypesService.getAvailable({ isActive: true }).then((jobtypes) => {
      $scope.Model.availableJobTypes = jobtypes;
    });
  };

  const loadWorkflow = () => {
    const deferred = $q.defer();
    workflowService.readWorkflow({ id: $stateParams.id }).then((workflow) => {
      $scope.Model.currentWorkflow = workflow;
      deferred.resolve(workflow);
    });
    return deferred.promise;
  };

  const loadTicket = () => {
    const deferred = $q.defer();
    ticketService.readTicket({ id: $stateParams.dd }).then((ticket) => {
      $scope.Model.currentTicket = ticket;
      deferred.resolve(ticket);
    });
    return deferred.promise;
  };

  const loadPartners = () => {
    partnersService
      .getAvailable({ isActive: true, fields: ACCOUNT.FIELDS.CHIPS })
      .then((partners) => {
        $scope.Model.availablePartners = partners;
        if (partners?.length && $scope.Model.currentTicket?.idPartners?.length) {
          $scope.Model.ticketPartners = _.sortBy(
            _.filter(partners, (c) => $scope.Model.currentTicket.idPartners.indexOf(c.id) > -1)
          );
        }
      });
  };

  const loadCurrentLendersDocuments = (idLenders) => {
    if (idLenders && idLenders.length) {
      lendersService.getDocuments({ idLenders, types: ['LOGO'] }).then((lendersDocuments) => {
        if (lendersDocuments && lendersDocuments.length) {
          $scope.Model.currentLendersDocuments = lendersDocuments;
        }
      });
    } else {
      lendersService
        .getAvailable({ cca2: [helperService.getOrganizationCountry().cca2] })
        .then((lendersDocuments) => {
          if (lendersDocuments && lendersDocuments.length) {
            $scope.Model.currentLendersDocuments = lendersDocuments;
          }
        });
    }
  };

  const loadLender = (idLender) => {
    $scope.Model.isCurrentLenderReady = false;
    lendersService
      .getSpecific({
        idLenders: [idLender],
        cca2: [helperService.getOrganizationCountry().cca2]
      })
      .then((data) => {
        if (data && data.length) {
          const lender = data[0];
          $scope.Model.currentLender = lender;
          $scope.Model.isCurrentLenderReady = true;
          loadCurrentLendersDocuments([$scope.Model.currentLender.id]);
        }
      });
  };

  const loadHomeLoan = (idHomeLoan) => {
    homeLoanService.readHomeLoan({ id: idHomeLoan }).then((loan) => {
      $scope.Model.currentHomeLoan = loan;
      $scope.Model.idLenderApplication = $scope.Model.currentHomeLoan.idLenderApplication;
      $scope.Model.availableComplianceTypes = _.sortBy(DOCUMENT.TYPES, 'value');
      $scope.getSetAvailableComplianceTypes();

      const preferredProduct = getPreferredProduct(
        $scope.Model.currentHomeLoan?.reviewProducts || []
      );
      if (preferredProduct?.idLender) {
        loadLender(preferredProduct.idLender);
      }
      $scope.Model.preferredProductTotalLoanAmount = getHomeLoanTotalLoanAmount(
        $scope.Model.currentHomeLoan?.reviewProducts,
        $scope.Model.organizationCountry?.cca2
      );
    });
  };

  const loadAssetFinance = (idAssetFinance) => {
    assetFinanceService.readAssetFinance({ id: idAssetFinance }).then((assetFinance) => {
      $scope.Model.currentAssetFinance = assetFinance;
      $scope.Model.idLenderApplication = $scope.Model.currentAssetFinance.idLenderApplication;
      $scope.Model.availableComplianceTypes = helperService.getSetAvailableComplianceTypes({
        workflow: $scope.Model.currentWorkflow,
        isAssetFinanceCommercial: $scope.Model.currentAssetFinance?.isCommercial || false
      });
      const preferredProduct = getPreferredProduct(
        $scope.Model.currentAssetFinance?.compareProducts || []
      );
      if (preferredProduct?.selectedProduct?.lender?.length) {
        loadLender(preferredProduct.selectedProduct.lender[0].id);
      }
    });
  };

  const loadSpouses = (idContacts) => {
    contactsService.getSpecific({ idContacts, isActive: true }).then((spouses) => {
      $scope.Model.availableSpouses = spouses;
    });
  };

  const loadContacts = (idContacts) => {
    const deferred = $q.defer();
    const attachContactOwners = _.compact(
      _.map($scope.Model.currentTicket.attachments, 'idOwnerContact')
    );
    const allContactIds = idContacts.concat(attachContactOwners);
    contactsService
      .getSpecific({ idContacts: allContactIds, isActive: true })
      .then((contacts) => {
        const availableContacts = _.compact(contacts);
        if (availableContacts?.length) {
          $scope.Model.availableContacts = availableContacts;
          $scope.Model.ticketClients = availableContacts.filter(
            (c) => $scope.Model.currentTicket.idClients.indexOf(c.id) > -1
          );
          $scope.Model.ticketClients = _.sortBy($scope.Model.ticketClients, (c) =>
            _.indexOf($scope.Model.currentTicket.idClients, c.id)
          );
          $scope.Model.ticketContacts = availableContacts.filter(
            (c) => $scope.Model.currentTicket.idContacts.indexOf(c.id) > -1
          );
          $scope.Model.ticketContacts = _.sortBy($scope.Model.ticketContacts, (c) =>
            _.indexOf($scope.Model.currentTicket.idContacts, c.id)
          );
          $scope.Model.availablePersonOnlyClients = _.filter(
            availableContacts,
            (c) => !c.isCompany
          );
          let idSpouses = _.map(
            _.filter(
              $scope.Model.availablePersonOnlyClients,
              (c) => c.person.information.idSpouse && c.person.information.idSpouse !== ''
            ),
            (s) => s.person.information.idSpouse
          );
          idSpouses = _.uniq(_.compact(idSpouses));

          if (idSpouses.length) {
            loadSpouses(idSpouses);
          }
          if ($scope.Model.isClientPortalEnabled) {
            for (let i = 0; i < $scope.Model.ticketClients.length; i += 1) {
              clientAccessService
                .hasAccess({
                  idTicket: $scope.Model.currentTicket.id,
                  idContact: $scope.Model.ticketClients[i].id
                })
                .then((result) => {
                  const client = $scope.Model.ticketClients.find(
                    (c) => c.id === $scope.Model.ticketClients[i].id
                  );
                  client.hasAccessToClientPortal = result;
                });
            }
          }
          for (let i = 0; i < availableContacts.length; i += 1) {
            const contact = availableContacts[i];
            const availableContact = {
              id: '',
              isCompany: '',
              name: '',
              familyName: '',
              phoneCode: '',
              phone: '',
              email: '',
              type: '',
              homeCode: '',
              homePhone: '',
              workCode: '',
              workPhone: '',
              preferredContactMethod: {
                phone: false,
                email: false
              },
              residentialStatus: '',
              employmentType: '',
              employmentBasis: '',
              employmentSubTypes: {
                onBenefits: false,
                student: false,
                homeDuties: false
              }
            };
            availableContact.id = contact.id;
            availableContact.isCompany = contact.isCompany;
            if (contact.isCompany) {
              availableContact.name =
                contact.company &&
                contact.company.information &&
                contact.company.information.name
                  ? contact.company.information.name
                  : '';
              availableContact.phoneCode =
                contact.company && contact.company.contact && contact.company.contact.phoneCode
                  ? contact.company.contact.phoneCode
                  : '';
              availableContact.phone =
                contact.company && contact.company.contact && contact.company.contact.phone
                  ? contact.company.contact.phone
                  : '';
              availableContact.email =
                contact.company && contact.company.contact && contact.company.contact.email
                  ? contact.company.contact.email
                  : '';
            } else {
              availableContact.name =
                contact.person &&
                contact.person.information &&
                contact.person.information.firstName
                  ? contact.person.information.firstName
                  : '';
              availableContact.familyName =
                contact.person &&
                contact.person.information &&
                contact.person.information.familyName
                  ? contact.person.information.familyName
                  : '';
              availableContact.phoneCode =
                contact.person && contact.person.contact && contact.person.contact.primaryCode
                  ? contact.person.contact.primaryCode
                  : '';
              availableContact.phone =
                contact.person && contact.person.contact && contact.person.contact.primary
                  ? contact.person.contact.primary
                  : '';
              availableContact.email =
                contact.person && contact.person.contact && contact.person.contact.email
                  ? contact.person.contact.email
                  : '';
            }
            availableContact.type =
              $scope.getIdLabelByContact(contact.id) || $scope.getIdLabelByClient(contact.id);

            $scope.Model.ticketAvailableContacts.push(availableContact);
          }
        }
        deferred.resolve(availableContacts);
      });
    return deferred.promise;
  };

  const loadNotes = () => {
    const deferred = $q.defer();
    $scope.Model.isNoteReady = false;
    notesService
      .getSpecific({ idTickets: $scope.Model.currentTicket.id, isActive: true })
      .then((notes) => {
        if (notes.length) {
          $scope.Model.allNotes = notes;
          $scope.Model.availableNotes = notes.filter((i) => !i.isPinned);
          const iItems = notes.filter((i) => i.isPinned);
          for (let i = 0; i < iItems.length; i += 1) {
            const iIdx = helperService.findIndexById($scope.Model.importantItems, iItems[i].id);
            if (iIdx === -1) {
              $scope.Model.importantItems.push(iItems[i]);
            }
          }
          $scope.Model.filteredNotes = notes;
          for (let a = 0; a < $scope.Model.availableNotes.length; a += 1) {
            const aIdx = helperService.findIndexById(
              $scope.Model.allItems,
              $scope.Model.availableNotes[a].id
            );
            if (aIdx === -1) {
              $scope.Model.allItems.push($scope.Model.availableNotes[a]);
            }
          }
        }
        $scope.Model.isNoteReady = true;
        deferred.resolve(notes);
      });
    return deferred.promise;
  };

  const loadAccount = (idOwner) => {
    const deferred = $q.defer();
    accountService.readAccount({ id: idOwner }).then((account) => {
      $scope.Model.currentTicketOwner = account;
      deferred.resolve(account);
    });
    return deferred.promise;
  };

  const loadAccounts = (idAccounts) => {
    const deferred = $q.defer();
    $scope.Model.isAccountReady = false;
    accountsService
      .getSpecific({ ids: idAccounts, isActive: true, fields: ACCOUNT.FIELDS.LIST_COMPACT })
      .then((accounts) => {
        if (accounts && accounts.length) {
          $scope.Model.availableAccounts = accounts;
          const idTicketAccounts = _.union(
            [$scope.Model.currentTicket.idOwner],
            $scope.Model.currentTicket.idAccountsAsPartners,
            _.map($scope.Model.currentTicket.attachments, 'idOwner'),
            $scope.Model.currentTicket.idTeamMembers,
            _.map($scope.Model.availableNotes, 'idOwner')
          );
          $scope.Model.availableTicketAccounts = _.filter(
            accounts,
            (a) => idTicketAccounts?.indexOf(a?.id) > -1
          );
          $scope.Model.ticketTeamMembers = _.filter(
            accounts,
            (account) => $scope.Model.currentTicket.idTeamMembers.indexOf(account.id) > -1
          );
          $scope.Model.teamMembers = _.filter(
            accounts,
            (account) =>
              $scope.Model.currentWorkflow.idTeamMembers.indexOf(account.id) > -1 ||
              $scope.Model.currentWorkflow.idOwner === account.id
          );
        }
        $scope.Model.isAccountReady = true;
        deferred.resolve(accounts);
      });
    return deferred.promise;
  };

  const loadLenders = (account) => {
    const deferred = $q.defer();
    $scope.Model.isLenderReady = false;
    let lenderType = '';
    if ($scope.Model.currentWorkflow?.isHomeLoan()) {
      lenderType = 'RESIDENTIAL';
    } else if ($scope.Model.currentWorkflow?.isAssetFinance()) {
      lenderType = 'ASSET_FINANCE';
    } else if ($scope.Model.currentWorkflow?.isCommercialLoan()) {
      lenderType = 'COMMERCIAL';
    } else if ($scope.Model.currentWorkflow?.isPersonalLoan()) {
      lenderType = 'PERSONAL';
    }
    if (lenderType !== '') {
      $q.all([
        organizationService.readOrganization({ id: $rootScope.CurrentOrganization?.id }),
        lendersService.getAvailable({
          cca2: [$scope.Model.organizationCountry?.cca2],
          type: lenderType
        }),
        $scope.Model.currentTicket?.idAssetFinance
          ? assetFinanceService.readAssetFinance({
              id: $scope.Model.currentTicket?.idAssetFinance,
              fields: {
                list: ['isCommercial']
              }
            })
          : {}
      ]).then((data) => {
        const organization = data[0];
        const lenders = data[1];
        const assetFinance = data[2];
        $scope.Model.allLenders = _.chain(lenders)
          .sortNatural('name')
          .sortNatural('group')
          .value();

        const availableLenders = getAvailableLendersByLenderCommissions(
          lenders,
          organization,
          account,
          $scope.Model.currentWorkflow,
          $rootScope.IsEnterprise,
          assetFinance?.isCommercial || false
        );
        $scope.Model.availableLenders = _.chain(availableLenders)
          .sortNatural('name')
          .sortNatural('group')
          .value();

        const idLenders = _.map($scope.Model.availableLenders || [], 'id');
        if (idLenders?.length) {
          loadLendersDocuments(idLenders);
        }
        $scope.Model.isLenderReady = true;
        deferred.resolve(lenders);
      });
    } else {
      $scope.Model.isLenderReady = true;
      deferred.resolve([]);
    }
    return deferred.promise;
  };

  const loadAttachments = () => {
    $scope.Model.isAttachmentsReady = false;
    $timeout(() => {
      const ticketAttachments = angular.copy($scope.Model.currentTicket.attachments);
      let noteAttachments = $scope.Model.availableNotes.map((note) => {
        const attachments = [];
        for (let n = 0; n < note.attachments.length; n += 1) {
          const attach = note.attachments[n];
          if (attach.file) {
            attach.idNote = note.id;
            attach.noteType = note.type;
            if (_.find(attachments, { id: attach.id }) === undefined) {
              attachments.push(attach);
            }
          }
        }
        return attachments;
      });
      noteAttachments = _.flatten(noteAttachments);
      $scope.Model.availableAttachments = _.union(ticketAttachments, noteAttachments);
      for (let i = 0; i < ticketAttachments.length; i += 1) {
        const aIdx = helperService.findIndexById(
          $scope.Model.allItems,
          ticketAttachments[i].id
        );
        if (aIdx === -1) {
          $scope.Model.allItems.push(ticketAttachments[i]);
        }
      }
      $scope.Model.isAttachmentsReady = true;
    });
  };

  const loadOtherPartners = (idPartners) => {
    partnersService
      .getSpecific({ ids: idPartners, isActive: true, fields: PARTNER.FIELDS.LIST })
      .then((partners) => {
        $scope.Model.availableOtherPartners = partners;
      });
  };

  const loadWorkflows = () => {
    workflowsService.getAvailable({ isActive: true }).then((workflows) => {
      if (workflows && workflows.length) {
        $scope.Model.availableWorkflows = workflows;
      }
    });
  };

  const getStatusChangeTitle = (sh) => {
    if (sh.isDueAhead) {
      return 'Due tomorrow';
    }
    if (sh.isDue) {
      return 'Due';
    }
    if (sh.isOverdue) {
      return 'Overdue';
    }
    if (sh.isReadyForVerification && !sh.isVerified) {
      return 'Ready for verification';
    }
    if (sh.isVerified) {
      return 'Verified';
    }
    if (sh.isFrozen) {
      return 'Paused';
    }
    if (sh.isRotten) {
      return 'Stale';
    }
    if (sh.isSubmitted) {
      return 'Submitted';
    }
    if (sh.isLodged) {
      return 'Lodged';
    }
    if (sh.isConditionallyApproved) {
      return 'Conditionally approved';
    }
    if (sh.isApproved) {
      return 'Approved';
    }
    if (sh.isSettled) {
      return 'Settled';
    }
    if (sh.isWon) {
      return 'Won';
    }
    if (sh.isWithDrawn) {
      return 'Withdrawn';
    }
    if (sh.isDeclined) {
      return 'Declined';
    }
    if (sh.isLost) {
      return 'Lost';
    }
    if (sh.isActive) {
      return 'Active';
    }
    return 'Unknown';
  };

  const mergeActivity = () => {
    const activityItem = ({
      title,
      note,
      id,
      idOwner,
      timeStamp,
      timeStampSet,
      isStage,
      isStatus,
      isIntegration
    }) => ({
      title,
      note,
      id,
      owner: $scope.getAccount(idOwner),
      time: dateTimeService.getFormattedDateTime(timeStamp),
      timeStamp,
      timeSet: dateTimeService.getFormattedDate(timeStampSet),
      timeStampSet,
      isStage: isStage === true,
      isStatus: isStatus === true,
      isIntegration: isIntegration === true
    });

    $scope.Model.activityItems = _.sortBy(
      []
        .concat(
          activityItem({
            title: 'Deal created',
            note: 'Deal has been created',
            idOwner: $scope.Model.currentTicket.idOwner,
            timeStamp: $scope.Model.currentTicket.timeStamp,
            isStatus: true
          })
        )
        .concat(
          _.map($scope.Model.currentTicket.stageHistory, (sh) =>
            activityItem({
              title: 'Stage change',
              note: `Deal has entered <strong>'${
                _.find($scope.Model.currentWorkflow.stages, (s) => s.id === sh.idStage)?.name ||
                'REMOVED'
              }'</strong> stage`,
              id: sh.id,
              idOwner: sh.idOwner,
              timeStamp: sh.timeStamp,
              isStage: true
            })
          )
        )
        .concat(
          _.map($scope.Model.currentTicket.statusHistory, (sh) =>
            activityItem({
              title: 'Status change',
              note: `Deal has changed status to '<strong>${getStatusChangeTitle(sh)}</strong>'${
                sh.timeStampSet
                  ? ` at <strong>${dateTimeService.getFormattedDate(sh.timeStampSet)}</strong>`
                  : ''
              }${
                sh.note
                  ? `, with note: <p><blockquote class="note">${sh.note}</blockquote></p>`
                  : ', without note'
              }`,
              id: sh.id,
              idOwner: sh.idOwner,
              timeStamp: sh.timeStamp,
              timeStampSet: sh.timeStampSet,
              isStatus: true
            })
          )
        )
        .concat(
          _.map($scope.Model.currentTicket.integrationHistory, (sh) =>
            activityItem({
              title: 'Integration change',
              note: `Deal had '<strong>${sh.name.capitalizeFirstLetter()}</strong>' integration activated`,
              id: sh.id,
              idOwner: sh.idOwner,
              timeStamp: sh.timeStamp,
              isIntegration: true
            })
          )
        ),
      'timeStamp'
    ).reverse();
  };

  const loadCommissions = () => {
    const deferred = $q.defer();
    commissionsService.getAvailable({ isActive: true }).then((data) => {
      if (data.length) {
        const commissionBlank = Commission.blank();
        commissionBlank.name = 'Select one';
        data.unshift(commissionBlank);
        $scope.Model.availableCommissions = data;
      }
      deferred.resolve(data);
    });
    return deferred.promise;
  };

  const allContactsIds = () =>
    _.uniq(
      _.compact(
        _.union($scope.Model.currentTicket.idClients, $scope.Model.currentTicket.idContacts)
      )
    );

  const initialize = () => {
    loadLendersPerCountry();
    loadMessages();
    loadChecklists();
    loadLabels();
    loadJobs();
    loadJobTypes();
    loadCommissions();
    loadWorkflow().then(() => {
      loadTicket().then(() => {
        webpage.pageTitle($scope.Model.currentTicket.getName());
        loadAccount($scope.Model.currentTicket.idOwner).then(() => {
          dateTimeService.getSet(
            $scope,
            $scope.Model.currentTicket,
            'values.onceOffDueDate',
            'getSetOnceOffDueDate'
          );
          dateTimeService.getSet(
            $scope,
            $scope.Model.currentTicket,
            'values.financeDueDate',
            'getSetFinanceDueDate'
          );
          $scope.Model.outboundReferrers = accessService.getOutbound(
            $scope.Model.currentTicket.idWorkflow,
            $scope.Model.currentTicket.idStage
          );
          loadPartners();
          if (
            $scope.Model.currentWorkflow.isAssetFinance() &&
            $scope.Model.currentTicket?.idAssetFinance
          ) {
            loadAssetFinance($scope.Model.currentTicket.idAssetFinance);
            $scope.Model.duplicateDealAndToolName =
              ($rootScope.isGem() || $rootScope.isGnz()) &&
              $scope.Model.currentTicket?.isSettled
                ? ''
                : 'Duplicate deal and asset finance tools';
            $scope.Model.availableComplianceTypes = _.sortBy(DOCUMENT.TYPES, 'value');
          }
          if ($scope.Model.currentWorkflow.isHomeLoan() && $scope.Model.currentTicket?.idLoan) {
            loadHomeLoan($scope.Model.currentTicket.idLoan);
            $scope.Model.duplicateDealAndToolName =
              ($rootScope.isGem() || $rootScope.isGnz()) &&
              $scope.Model.currentTicket?.isSettled
                ? ''
                : 'Duplicate deal and home loan tools';
          }
          if (
            $scope.Model.currentWorkflow.isRiskInsurance() &&
            $scope.Model.currentTicket?.idRiskInsurance
          ) {
            $scope.Model.duplicateDealAndToolName =
              ($rootScope.isGem() || $rootScope.isGnz()) &&
              $scope.Model.currentTicket?.isSettled
                ? ''
                : 'Duplicate deal and risk insurance tools';
          }
          const allContacts = allContactsIds();
          if (allContacts.length) {
            loadContacts(allContacts);
          }
          $scope.Model.currentTicketEmail = emailService.getTicketEmail(
            $scope.Model.currentTicket.uuid
          );

          loadNotes().then(() => {
            const idAccounts = $scope.collectIdAccounts();
            loadAccounts(idAccounts).then(() => {
              mergeActivity();
              loadLenders($scope.Model.currentTicketOwner).then(() => {
                $scope.isLenderExistingInTicketOwnersLenderAccreditations();
              });
              loadAttachments();
              let ticketAttachmentsIdOwnerPartner = [];
              let notesIdOwnerPartner = [];
              if ($scope.Model.currentTicket.attachments.length) {
                ticketAttachmentsIdOwnerPartner = _.uniq(
                  _.compact(
                    _.union(
                      _.map(
                        _.filter(
                          $scope.Model.currentTicket.attachments,
                          (attachment) =>
                            attachment.idOwnerPartner && attachment.idOwnerPartner !== ''
                        ),
                        'idOwnerPartner'
                      )
                    )
                  )
                );
              }
              if ($scope.Model.availableNotes.length) {
                notesIdOwnerPartner = _.uniq(
                  _.compact(
                    _.union(
                      _.map(
                        _.filter(
                          $scope.Model.availableNotes,
                          (note) => note.idOwnerPartner && note.idOwnerPartner !== ''
                        ),
                        'idOwnerPartner'
                      )
                    )
                  )
                );
              }
              const idPartners = _.uniq(
                _.compact(_.union(ticketAttachmentsIdOwnerPartner, notesIdOwnerPartner))
              );
              if (idPartners.length) {
                loadOtherPartners(idPartners);
              }
            });
          });
          loadWorkflows();
          $scope.Model.isReady = true;
        });
      });
    });
  };

  initialize();

  /*
   * Ticket view ~ Helpers
   * --------------------------------------------------------------------------------
   */
  $scope.hasScrollBar = () => {
    if ($scope.Model.isSidebarMinimized) {
      return { 'margin-left': '3.4em' };
    }
    const eHeight = angular.element(document.querySelector(`form-content`));
    return eHeight[0].scrollHeight > window.innerHeight - 112
      ? { 'margin-left': '20.1%' }
      : { 'margin-left': '20%' };
  };

  $scope.canMakeCall = () =>
    !!(
      $rootScope.CurrentOrganization.canUsePhone() &&
      $rootScope.CurrentOrganization.hasCommsPhonesInStock() &&
      $rootScope.CurrentOrganization.getPhonesForOwner($rootScope.CurrentAccount.id).length
    );

  $scope.canSendSms = () =>
    !!(
      !!$rootScope.CurrentOrganization.canUseSMS() &&
      ($rootScope.CurrentAccount.getPhone() ||
        $scope.getAccount($scope.Model.currentTicket.idOwner).getPhone())
    );

  $scope.copyToClipboard = (data) => {
    clipboard.copyText(data);
    uiService.toast({
      text: {
        p1: data.includes('@') ? 'E-Mail' : 'Phone',
        p2: data.includes('@') ? 'address' : 'number',
        p3: 'copied to clipboard'
      }
    });
  };

  $scope.copyEMailBccToClipboard = () => {
    clipboard.copyText($scope.Model.currentTicketEmail);
    uiService.toast({
      text: {
        p1: 'E-Mail to notes',
        p2: 'address',
        p3: 'copied to clipboard'
      }
    });
  };

  $scope.isDealOwnerBroker = () =>
    authenticationService.isBroker($scope.Model.currentTicket.idOwner);

  $scope.isDealImportedAndNotArchived = () =>
    $scope.Model.currentTicket.isImported
      ? !$scope.Model.currentTicket.isWon &&
        !$scope.Model.currentTicket.isLost &&
        !$scope.Model.currentTicket.isFrozen &&
        $scope.Model.currentTicket.isActive
      : true;

  $scope.setTicketClass = (ticket) =>
    ticketService.setTicketClass(
      ticket,
      $rootScope.CurrentAccount?.userInterface?.showTileFinanceDueDate
    );

  $scope.getTicketStatus = (ticket) =>
    ticketService.getTicketStatus(
      ticket,
      $rootScope.CurrentAccount?.userInterface?.showTileFinanceDueDate
    );

  $scope.setCaretClass = (isView) => ticketService.setCaretClass(isView);

  $scope.getTicketClientType = (idContact) => {
    let type;
    if (
      $scope.Model.currentTicket.ticketClientTypes &&
      $scope.Model.currentTicket.ticketClientTypes.length
    ) {
      const clientType = $scope.Model.currentTicket.ticketClientTypes.find(
        (t) => t.idContact === idContact
      );
      if (clientType) {
        type = $scope.Model.availableContactLabels.find((t) => t.id === clientType.idLabel);
      }
    }
    return type ? type.getName() : 'Client';
  };

  $scope.getTicketContactType = (idContact) => {
    let type;
    if (
      $scope.Model.currentTicket.ticketContactTypes &&
      $scope.Model.currentTicket.ticketContactTypes.length
    ) {
      const contactType = $scope.Model.currentTicket.ticketContactTypes.find(
        (t) => t.idContact === idContact
      );
      if (contactType) {
        type = $scope.Model.availableContactLabels.find((t) => t.id === contactType.idLabel);
      }
    }
    return type ? type.getName() : 'Other';
  };

  $scope.getLabel = (idLabel) => {
    let label;
    if ($scope.Model.availableLabels.length) {
      label = $scope.Model.availableLabels.find((l) => l.id === idLabel);
    }
    return label;
  };

  $scope.getNote = (idNote) => {
    let note;
    if ($scope.Model.availableNotes.length) {
      note = $scope.Model.availableNotes.find((n) => n.id === idNote);
    }
    return note;
  };

  $scope.getAccount = (idAccount) => {
    let account;
    if ($scope.Model.availableAccounts.length) {
      account = $scope.Model.availableAccounts.find((a) => a.id === idAccount);
    }
    return account;
  };

  $scope.getPreferredProduct = () =>
    getPreferredProduct($scope.Model.currentHomeLoan?.reviewProducts || []);

  $scope.collectIdAccounts = () =>
    _.uniq(
      _.compact(
        _.union(
          [$scope.Model.currentTicket.idOwner],
          $scope.Model.currentTicket.idAccountsAsPartners,
          _.map($scope.Model.currentTicket.attachments, 'idOwner'),
          $scope.Model.currentTicket.idTeamMembers,
          $scope.Model.currentWorkflow.idTeamMembers,
          _.map($scope.Model.availableNotes, 'idOwner'),
          _.map($scope.Model.currentTicket.stageHistory, 'idOwner'),
          _.map($scope.Model.currentTicket.statusHistory, 'idOwner')
        )
      )
    );

  $scope.hasLenderAccreditations = () => {
    if (
      ($scope.Model.currentWorkflow.isAssetFinance() &&
        $scope.Model.currentTicket.idAssetFinance &&
        $scope.Model.currentTicket.idAssetFinance !== '') ||
      ($scope.Model.currentWorkflow.isHomeLoan() &&
        $scope.Model.currentTicket.idLoan &&
        $scope.Model.currentTicket.idLoan !== '')
    ) {
      return (account) => {
        let output = [];
        if (
          account &&
          account.lenderAccreditations &&
          account.lenderAccreditations.length &&
          authenticationService.isBroker(account.id)
        ) {
          const idLenders = _.compact(account.lenderAccreditations.map((l) => l.idLender));
          const idAllLenders = _.compact(_.map($scope.Model.allLenders, 'id'));
          output = _.intersection(idLenders, idAllLenders);
        }
        return output.length > 0;
      };
    }
    if (
      ($scope.Model.currentWorkflow.isAssetFinance() &&
        (!$scope.Model.currentTicket.idAssetFinance ||
          $scope.Model.currentTicket.idAssetFinance === '')) ||
      ($scope.Model.currentWorkflow.isHomeLoan() &&
        (!$scope.Model.currentTicket.idLoan || $scope.Model.currentTicket.idLoan === ''))
    ) {
      return (account) => {
        let output = [];
        if (account && account.lenderAccreditations && account.lenderAccreditations.length) {
          if (account && account.lenderAccreditations && account.lenderAccreditations.length) {
            const idLenders = _.compact(account.lenderAccreditations.map((l) => l.idLender));
            const idAllLenders = _.compact(_.map($scope.Model.allLenders, 'id'));
            output = _.intersection(idLenders, idAllLenders);
          }
        }
        return output.length === 0;
      };
    }
    return true;
  };

  $scope.getPartner = (idPartner) => {
    let partner;
    if ($scope.Model.ticketPartners.length) {
      partner = $scope.Model.ticketPartners.find((p) => p.id === idPartner);
    }
    return partner;
  };

  $scope.hasHomeLoanTools = () =>
    $scope.isDealOwnerBroker() &&
    $rootScope.hasBrokerToolsEnabled() &&
    $scope.Model.currentTicket.idLoan &&
    $scope.Model.availableLenders.length &&
    $scope.Model.currentWorkflow.isHomeLoan();

  $scope.hasAssetFinanceTools = () =>
    $scope.isDealOwnerBroker() &&
    $rootScope.hasBrokerToolsEnabled() &&
    $scope.Model.availableLenders.length &&
    $scope.Model.currentTicket.idAssetFinance &&
    $scope.Model.currentWorkflow.isAssetFinance() &&
    $rootScope.canSeeAssetFinanceTools();

  $scope.areAllRequiredComplianceFieldsFilled = () => {
    if ($scope.Model.currentWorkflow?.isAssetFinance() && $scope.hasAssetFinanceTools()) {
      return helperService.getStatusOfRequiredComplianceFields({
        products: $scope?.Model?.currentAssetFinance?.compareProducts || [],
        compliance: $scope?.Model?.currentAssetFinance?.compliance || {},
        objectives: $scope?.Model?.currentTicket?.objectives || {},
        commission: $scope?.Model?.currentAssetFinance?.commission || {},
        isCommercial: $scope?.Model?.currentAssetFinance?.isCommercial || false,
        hasAssetFinanceTools: $scope.hasAssetFinanceTools(),
        isDocument: true
      });
    }
    if ($scope.Model.currentWorkflow?.isHomeLoan() && $scope.hasHomeLoanTools()) {
      const preferredProduct = getPreferredProduct(
        $scope.Model.currentHomeLoan?.compareProducts || []
      );
      return helperService.getStatusOfRequiredComplianceFields({
        products: $scope?.Model?.currentHomeLoan?.reviewProducts || [],
        compliance: $scope?.Model?.currentHomeLoan?.compliance || {},
        objectives: $scope?.Model?.currentTicket?.objectives || {},
        commission: $scope?.Model?.currentHomeLoan?.commission || {},
        hasHomeLoanTools: $scope.hasHomeLoanTools(),
        idPreferredLender: preferredProduct?.idLender || '',
        isDocument: true
      });
    }
    return true;
  };

  $scope.haveAnyClientsAccessToClientPortal = () =>
    _.some($scope.Model.ticketClients, (c) => c.hasAccessToClientPortal);

  $scope.getIdLabel = (idLabel) =>
    $scope.Model.availableContactLabels.find((l) => l.id === idLabel).id;

  $scope.getCumulativeTimeInStage = (idStage, humanize) => {
    let output = '';
    if (
      $scope.Model.currentTicket.stageHistory &&
      $scope.Model.currentTicket.stageHistory.length
    ) {
      let duration = 0;
      for (let i = 0; i < $scope.Model.currentTicket.stageHistory.length; i += 1) {
        if ($scope.Model.currentTicket.stageHistory[i].idStage === idStage) {
          if (i < $scope.Model.currentTicket.stageHistory.length - 1) {
            duration += moment
              .utc($scope.Model.currentTicket.stageHistory[i + 1].timeStamp, 'X')
              .diff(moment.utc($scope.Model.currentTicket.stageHistory[i].timeStamp, 'X'));
          } else {
            duration += moment
              .utc()
              .diff(moment.utc($scope.Model.currentTicket.stageHistory[i].timeStamp, 'X'));
          }
        }
      }
      if (duration > 0) {
        output = humanize ? moment.duration(duration).humanize() : moment.duration(duration);
      } else {
        output = humanize ? 'no time' : null;
      }
    }
    return output;
  };

  $scope.getIdLabelByClient = (idContact) => {
    let type;
    if (
      $scope.Model.currentTicket.ticketClientTypes &&
      $scope.Model.currentTicket.ticketClientTypes.length
    ) {
      type = $scope.Model.currentTicket.ticketContactTypes.find(
        (t) => t.idContact === idContact
      );
    }
    return type ? type.idLabel : $scope.Model.idLabelsOfClient[0];
  };

  $scope.getIdLabelByContact = (idContact) => {
    let type;
    if (
      $scope.Model.currentTicket.ticketContactTypes &&
      $scope.Model.currentTicket.ticketContactTypes.length
    ) {
      type = $scope.Model.currentTicket.ticketContactTypes.find(
        (t) => t.idContact === idContact
      );
    }
    return type ? type.idLabel : $scope.Model.availableContactLabels[0].id;
  };

  $scope.getLender = () => {
    let lender;
    if ($scope.Model.currentWorkflow?.isHomeLoan()) {
      const preferredProduct = getPreferredProduct(
        $scope.Model.currentHomeLoan?.reviewProducts || []
      );
      if (preferredProduct) {
        lender = _.find(
          $scope.Model.availableLenders,
          (l) => l?.id === preferredProduct?.idLender
        );
      } else {
        const homeLoanLenderAbbr =
          $scope?.Model?.currentTicket?.loan?.details?.lender.toUpperCase();
        if (homeLoanLenderAbbr && homeLoanLenderAbbr !== 'OTHER') {
          lender = _.find($scope.Model.allLenders, (l) => l.abbr === homeLoanLenderAbbr);
        } else {
          lender = $scope?.Model?.currentTicket?.loan?.details?.lenderOtherName;
        }
      }
    } else if ($scope.Model.currentWorkflow?.isAssetFinance()) {
      const preferredProduct = getPreferredProduct(
        $scope.Model.currentAssetFinance?.compareProducts || []
      );
      lender = _.find(
        $scope.Model.availableLenders || [],
        (l) => l.id === preferredProduct?.selectedProduct?.lender[0]?.id
      );
    } else if ($scope.Model.currentWorkflow.isCommercialLoan()) {
      const lenderAbbr =
        $scope.Model.currentTicket.commercialLoan &&
        $scope.Model.currentTicket.commercialLoan.details &&
        $scope.Model.currentTicket.commercialLoan.details.lender &&
        $scope.Model.currentTicket.commercialLoan.details.lender.toUpperCase();

      if (lenderAbbr) {
        lender = _.find($scope.Model.allLenders, (l) => l.abbr === lenderAbbr);
      }
    } else if ($scope.Model.currentWorkflow.isPersonalLoan()) {
      const lenderAbbr =
        $scope.Model.currentTicket.personalLoan &&
        $scope.Model.currentTicket.personalLoan.details &&
        $scope.Model.currentTicket.personalLoan.details.lender &&
        $scope.Model.currentTicket.personalLoan.details.lender.toUpperCase();

      if (lenderAbbr) {
        lender = _.find($scope.Model.allLenders, (l) => l.abbr === lenderAbbr);
      }
    }
    return lender;
  };

  $scope.fullBrokerId = (lenderAccreditation) =>
    `${`${lenderAccreditation?.brokerIdPrimary || ''}${
      lenderAccreditation?.brokerIdSecondary
        ? ` ${lenderAccreditation.brokerIdPrimary && ' | '} ${
            lenderAccreditation.brokerIdSecondary
          }`
        : ''
    }`}`;

  $scope.getBrokerId = () => {
    if ($scope.Model.isAccountReady) {
      let idLender;

      if ($scope.Model.currentWorkflow.isHomeLoan()) {
        if ($scope.hasHomeLoanTools() && $scope.isDealImportedAndNotArchived()) {
          const preferredProduct = getPreferredProduct(
            $scope.Model.currentHomeLoan?.reviewProducts || []
          );
          idLender = preferredProduct?.idLender || '';
        }
        if (
          !$scope.hasHomeLoanTools() ||
          ($scope.hasHomeLoanTools() && !$scope.isDealImportedAndNotArchived())
        ) {
          const lender = $scope.Model.allLenders.find(
            (l) =>
              l?.abbr?.toUpperCase() ===
              $scope.Model.currentTicket?.loan?.details?.lender?.toUpperCase()
          );
          idLender = lender?.id || '';
        }
      }
      if ($scope.Model.currentWorkflow.isAssetFinance()) {
        if ($scope.hasAssetFinanceTools()) {
          const preferredProduct = getPreferredProduct(
            $scope.Model.currentAssetFinance?.compareProducts || []
          );
          idLender = preferredProduct?.selectedProduct?.lender[0]?.id || '';
        }
        if (!$scope.hasAssetFinanceTools()) {
          const lender = _.find(
            $scope.Model.allLenders,
            (l) =>
              l?.abbr?.toUpperCase() ===
              $scope.Model.currentTicket?.assetFinance?.asset?.lender?.toUpperCase()
          );
          idLender = lender?.id || '';
        }
      }
      if ($scope.Model.currentWorkflow.isCommercialLoan()) {
        const lender = $scope.Model.allLenders.find(
          (l) =>
            l?.abbr?.toUpperCase() ===
            $scope?.Model?.currentTicket?.commercialLoan?.details?.lender?.toUpperCase()
        );
        idLender = lender?.id || '';
      }
      if ($scope.Model.currentWorkflow.isPersonalLoan()) {
        const lender = $scope.Model.allLenders.find(
          (l) =>
            l?.abbr?.toUpperCase() ===
            $scope?.Model?.currentTicket?.personalLoan?.details?.lender?.toUpperCase()
        );
        idLender = lender?.id || '';
      }

      const lenderAccreditation = _.find(
        $scope.Model.currentTicketOwner?.lenderAccreditations || [],
        (l) => l?.idLender === idLender
      );

      return lenderAccreditation?.brokerIdPrimary !== '' ||
        lenderAccreditation?.brokerIdSecondary !== ''
        ? $scope.fullBrokerId(lenderAccreditation)
        : '-';
    }
    return null;
  };

  $scope.getProductType = () => {
    let productType = '-';
    if ($scope.Model.currentWorkflow?.isAssetFinance() && $scope.hasAssetFinanceTools()) {
      const pType = _.find(
        assetFinanceService.getAvailableProductTypes({
          isCommercial: $scope.Model.currentAssetFinance?.isCommercial || false
        }),
        (p) => p?.id === $scope.Model.currentAssetFinance?.financeProposal?.productType
      );
      productType = pType?.value || '-';
    }
    if ($scope.Model.currentWorkflow?.isInsurance()) {
      productType = $scope.Model.currentTicket?.insurance?.productType || '-';
    }
    return productType;
  };

  $scope.isClient = (client) => {
    if (
      $scope.Model.currentTicket.ticketClientTypes &&
      $scope.Model.currentTicket.ticketClientTypes.length
    ) {
      const ticketClientType = $scope.Model.currentTicket.ticketClientTypes.find(
        (c) => c.idContact === client.id
      );
      if (ticketClientType) {
        const clientType = $scope.Model.availableContactLabels.find(
          (l) => l.name.toLowerCase() === 'client'
        );
        return clientType && ticketClientType.idLabel === clientType.id;
      }
      return true;
    }
    return true;
  };

  $scope.getLenderDocument = (idLender, lenderAbbr) => {
    let doc;
    if ($scope.Model.currentLendersDocuments.length) {
      doc = _.find($scope.Model.currentLendersDocuments, (d) => {
        if (idLender) {
          return d.lender[0]
            ? d.lender[0].id === idLender && d.type.indexOf('LOGO') > -1
            : undefined;
        }
        return d.lender[0]
          ? d.lender[0].id === lenderAbbr && d.type.indexOf('LOGO') > -1
          : undefined;
      });
    }
    return doc ? doc.url : '';
  };

  $scope.getCustomField = (customField) => fieldService.getCustomField(customField);

  $scope.getMaximumBorrowing = () => {
    const deferred = $q.defer();
    $scope.Model.maximumBorrowing = financeService.prepareEstimateData({
      lenders: $scope.Model.availableLenders,
      contacts: $scope.Model.availablePersonOnlyClients,
      income: $scope.Model.currentTicket?.income || [],
      expenses: _.filter(
        $scope.Model.currentTicket?.expenses || [],
        (e) => e?.id && _.isUuid(e?.id)
      ),
      assets: $scope.Model.currentTicket?.assets || [],
      liabilities: $scope.Model.currentTicket?.liabilities || [],
      ticketClientTypes: $scope.Model.currentTicket?.ticketClientTypes || [],
      homeLoanSecurities: $scope.Model.currentHomeLoan?.securityDetails?.securitySplits || [],
      fundingWorksheets: $scope.Model?.currentHomeLoan?.fundingWorksheets || {},
      workflow: $scope.Model.currentWorkflow || {},
      owner: $scope.Model.currentTicketOwner || {},
      isDealOwnerBroker: $scope.isDealOwnerBroker(),
      useGeneric: true
    });

    financesService
      .homeLoanMaximumBorrowing({ idTicket: $scope.Model.currentTicket?.id })
      .then((res) => {
        if (res?.status && res?.lenders?.length) {
          const len = $scope.Model.availableLenders?.length || 0;
          for (let l = 0; l < len; l += 1) {
            const lender = $scope.Model.availableLenders[l];
            const estimateData = _.find(res?.lenders || [], (i) => i?.id === lender?.id);
            if (estimateData && estimateData?.homeLoanEstimate?.length) {
              lender.maxBorrow =
                estimateData?.homeLoanEstimate[0]?.maximumBorrowing < 0
                  ? 0
                  : estimateData.homeLoanEstimate[0].maximumBorrowing;
              lender.mbp = estimateData.mbp;
            }
          }
          deferred.resolve();
        }
      });
    return deferred.promise;
  };

  /*
   * Ticket view ~ Edit Contact
   * --------------------------------------------------------------------------------
   */
  $scope.goToAssetFinanceQuickQuote = () => {
    const type = 'assetFinanceQuickQuote';
    $state.transitionTo(type, { id: $stateParams.id, dd: $stateParams.dd });
  };

  $scope.goToAssetFinanceTools = () => {
    const type =
      $scope.hasAssetFinanceTools() &&
      $scope.isLenderExistingInTicketOwnersLenderAccreditations()
        ? 'assetFinance'
        : 'factFind';
    $state.transitionTo(type, { id: $stateParams.id, dd: $stateParams.dd });
  };

  $scope.gotToHomeLoanTools = () => {
    const type =
      $scope.hasHomeLoanTools() && $scope.isLenderExistingInTicketOwnersLenderAccreditations()
        ? 'homeLoan'
        : 'factFind';
    $state.transitionTo(type, { id: $stateParams.id, dd: $stateParams.dd });
  };

  $scope.goToFeesAndCharges = () => {
    let tool;
    if ($scope.hasAssetFinanceTools()) {
      tool = 'asset-finance';
    }
    if ($scope.hasHomeLoanTools()) {
      tool = 'home-loan';
    }
    let type = 'factFind';
    if (
      ($scope.hasAssetFinanceTools() || $scope.hasHomeLoanTools()) &&
      $scope.isLenderExistingInTicketOwnersLenderAccreditations() &&
      !$scope.Model.currentTicket.isSettled
    ) {
      type = 'feesAndCharges';
    }
    $state.transitionTo(type, { tool, id: $stateParams.id, dd: $stateParams.dd });
  };

  $scope.goToHomeLoanSwitchTools = () => {
    const type =
      $scope.hasHomeLoanTools() &&
      $scope.isLenderExistingInTicketOwnersLenderAccreditations() &&
      $scope.Model.currentTicket.isSettled
        ? 'homeLoanSwitch'
        : 'factFind';
    $state.transitionTo(type, { id: $stateParams.id, dd: $stateParams.dd });
  };

  $scope.goToRiskInsuranceTools = () => {
    const type = $rootScope.canSeeRiskInsuranceTools() ? 'riskInsurance' : 'factFind';
    $state.transitionTo(type, { id: $stateParams.id, dd: $stateParams.dd });
  };

  $scope.gotToFactFind = () => {
    $state.transitionTo('factFind', { id: $stateParams.id, dd: $stateParams.dd });
  };

  $scope.goToContactView = (contact) =>
    $state.transitionTo('contactView', {
      type: contact.isCompany ? 'company' : 'person',
      id: contact.id
    });

  /*
   * Ticket view ~ Switch UI Section
   * --------------------------------------------------------------------------------
   */
  $scope.toggleSidebar = () => {
    $scope.Model.isSidebarMinimized = !$scope.Model.isSidebarMinimized;
    if ($scope.Model.isSidebarMinimized) {
      cookies.set('stSidebar', btoa('sidebar is minimized'), { path: '/' });
    } else {
      cookies.remove('stSidebar', { path: '/' });
    }
  };

  $scope.onValidated = (validationErrors) => {
    $scope.Model.validation.errors = validationErrors;
    $scope.Model.validation.needsAndObjectivesErrors = _.filter(
      validationErrors,
      (v) => v?.message?.toLowerCase()?.indexOf('needs and objectives -') > -1
    );
    $scope.Model.validation.productRequirementsErrors = _.filter(
      validationErrors,
      (v) => v?.message?.toLowerCase()?.indexOf('product requirements -') > -1
    );
    $scope.Model.validation.bidErrors = $scope.Model.currentWorkflow.isAssetFinance()
      ? $scope.Model.validation?.needsAndObjectivesErrors
      : $scope.Model.validation?.needsAndObjectivesErrors.concat(
          $scope.Model.validation?.productRequirementsErrors
        );
  };

  $scope.validate = () => {
    if (
      $scope.Model.currentWorkflow.isAssetFinance() &&
      !$scope.Model.currentAssetFinance?.isCommercial &&
      $scope.Model.organizationCountry?.cca2 !== 'NZ'
    ) {
      const errors = validationService.validate({
        type: 'af',
        ticket: $scope.Model.currentTicket
      });
      $scope.Model.validation.errors = errors?.validationErrors || [];
      $scope.onValidated($scope.Model.validation.errors);
    }

    if (
      $scope.Model.currentWorkflow.isHomeLoan() &&
      $scope.Model.organizationCountry?.cca2 !== 'NZ'
    ) {
      const errors = validationService.validate({
        type: 'hl',
        ticket: $scope.Model.currentTicket
      });
      $scope.Model.validation.errors = errors?.validationErrors || [];
      $scope.onValidated($scope.Model.validation.errors);
    }
  };

  $scope.toggleTab = (tab, activeTab) => {
    if (tab === 3) {
      $scope.validate();
    }
    $scope.Model.activeTab = activeTab === tab ? undefined : tab;
  };

  $scope.cancelledAdding = () => {
    $scope.Model.activeTab = undefined;
  };

  $scope.toggleTabList = (tab) => {
    $scope.Model.activeTabList = tab;
  };

  /*
   * Ticket view ~ Hide Status Bar and Tag
   * --------------------------------------------------------------------------------
   */
  $scope.Model.previousState =
    cookies.get(NAVIGATION.COOKIE.PREVIOUS_STATE) &&
    cookies.get(NAVIGATION.COOKIE.PREVIOUS_STATE) !== undefined
      ? JSON.parse(cookies.get(NAVIGATION.COOKIE.PREVIOUS_STATE))
      : '';

  /*
   * Ticket view ~ Refer
   * --------------------------------------------------------------------------------
   */
  $scope.referTicket = ($event, a) => {
    function ticketReferController(access, ticket) {
      this.access = access;
      this.ticket = ticket;
      this.confirm = () => {
        $mdDialog.hide(true);
      };
      this.cancel = () => {
        $mdDialog.cancel(false);
      };
    }
    $mdDialog
      .show({
        targetEvent: $event,
        locals: {
          access: a,
          ticket: $scope.Model.currentTicket
        },
        template: templateTicketRefer,
        controllerAs: '$ctrl',
        controller: ticketReferController
      })
      .then((result) => {
        if (result === true) {
          accessService.refer({
            idAccess: a.id,
            idTicket: $scope.Model.currentTicket.id
          });
        }
      });
  };

  /*
   * Ticket view ~ Add contact to ticket
   * --------------------------------------------------------------------------------
   */
  $scope.ticketContactAdd = ($event, isCompany) => {
    const contact = angular.copy({
      id: '',
      isCompany,
      name: '',
      familyName: '',
      phoneCode: !_.isEmpty($rootScope.CurrentOrganization?.organization?.location)
        ? $rootScope.CurrentOrganization?.organization?.location?.callingCode[0] || ''
        : '',
      phone: '',
      email: '',
      type: $scope.Model.idLabelsOfClient[0]
    });
    $scope.Model.ticketAvailableContacts.push(contact);
    eventService.ticketViewContactAdd({
      event: $event,
      contact,
      contacts: $scope.Model.ticketAvailableContacts,
      contactLabels: $scope.Model.availableContactLabels,
      workflow: $scope.Model.currentWorkflow
    });
  };

  $scope.ticketContactAdded = (contact) => {
    contactsService.clearCache();
    if (contact?.id) {
      if (
        _.indexOf($scope.Model.idLabelsOfClient || [], contact?.type) > -1 &&
        _.indexOf($scope.Model.currentTicket?.idClients || [], contact?.id) === -1
      ) {
        $scope.Model.currentTicket.idClients.push(contact?.id);
        $scope.Model.currentTicket.ticketClientTypes.push(
          TicketContactType.build({
            idContact: contact.id,
            idLabel: contact.type
          })
        );
        if (
          $scope.Model.currentTicket?.ticketContactTypes?.length &&
          $scope.Model.currentTicket?.ticketContactTypes instanceof Array
        ) {
          const idx = _.findIndex(
            $scope.Model.currentTicket.ticketContactTypes || [],
            (c) => c?.idContact === contact?.id
          );
          if (idx > -1) {
            $scope.Model.currentTicket.ticketContactTypes.splice(idx, 1);
          }
        }
        const cIdx = $scope.Model.currentTicket.idContacts.indexOf(contact?.id);
        if (cIdx > -1) {
          $scope.Model.currentTicket.idContacts.splice(cIdx, 1);
        }

        $scope.Model.currentTicket.assets = $scope.addOwnership(
          $scope.Model.currentTicket?.assets || [],
          contact.id
        );
        $scope.Model.currentTicket.liabilities = $scope.addOwnership(
          $scope.Model.currentTicket?.liabilities || [],
          contact.id
        );
        if ($scope.hasHomeLoanTools()) {
          $scope.Model.currentHomeLoan.securityDetails.securitySplits = $scope.addOwnership(
            $scope.Model.currentHomeLoan?.securityDetails?.securitySplits || [],
            contact.id
          );
          $scope.Model.currentHomeLoan.securityDetails.otherMortgages = $scope.addOwnership(
            $scope.Model.currentHomeLoan?.securityDetails?.otherMortgages || [],
            contact.id
          );
          for (let r = 0; r < $scope.Model.currentHomeLoan.reviewProducts.length; r += 1) {
            $scope.Model.currentHomeLoan.reviewProducts[r].productSplits = $scope.addOwnership(
              $scope.Model.currentHomeLoan?.reviewProducts[r]?.productSplits || [],
              contact.id
            );
          }
        }
      } else if (
        _.indexOf($scope.Model.idLabelsOfClient || [], contact?.type) === -1 &&
        $scope.Model.currentTicket.idContacts.indexOf(contact?.id) === -1
      ) {
        $scope.Model.currentTicket.idContacts.push(contact.id);
        $scope.Model.currentTicket.ticketContactTypes.push(
          TicketContactType.build({
            idContact: contact.id,
            idLabel: contact.type
          })
        );
        if (
          $scope.Model.currentTicket?.ticketClientTypes?.length &&
          $scope.Model.currentTicket?.ticketClientTypes instanceof Array
        ) {
          const idx = _.findIndex(
            $scope.Model.currentTicket?.ticketClientTypes || [],
            (c) => c?.idContact === contact.id
          );
          if (idx > -1) {
            $scope.Model.currentTicket.ticketClientTypes.splice(idx, 1);
          }
        }
        const cIdx = $scope.Model.currentTicket.idClients.indexOf(contact.id);
        if (cIdx > -1) {
          $scope.Model.currentTicket.idClients.splice(cIdx, 1);
        }
      }

      const idContacts = $scope.Model.currentTicket.idClients.concat(
        $scope.Model.currentTicket.idContacts
      );
      if (idContacts.length) {
        loadContacts(idContacts).then(() => {
          if (
            _.indexOf($scope.Model.idLabelsOfClient || [], contact?.type) > -1 &&
            !contact?.isCompany
          ) {
            const currentContact = _.find(
              $scope.Model.availablePersonOnlyClients || [],
              (c) => c?.id === contact?.id
            );
            if (currentContact?.person?.employments?.length) {
              const eLen = currentContact?.person?.employments?.length || 0;
              for (let e = 0; e < eLen; e += 1) {
                const employment = currentContact.person.employments[e];
                if (employment?.isCurrent && employment?.type) {
                  const incomeType =
                    employment?.type?.name === ContactEmploymentType.salaried_employee.name
                      ? $scope.Model.availableIncomeTypes[0]
                      : $scope.Model.availableIncomeTypes[1];
                  $scope.incomeAdd(incomeType, contact.id, employment?.id);
                }
              }
            }
          } else if (
            _.indexOf($scope.Model.idLabelsOfClient || [], contact?.type) > -1 &&
            contact?.isCompany
          ) {
            $scope.incomeAdd($scope.Model.availableIncomeTypes[1], contact.id, '');
          }
          $timeout(() => {
            $scope.saveTicketAfterAddedContact();
          });
        });
      }
    } else {
      $scope.saveTicketAfterAddedContact();
    }
  };

  $scope.addOwnership = (data, idContact) => {
    const ticketData = data;
    const percent = 0;
    for (let i = 0; i < ticketData?.length; i += 1) {
      const isOwnershipExist = _.some(
        ticketData[i]?.ownership,
        (item) => item?.idContact === idContact
      );
      const isOwnershipEmptyContact = _.some(
        ticketData[i]?.ownership,
        (item) => item?.idContact === ''
      );
      if (isOwnershipExist || isOwnershipEmptyContact) {
        for (let j = 0; j < ticketData[i]?.ownership?.length; j += 1) {
          if (isOwnershipEmptyContact) {
            ticketData[i].ownership[j].idContact = idContact;
          }
          ticketData[i].ownership[j].percent = percent;
        }
      } else if (!isOwnershipExist && !isOwnershipEmptyContact) {
        ticketData[i].ownership.push(Ownership.blank(idContact, percent));
      }
    }
    return ticketData;
  };

  $scope.incomeAdd = (incomeType, idContact, idEmployer) => {
    let existIncome;
    if ($scope.Model.currentTicket?.income?.length) {
      existIncome = _.find(
        $scope.Model.currentTicket?.income || [],
        (i) =>
          i?.incomeType?.id === incomeType?.id &&
          i?.idContact === idContact &&
          i?.idEmployer === idEmployer
      );
    }
    if (!existIncome) {
      $scope.Model.currentTicket.income = incomeService.incomeAdd(
        $scope.Model.currentTicket?.income || [],
        incomeType,
        idContact,
        idEmployer
      );
    }
  };

  $scope.saveTicketAfterAddedContact = $mdUtil.debounce(() => {
    $scope.saveTicket({
      idClients: $scope.Model.currentTicket.idClients,
      idContacts: $scope.Model.currentTicket.idContacts,
      ticketContactTypes: $scope.Model.currentTicket.ticketContactTypes,
      ticketClientTypes: $scope.Model.currentTicket.ticketClientTypes,
      income: $scope.Model.currentTicket.income,
      assets: $scope.Model.currentTicket.assets,
      liabilities: $scope.Model.currentTicket.liabilities
    });
    if ($scope.hasHomeLoanTools()) {
      $scope.saveHomeLoan({
        securityDetails: {
          securitySplits: $scope.Model.currentHomeLoan.securityDetails.securitySplits,
          otherMortgages: $scope.Model.currentHomeLoan.securityDetails.otherMortgages
        }
      });
    }
  }, 1500);

  /*
   * Ticket view ~ Add partner to ticket
   * --------------------------------------------------------------------------------
   */
  $scope.ticketPartnerAdd = ($event, partner) => {
    $event.stopPropagation();
    if (
      $scope.Model.currentTicket.idPartners &&
      $scope.Model.currentTicket.idPartners.indexOf(partner.id) === -1
    ) {
      $scope.Model.currentTicket.idPartners.push(partner.id);
      $scope.Model.ticketPartners.push(partner);
      $scope.saveTicket({ idPartners: $scope.Model.currentTicket.idPartners });
    } else {
      uiService.toast({
        text: {
          p1: 'Referrer',
          p2: partner.getName(),
          p3: 'has been already added'
        }
      });
    }
  };

  /*
   * Ticket view ~ Change ticket owner
   * --------------------------------------------------------------------------------
   */
  $scope.ticketChangeOwner = ($event, idAccount) => {
    $event.stopPropagation();
    if (!$scope.Model.currentTicket.isLodged) {
      const ticketOwner = $scope.getAccount(idAccount);
      if (ticketOwner) {
        loadLenders(ticketOwner).then(() => {
          $scope.Model.currentTicket.idOwner = idAccount;
          $scope.isLenderExistingInTicketOwnersLenderAccreditations();
          $scope.saveTicket({ idOwner: idAccount });
        });
      }
    } else {
      uiService.toast({
        text: {
          p1: 'Deal',
          p2: $scope.Model.currentTicket.getName(),
          p3: 'has already been lodged'
        },
        warn: true
      });
    }
  };

  $scope.isLenderExistingInTicketOwnersLenderAccreditations = () => {
    const ticketOwner = $scope.getAccount($scope.Model.currentTicket.idOwner);
    let preferredProduct;
    if (ticketOwner?.lenderAccreditations?.length) {
      if ($scope.hasAssetFinanceTools()) {
        preferredProduct = getPreferredProduct(
          $scope.Model.currentAssetFinance?.compareProducts || []
        );
      }
      if ($scope.hasHomeLoanTools()) {
        preferredProduct = getPreferredProduct(
          $scope.Model.currentHomeLoan?.reviewProducts || []
        );
      }
      if (preferredProduct) {
        let lender;
        if ($rootScope.IsEnterprise) {
          lender = _.find(
            $scope.Model.availableLenders || [],
            (l) =>
              l?.id ===
              (preferredProduct?.selectedProduct?.lender[0]?.id || preferredProduct?.idLender)
          );
        } else {
          lender = _.find(
            ticketOwner?.lenderAccreditations || [],
            (l) =>
              l?.idLender ===
              (preferredProduct?.selectedProduct?.lender[0]?.id || preferredProduct?.idLender)
          );
        }
        return lender !== undefined;
      }
      return true;
    }
    return true;
  };

  $scope.getToolsName = () => {
    let name = 'tools';
    if ($scope.Model.currentWorkflow.isHomeLoan()) {
      name = 'Broker tools';
    }
    if ($scope.Model.currentWorkflow.isAssetFinance()) {
      name = 'Asset finance tools';
    }
    return name;
  };

  /*
   * Ticket view ~ Get preferred product based on workflow
   * --------------------------------------------------------------------------------
   */
  $scope.getPreferredProductHomeLoan = () => $scope.Model.currentTicket?.loan || {};
  $scope.getPreferredProductAssetFinance = () => $scope.Model.currentTicket?.assetFinance || {};
  $scope.getPreferredProductAssetFinanceTools = () =>
    getPreferredProduct($scope.Model.currentAssetFinance?.compareProducts || []);
  $scope.getPreferredProductCommercialLoan = () =>
    $scope.Model.currentTicket?.commercialLoan || {};
  $scope.getPreferredProductPersonalLoan = () => $scope.Model.currentTicket?.personalLoan || {};
  $scope.getLoanProductsForCommission = () => {
    if ($scope.hasHomeLoanTools()) {
      return getPreferredProduct($scope.Model.currentHomeLoan?.compareProducts || []);
    }
    if ($scope.Model.currentWorkflow.isHomeLoan() && !$scope.hasHomeLoanTools()) {
      return $scope.getPreferredProductHomeLoan();
    }
    if ($scope.Model.currentWorkflow.isAssetFinance() && !$scope.hasAssetFinanceTools()) {
      return $scope.getPreferredProductAssetFinance();
    }
    if ($scope.Model.currentWorkflow.isAssetFinance() && $scope.hasAssetFinanceTools()) {
      return $scope.getPreferredProductAssetFinanceTools();
    }
    if ($scope.Model.currentWorkflow.isCommercialLoan()) {
      return $scope.getPreferredProductCommercialLoan();
    }
    if ($scope.Model.currentWorkflow.isPersonalLoan()) {
      return $scope.getPreferredProductPersonalLoan();
    }
    return null;
  };

  /*
   * Ticket view ~ Change ticket status
   * --------------------------------------------------------------------------------
   */
  $scope.ticketStatusChange = ($event, statusToChange) => {
    $event.stopPropagation();
    const statusHistory = TicketStatusHistory.blank();
    const ticketPartners = [];
    const isStatusToChangeSettled = statusToChange === 'settled';
    if (isStatusToChangeSettled) {
      statusHistory.timeStamp = 0;
      if ($scope.Model.currentTicket.idPartners.length) {
        for (let i = 0; i < $scope.Model.currentTicket.idPartners.length; i += 1) {
          ticketPartners.push({
            idPartner: $scope.Model.currentTicket.idPartners[i],
            partnerReferralFee: $scope.Model.currentTicket.partnersReferralFee
              ? $scope.Model.currentTicket.partnersReferralFee[
                  $scope.Model.currentTicket.idPartners[i]
                ]
              : 0
          });
        }
      } else {
        ticketPartners.push({ idPartner: '', partnerReferralFee: '' });
      }
    }

    $mdDialog
      .show({
        targetEvent: $event,
        locals: {
          status: statusToChange,
          ticketOwner: isStatusToChangeSettled
            ? $scope.getAccount($scope.Model.currentTicket.idOwner)
            : null,
          currentLender:
            isStatusToChangeSettled && $scope.Model.currentLender
              ? $scope.Model.currentLender
              : null,
          currentLenderLogo:
            isStatusToChangeSettled && $scope.Model.currentLender
              ? $scope.getLenderDocument($scope.Model.currentLender.id)
              : null,
          currentTicket: $scope.Model.currentTicket,
          loan: $scope.Model.currentHomeLoan,
          currentAssetFinance: $scope.Model.currentAssetFinance,
          preferredProduct: isStatusToChangeSettled
            ? $scope.getLoanProductsForCommission()
            : null,
          partners: isStatusToChangeSettled ? $scope.Model.availablePartners : [],
          idPartners: $scope.Model.currentTicket.idPartners,
          idAccountsAsPartners: $scope.Model.currentTicket.idAccountsAsPartners,
          partnersReferralFee: $scope.Model.currentTicket.partnersReferralFee,
          workflow: $scope.Model.currentWorkflow,
          hasBrokerToolsEnabled:
            $scope.hasHomeLoanTools() &&
            getPreferredProduct($scope.Model.currentHomeLoan?.compareProducts || []) !==
              undefined,
          hasAssetFinanceToolsEnabled:
            $scope.hasAssetFinanceTools() && $scope.Model.currentAssetFinance
        },
        template: templateTicketStatusChange,
        controllerAs: '$ctrl',
        controller(
          status,
          ticketOwner,
          currentLender,
          currentLenderLogo,
          currentTicket,
          loan,
          currentAssetFinance,
          preferredProduct,
          partners,
          idPartners,
          idAccountsAsPartners,
          partnersReferralFee,
          workflow,
          hasBrokerToolsEnabled,
          hasAssetFinanceToolsEnabled
        ) {
          const ctrl = this;
          ctrl.currentOrganization = $rootScope.CurrentOrganization;
          ctrl.canSeeAccountsAsPartnersOption = $rootScope.canSeeAccountsAsPartnersOption();
          ctrl.currentCurrency = $rootScope.CurrentCurrency();
          ctrl.currentDateFormat = $rootScope.CurrentDateFormatPrimary();
          ctrl.currentCurrency = $rootScope.CurrentCurrency();
          ctrl.currentLocale = $rootScope.CurrentLocale();
          ctrl.rootScope = $rootScope;
          ctrl.status = status;
          ctrl.statusHistory = statusHistory;
          ctrl.ticketOwner = ticketOwner;
          ctrl.currentLender = currentLender;
          ctrl.currentLenderLogo = currentLenderLogo;
          ctrl.currentTicket = currentTicket;
          dateTimeService.getSet(
            ctrl,
            ctrl.statusHistory,
            'timeStamp',
            'getSetStatusHistoryDate'
          );
          dateTimeService.getSet(
            ctrl,
            ctrl.currentTicket,
            'submittedTimeStamp',
            'getSetSubmittedTimeStamp'
          );

          ctrl.loan = loan;
          ctrl.currentAssetFinance = currentAssetFinance;
          ctrl.preferredProduct = preferredProduct;
          ctrl.partners = partners;
          ctrl.idPartners = idPartners;
          ctrl.partnersReferralFee = partnersReferralFee;
          ctrl.accountsAsPartners = [];
          ctrl.idAccountsAsPartners = idAccountsAsPartners;
          ctrl.accountsAsPartnersReferralFee = [];
          ctrl.workflow = workflow;
          ctrl.workflowType = ctrl.workflow.type.name;
          ctrl.hasBrokerToolsEnabled = hasBrokerToolsEnabled;
          ctrl.hasAssetFinanceToolsEnabled = hasAssetFinanceToolsEnabled;
          ctrl.ticketPartners = ticketPartners;
          ctrl.ticketAccountsAsPartners = [];
          ctrl.preferredProductReview = _.find(ctrl.loan && ctrl.loan.reviewProducts, {
            isPreferred: true
          });
          ctrl.isAstuteOrg = $rootScope.canSeeNeedsAnalysis();
          ctrl.isLoading = false;
          ctrl.personalLoanPurpose = TicketPersonalLoanPurpose.available();
          ctrl.CurrentOrganization = $rootScope.CurrentOrganization;
          ctrl.hasCommissionsPostingEnabled = $rootScope.hasCommissionsPostingEnabled();
          ctrl.isGnz = $rootScope.isGnz();
          ctrl.jobsToCreate = [];
          ctrl.availableCommissions = $scope.Model.availableCommissions;

          ctrl.commissionUsername =
            status === 'settled' && ctrl.hasCommissionsPostingEnabled
              ? $rootScope.CurrentOrganization.partnersAttributes[ctrl.ticketOwner.id] &&
                $rootScope.CurrentOrganization.partnersAttributes[ctrl.ticketOwner.id]
                  .commissionUsername
              : '';

          ctrl.saveAssetFinanceCommission = $mdUtil.debounce((commission) => {
            if (commission && !_.isEmpty(commission) && ctrl.hasAssetFinanceToolsEnabled) {
              $scope.Model.currentAssetFinance.commission = commission;
              $scope.saveAssetFinance({ commission });
            }
          }, 500);

          ctrl.getLenderName = () => {
            if (ctrl.workflow.isHomeLoan()) {
              if (hasBrokerToolsEnabled) {
                return (ctrl.currentLender && ctrl.currentLender.getName()) || '';
              }
              return ctrl?.currentTicket?.loan?.details?.lender || '';
            }
            if (ctrl.workflow.isAssetFinance() && !ctrl.hasAssetFinanceToolsEnabled) {
              return ctrl?.currentTicket?.assetFinance?.asset?.lender;
            }
            if (ctrl.workflow.isAssetFinance() && ctrl.hasAssetFinanceToolsEnabled) {
              return preferredProduct?.selectedProduct?.lender[0].name;
            }
            if (ctrl.workflow.isCommercialLoan()) {
              return ctrl.currentTicket.commercialLoan.details.lender;
            }
            if (ctrl.workflow.isPersonalLoan()) {
              return ctrl?.currentTicket?.personalLoan?.details?.lender;
            }
            return null;
          };

          if (
            ctrl.workflow.isHomeLoan() &&
            hasBrokerToolsEnabled &&
            ctrl.preferredProduct &&
            ctrl.preferredProductReview
          ) {
            _.forEach(ctrl.preferredProduct.productSplits, (s, idx) => {
              const split = s;
              split.commissions = ctrl.preferredProductReview.productSplits[idx].commissions;
            });
          }

          ctrl.ticketPartnerAdd = () => {
            if (ctrl.ticketPartners[ctrl.ticketPartners.length - 1].idPartner !== '') {
              ctrl.ticketPartners.push({ idPartner: '', partnerReferralFee: '' });
            }
          };

          ctrl.ticketPartnerEdit = (idPartner, idx) => {
            if (ctrl.idPartners.indexOf(idPartner) === -1) {
              if (!ticketPartners.some((partner) => partner.idPartner === idPartner)) {
                ticketPartners.push({
                  idPartner,
                  partnerReferralFee: ctrl.currentTicket.partnersReferralFee[idPartner] || ''
                });
              }

              ctrl.idPartners.push(idPartner);
              ctrl.partnersReferralFee[idPartner] =
                ctrl.currentOrganization.partnersAttributes[idPartner] &&
                ctrl.currentOrganization.partnersAttributes[idPartner].fee
                  ? ctrl.currentOrganization.partnersAttributes[idPartner].fee
                  : '';
              ctrl.ticketPartners[idx].partnerReferralFee = ctrl.currentOrganization
                .partnersAttributes[idPartner]
                ? ctrl.currentOrganization.partnersAttributes[idPartner].fee &&
                  ctrl.currentOrganization.partnersAttributes[idPartner].fee
                : '';
              ctrl.currentTicket.idPartners = ctrl.idPartners;
            } else {
              uiService.toast({
                text: {
                  p1: 'Partner',
                  p3: 'already exist'
                },
                warn: true
              });
            }
          };

          ctrl.ticketAccountAsPartnerAdd = () => {
            if (
              ctrl.ticketAccountsAsPartners[ctrl.ticketAccountsAsPartners.length - 1]
                .idPartner !== ''
            ) {
              ctrl.ticketAccountsAsPartners.push({ idPartner: '', partnerReferralFee: '' });
            }
          };

          ctrl.ticketAccountAsPartnerEdit = (idPartner, idx) => {
            if (ctrl.idAccountsAsPartners.indexOf(idPartner) === -1) {
              if (
                !ctrl.ticketAccountsAsPartners.some(
                  (partner) => partner.idPartner === idPartner
                )
              ) {
                ctrl.ticketAccountsAsPartners.push({
                  idPartner,
                  partnerReferralFee: ''
                });
              }

              ctrl.idAccountsAsPartners.push(idPartner);
              ctrl.accountsAsPartnersReferralFee[idPartner] = '';
              ctrl.ticketAccountsAsPartners[idx].partnerReferralFee = '';
              ctrl.currentTicket.idAccountsAsPartners = ctrl.idAccountsAsPartners;
            } else {
              uiService.toast({
                text: {
                  p1: 'Partner',
                  p3: 'already exist'
                },
                warn: true
              });
            }
          };
          ctrl.getAccountsAsPartners = () => {
            if (ctrl.canSeeAccountsAsPartnersOption) {
              return accountsService
                .getAvailable({ isActive: true, fields: ACCOUNT.FIELDS.LIST })
                .then((result) => {
                  ctrl.accountsAsPartners = _.reject(
                    result,
                    (account) => account.id === ctrl.ticketOwner.id
                  );

                  if (status === 'settled') {
                    if ($scope.Model.currentTicket.idAccountsAsPartners.length) {
                      for (
                        let i = 0;
                        i < $scope.Model.currentTicket.idAccountsAsPartners.length;
                        i += 1
                      ) {
                        ctrl.ticketAccountsAsPartners.push({
                          idPartner: $scope.Model.currentTicket.idAccountsAsPartners[i],
                          partnerReferralFee:
                            $scope.Model.currentTicket.partnersReferralFee[
                              $scope.Model.currentTicket.idAccountsAsPartners[i]
                            ]
                        });
                      }
                    } else {
                      ctrl.ticketAccountsAsPartners.push({
                        idPartner: '',
                        partnerReferralFee: ''
                      });
                    }
                  }
                });
            }
            return [];
          };

          ctrl.getAccountsAsPartners();
          ctrl.ticketPartnerDelete = (idPartner, idx) => {
            ctrl.ticketPartners.splice(idx, 1);
            ctrl.idPartners.splice(ctrl.idPartners.indexOf(idPartner), 1);
            delete ctrl.partnersReferralFee[idPartner];
            if (!ctrl.ticketPartners.length) {
              ctrl.ticketPartners.push({ idPartner: '', partnerReferralFee: '' });
            }
          };
          ctrl.ticketAccountAsPartnerDelete = (idPartner, idx) => {
            ctrl.ticketAccountsAsPartners.splice(idx, 1);
            ctrl.idAccountsAsPartners.splice(ctrl.idAccountsAsPartners.indexOf(idPartner), 1);
            delete ctrl.accountAsPartnersReferralFee[idPartner];
            if (!ctrl.ticketAccountsAsPartners.length) {
              ctrl.ticketAccountsAsPartners.push({ idPartner: '', partnerReferralFee: '' });
            }
          };
          ctrl.canSeePartner = (idPartner) => {
            const partnerIds = _.map(ctrl.partners, 'id');
            return partnerIds.indexOf(idPartner) > -1;
          };

          ctrl.onJobStatusChange = (jobsToCreate) => {
            ctrl.jobsToCreate = jobsToCreate;
          };

          ctrl.saveTicket = (data, property) => {
            uiService.toast({
              text: {
                p1: `Saving ${property}`
              }
            });
            $scope.saveTicketByProperty(data, property);
          };
          ctrl.updateTicketLoan = $mdUtil.debounce((loanDetails) => {
            uiService.toast({
              text: {
                p1: 'Updating Loan. Please Wait...'
              }
            });
            if (ctrl.workflow.isHomeLoan()) {
              $scope.saveTicket({
                loan: { details: { dealLoanDetailsSplit: loanDetails } }
              });
            } else if (ctrl.workflow.isAssetFinance()) {
              $scope.saveTicket({ assetFinance: loanDetails });
            } else if (ctrl.workflow.isCommercialLoan()) {
              $scope.saveTicket({ commercialLoan: loanDetails });
            } else if (ctrl.workflow.isPersonaLoan()) {
              $scope.saveTicket({ personalLoan: loanDetails });
            }
          }, 1500);

          ctrl.updateTicketLoanBT = $mdUtil.debounce(() => {
            _.forEach(ctrl.loan.compareProducts, (compareProduct, idx) => {
              if (compareProduct.isPreferred) {
                ctrl.loan.compareProducts[idx] = ctrl.preferredProduct;
              }
            });
            _.forEach(ctrl.loan.reviewProducts, (reviewProduct) => {
              if (reviewProduct.isPreferred) {
                _.forEach(reviewProduct.productSplits, (s, idx) => {
                  const split = s;
                  split.commissions = ctrl.preferredProduct.productSplits[idx].commissions;
                });
              }
            });
            $scope.saveHomeLoan({
              compareProducts: ctrl.loan.compareProducts,
              reviewProducts: ctrl.loan.reviewProducts
            });
          }, 1500);

          ctrl.areRequiredFieldsFilledInByWorkflowType = () => {
            let areRequiredFieldsFilledIn = false;
            switch (ctrl.workflow?.type?.name) {
              case WorkflowType?.asset_finance?.name:
                areRequiredFieldsFilledIn = ctrl.hasAssetFinanceToolsEnabled
                  ? ctrl.preferredProduct?.commissions?.loanAccountNumber !== ''
                  : ctrl.currentTicket?.assetFinance?.finance?.accountNumber;
                break;
              case WorkflowType?.commercial_loan?.name:
                areRequiredFieldsFilledIn = _.every(
                  ctrl.currentTicket?.commercialLoan?.details?.dealCommercialLoanDetailsSplit ||
                    [],
                  (p) => p?.accountNumber !== ''
                );
                break;
              case WorkflowType?.home_loan?.name:
                areRequiredFieldsFilledIn = ctrl.hasBrokerToolsEnabled
                  ? _.every(
                      ctrl.preferredProduct?.productSplits || [],
                      (p) => p?.commissions?.loanAccountNumber !== ''
                    )
                  : _.every(
                      ctrl.currentTicket?.loan?.details?.dealLoanDetailsSplit || [],
                      (p) => p?.accountNumber !== ''
                    );
                break;
              case WorkflowType?.personal_loan?.name:
                areRequiredFieldsFilledIn =
                  ctrl.currentTicket?.personalLoan?.details?.accountNumber;
                break;
              default:
                areRequiredFieldsFilledIn = true;
                break;
            }
            return areRequiredFieldsFilledIn;
          };

          ctrl.canSubmit = () =>
            status === 'settled' || status === 'post_commissions'
              ? ctrl.statusHistory?.timeStamp &&
                (ctrl.hasCommissionsPostingEnabled
                  ? ctrl.currentTicket?.submittedTimeStamp
                  : true) &&
                (ctrl.hasCommissionsPostingEnabled && status === 'settled' && !ctrl.isGnz
                  ? ctrl.commissionUsername
                  : true) &&
                ctrl.areRequiredFieldsFilledInByWorkflowType()
              : ctrl.statusHistory?.timeStamp;

          ctrl.confirm = () => {
            if (ctrl.canSubmit()) {
              ctrl.statusHistory.setTimeStamp();
              if (ctrl.hasCommissionsPostingEnabled && status === 'settled') {
                if (!ctrl.commissionUsername && !ctrl.isGnz) {
                  uiService.toast({
                    text: {
                      p1: 'Commission Username is required...'
                    }
                  });
                  return;
                }
                ctrl.isLoading = true;
                ctrl.currentTicket.settledTimeStamp = ctrl.statusHistory.timeStampSet;
                ctrl.currentTicket.assetFinance.id = ctrl.currentTicket.assetFinance.id
                  ? ctrl.currentTicket.assetFinance.id
                  : _.uuid();
                ctrl.currentTicket.assetFinance.vbiId = ctrl.currentTicket.assetFinance.vbiId
                  ? ctrl.currentTicket.assetFinance.vbiId
                  : _.uuid();
                ctrl.currentTicket.loan.id = ctrl.currentTicket.loan.id
                  ? ctrl.currentTicket.loan.id
                  : _.uuid();

                ticketService
                  .updateTicket(ctrl.currentTicket)
                  .then(() => {
                    if (ctrl.hasBrokerToolsEnabled) {
                      return homeLoanService.updateHomeLoan(ctrl.loan);
                    }
                    if (ctrl.hasAssetFinanceToolsEnabled) {
                      return $scope.saveAssetFinance({
                        compareProducts: ctrl.currentAssetFinance.compareProducts
                      });
                    }
                    return true;
                  })
                  .then(() => {
                    $timeout(() => {
                      ctrl.isLoading = false;
                      $mdDialog.hide({
                        status: ctrl.hasCommissionsPostingEnabled
                          ? 'post_commissions'
                          : ctrl.status,
                        statusHistory: ctrl.statusHistory,
                        submissionDate: ctrl.currentTicket.submissionTimeStamp,
                        idPartners: ctrl.idPartners,
                        partnersReferralFee: ctrl.partnersReferralFee,
                        jobsToCreate: ctrl.jobsToCreate
                      });
                    }, 5000);
                  });
              } else {
                ctrl.isLoading = false;
                $mdDialog.hide({
                  status: ctrl.status,
                  loan: ctrl.loan,
                  statusHistory: ctrl.statusHistory,
                  submissionDate: ctrl.currentTicket.submissionTimeStamp,
                  idPartners: ctrl.idPartners,
                  partnersReferralFee: ctrl.partnersReferralFee,
                  jobsToCreate: ctrl.jobsToCreate
                });
              }
            }
          };
          ctrl.cancel = () => {
            $mdDialog.cancel();
          };
        }
      })
      .then((result) => {
        switch (result.status) {
          case 'lost':
            $scope.Model.currentTicket = Ticket.setStatus('lost', $scope.Model.currentTicket, {
              lostTimeStamp: result.statusHistory.timeStampSet
            });
            break;
          case 'paused':
            $scope.Model.currentTicket = Ticket.setStatus(
              'paused',
              $scope.Model.currentTicket,
              {
                frozenTimeStamp: result.statusHistory.timeStampSet
              }
            );
            break;
          case 'won':
            $scope.Model.currentTicket = Ticket.setStatus('won', $scope.Model.currentTicket, {
              wonTimeStamp: result.statusHistory.timeStampSet,
              settledTimeStamp:
                $scope.Model.currentTicket.settledTimeStamp ||
                result.statusHistory.timeStampSet,
              values: {
                onceOfDueDate:
                  $scope.Model.currentTicket.settledTimeStamp ||
                  result.statusHistory.timeStampSet
              }
            });
            break;
          case 'settled':
            $scope.Model.currentTicket = Ticket.setStatus(
              'settled',
              $scope.Model.currentTicket,
              {
                settledTimeStamp: result.statusHistory.timeStampSet,
                values: {
                  onceOfDueDate: result.statusHistory.timeStampSet
                }
              }
            );
            break;
          case 'post_commissions':
            $scope.Model.currentTicket = Ticket.setStatus(
              'settled',
              $scope.Model.currentTicket,
              {
                settledTimeStamp: result.statusHistory.timeStampSet,
                values: {
                  onceOfDueDate: result.statusHistory.timeStampSet
                },
                postToCommissions: true
              }
            );
            $scope.Model.isReady = false;
            break;
          case 'deleted':
            $scope.Model.currentTicket = Ticket.setStatus(
              'deleted',
              $scope.Model.currentTicket,
              {
                deletedTimeStamp: result.statusHistory.timeStampSet
              }
            );
            break;
          case 'restore':
            $scope.Model.currentTicket = Ticket.setStatus(
              'inProgress',
              $scope.Model.currentTicket
            );
            break;
          default:
            break;
        }
        $scope.Model.currentTicket.idPartners = result.idPartners;
        $scope.Model.currentTicket.partnersReferralFee = result.partnersReferralFee;

        notesService.clearCache();
        ticketsService.clearCache();

        ticketService
          .updateTicket({
            id: $scope.Model.currentTicket.id,
            idPartners: $scope.Model.currentTicket.idPartners,
            partnersReferralFee: $scope.Model.currentTicket.partnersReferralFee,
            isInProgress: $scope.Model.currentTicket.isInProgress,
            isWon: $scope.Model.currentTicket.isWon,
            isLost: $scope.Model.currentTicket.isLost,
            isFrozen: $scope.Model.currentTicket.isFrozen,
            isSettled: $scope.Model.currentTicket.isSettled,
            isDeclined: $scope.Model.currentTicket.isDeclined,
            isWithDrawn: $scope.Model.currentTicket.isWithDrawn,
            wonTimeStamp: $scope.Model.currentTicket.wonTimeStamp,
            lostTimeStamp: $scope.Model.currentTicket.lostTimeStamp,
            frozenTimeStamp: $scope.Model.currentTicket.frozenTimeStamp,
            deletedTimeStamp: $scope.Model.currentTicket.deletedTimeStamp,
            settledTimeStamp: $scope.Model.currentTicket.settledTimeStamp,
            withDrawnTimeStamp: $scope.Model.currentTicket.withDrawnTimeStamp,
            declinedTimeStamp: $scope.Model.currentTicket.declinedTimeStamp,
            values: {
              onceOffDueDate: $scope.Model.currentTicket.values.onceOfDueDate
            },
            postToCommissions: $scope.Model.currentTicket.postToCommissions,
            statusHistoryNote: result.statusHistory.note,
            isActive: $scope.Model.currentTicket.isActive
          })
          .then(async (response) => {
            if (result.jobsToCreate.length) {
              await $q.all(result.jobsToCreate.map((job) => jobService.createJob(job)));
              jobsService.clearCache();
            }
            if (response.status === 'post_commissions') {
              $scope.Model.currentTicket.postToCommissions = false;
              initialize();
            } else {
              uiService.toast({
                text: {
                  p1: 'Deal',
                  p2: $scope.Model.currentTicket.getName(),
                  p3: 'has been changed status'
                }
              });
              $scope.back();
            }
          });
      });
  };

  $scope.ticketPostToCommissions = ($event, status) => {
    $event.stopPropagation();

    if (
      !$rootScope.isShf() &&
      !$rootScope.isMag() &&
      !$rootScope.isAfg() &&
      !$rootScope.isDev()
    ) {
      const ticketPartners = [];
      if ($scope.Model.currentTicket.idPartners.length) {
        for (let i = 0; i < $scope.Model.currentTicket.idPartners.length; i += 1) {
          ticketPartners.push({
            idPartner: $scope.Model.currentTicket.idPartners[i],
            partnerReferralFee:
              ($scope.Model.currentTicket.partnersReferralFee &&
                $scope.Model.currentTicket.partnersReferralFee[
                  $scope.Model.currentTicket.idPartners[i]
                ]) ||
              ''
          });
        }
      } else {
        ticketPartners.push({ idPartner: '', partnerReferralFee: '' });
      }
      $mdDialog
        .show({
          targetEvent: $event,
          locals: {
            status,
            statusHistory: TicketStatusHistory.blank(),
            ticketOwner: $scope.getAccount($scope.Model.currentTicket.idOwner),
            currentLender: $scope.Model.currentLender,
            currentTicket: $scope.Model.currentTicket,
            loan: $scope.Model.currentHomeLoan,
            currentAssetFinance: $scope.Model.currentAssetFinance,
            preferredProduct: $scope.getLoanProductsForCommission(),
            partners: $scope.Model.availablePartners,
            idPartners: $scope.Model.currentTicket.idPartners,
            idAccountsAsPartners: $scope.Model.currentTicket.idAccountsAsPartners,
            partnersReferralFee: $scope.Model.currentTicket.partnersReferralFee,
            workflow: $scope.Model.currentWorkflow,
            hasBrokerToolsEnabled:
              $scope.hasHomeLoanTools() &&
              getPreferredProduct($scope.Model.currentHomeLoan?.compareProducts || []) !==
                undefined,
            hasAssetFinanceToolsEnabled:
              $scope.hasAssetFinanceTools() && $scope.Model.currentAssetFinance
          },
          template: templateTicketStatusChange,
          controllerAs: '$ctrl',
          controller(
            statusHistory,
            ticketOwner,
            currentLender,
            currentTicket,
            loan,
            currentAssetFinance,
            preferredProduct,
            partners,
            idPartners,
            idAccountsAsPartners,
            partnersReferralFee,
            workflow,
            hasBrokerToolsEnabled,
            hasAssetFinanceToolsEnabled
          ) {
            const ctrl = this;
            ctrl.currentOrganization = $rootScope.CurrentOrganization;
            ctrl.currentCurrency = $rootScope.CurrentCurrency();
            ctrl.rootScope = $rootScope;
            ctrl.status = status;
            ctrl.statusHistory = statusHistory;
            dateTimeService.getSet(
              ctrl,
              ctrl.statusHistory,
              'timeStamp',
              'getSetStatusHistoryDate'
            );

            ctrl.ticketOwner = ticketOwner;
            ctrl.currentLender = currentLender;
            ctrl.currentTicket = currentTicket;
            dateTimeService.getSet(
              ctrl,
              ctrl.currentTicket,
              'submittedTimeStamp',
              'getSetSubmittedTimeStamp'
            );
            ctrl.loan = loan;
            ctrl.currentAssetFinance = currentAssetFinance;
            ctrl.preferredProduct = preferredProduct;
            ctrl.partners = partners;
            ctrl.idPartners = idPartners;
            ctrl.partnersReferralFee = partnersReferralFee;
            ctrl.accountsAsPartners = [];
            ctrl.idAccountsAsPartners = idAccountsAsPartners;
            ctrl.accountsAsPartnersReferralFee = [];
            ctrl.workflow = workflow;
            ctrl.workflowType = workflow.type.name;
            ctrl.hasBrokerToolsEnabled = hasBrokerToolsEnabled;
            ctrl.hasAssetFinanceToolsEnabled = hasAssetFinanceToolsEnabled;
            ctrl.ticketPartners = ticketPartners;
            ctrl.ticketAccountsAsPartners = [];
            ctrl.preferredProductReview = _.find(ctrl.loan && ctrl.loan.reviewProducts, {
              isPreferred: true
            });
            ctrl.isAstuteOrg = $rootScope.canSeeNeedsAnalysis();
            ctrl.isLoading = false;
            ctrl.personalLoanPurpose = TicketPersonalLoanPurpose.available();
            ctrl.CurrentOrganization = $rootScope.CurrentOrganization;
            ctrl.hasCommissionsPostingEnabled = $rootScope.hasCommissionsPostingEnabled();
            ctrl.isGnz = $rootScope.isGnz();
            ctrl.availableCommissions = $scope.Model.availableCommissions;
            ctrl.commissionUsername =
              _.get(
                $rootScope.CurrentOrganization,
                `partnersAttributes.${ctrl.ticketOwner.id}.commissionUsername`
              ) || '';

            ctrl.saveAssetFinanceCommission = $mdUtil.debounce((commission) => {
              if (commission && !_.isEmpty(commission) && ctrl.hasAssetFinanceToolsEnabled) {
                $scope.Model.currentAssetFinance.commission = commission;
                $scope.saveAssetFinance({ commission });
              }
            }, 500);

            ctrl.jobsToCreate = [];

            ctrl.getLenderName = () => {
              if (ctrl.workflow.isHomeLoan()) {
                if (hasBrokerToolsEnabled) {
                  return (ctrl.currentLender && ctrl.currentLender.getName()) || '';
                }
                return ctrl.currentTicket.loan.details.lender;
              }
              if (ctrl.workflow.isAssetFinance()) {
                return ctrl.currentTicket.assetFinance.asset.lender;
              }
              if (ctrl.workflow.isCommercialLoan()) {
                return ctrl.currentTicket.commercialLoan.details.lender;
              }
              if (ctrl.workflow.isPersonalLoan()) {
                return ctrl.currentTicket.personalLoan.details.lender;
              }
              return null;
            };

            if (
              ctrl.workflow.isHomeLoan() &&
              hasBrokerToolsEnabled &&
              ctrl.preferredProduct &&
              ctrl.preferredProductReview
            ) {
              _.forEach(ctrl.preferredProduct.productSplits, (s, idx) => {
                const split = s;
                split.commissions = ctrl.preferredProductReview.productSplits[idx].commissions;
              });
            }
            ctrl.ticketPartnerAdd = () => {
              if (ctrl.ticketPartners[ctrl.ticketPartners.length - 1].idPartner !== '') {
                ctrl.ticketPartners.push({ idPartner: '', partnerReferralFee: '' });
              }
            };
            ctrl.ticketPartnerEdit = (idPartner, idx) => {
              if (ctrl.idPartners.indexOf(idPartner) === -1) {
                if (!ticketPartners.some((partner) => partner.idPartner === idPartner)) {
                  ticketPartners.push({
                    idPartner,
                    partnerReferralFee: ctrl.currentTicket.partnersReferralFee[idPartner] || ''
                  });
                }

                ctrl.idPartners.push(idPartner);
                ctrl.partnersReferralFee[idPartner] =
                  (ctrl.currentOrganization.partnersAttributes[idPartner] &&
                    ctrl.currentOrganization.partnersAttributes[idPartner].fee) ||
                  '';
                ctrl.ticketPartners[idx].partnerReferralFee =
                  (ctrl.currentOrganization.partnersAttributes[idPartner] &&
                    ctrl.currentOrganization.partnersAttributes[idPartner].fee) ||
                  '';
                ctrl.currentTicket.idPartners = ctrl.idPartners;
              } else {
                uiService.toast({
                  text: {
                    p1: 'Partner',
                    p3: 'already exist'
                  },
                  warn: true
                });
              }
            };
            ctrl.ticketAccountAsPartnerAdd = () => {
              if (
                ctrl.ticketAccountsAsPartners[ctrl.ticketAccountsAsPartners.length - 1]
                  .idPartner !== ''
              ) {
                ctrl.ticketAccountsAsPartners.push({ idPartner: '', partnerReferralFee: '' });
              }
            };
            ctrl.ticketAccountAsPartnerEdit = (idPartner, idx) => {
              if (ctrl.idAccountsAsPartners.indexOf(idPartner) === -1) {
                if (
                  !ctrl.ticketAccountsAsPartners.some(
                    (partner) => partner.idPartner === idPartner
                  )
                ) {
                  ctrl.ticketAccountsAsPartners.push({
                    idPartner,
                    partnerReferralFee: ''
                  });
                }
                ctrl.idAccountsAsPartners.push(idPartner);
                ctrl.accountsAsPartnersReferralFee[idPartner] = '';
                ctrl.ticketAccountsAsPartners[idx].partnerReferralFee = '';
                ctrl.currentTicket.idAccountsAsPartners = ctrl.idAccountsAsPartners;
              } else {
                uiService.toast({
                  text: {
                    p1: 'Partner',
                    p3: 'already exist'
                  },
                  warn: true
                });
              }
            };
            ctrl.getAccountsAsPartners = () => {
              if (ctrl.isAstuteOrg) {
                return accountsService
                  .getAvailable({ isActive: true, fields: ACCOUNT.FIELDS.LIST })
                  .then((result) => {
                    ctrl.accountsAsPartners = _.reject(
                      result,
                      (account) => account.id === ctrl.ticketOwner.id
                    );

                    if ($scope.Model.currentTicket.idAccountsAsPartners.length) {
                      for (
                        let i = 0;
                        i < $scope.Model.currentTicket.idAccountsAsPartners.length;
                        i += 1
                      ) {
                        const fee =
                          $scope.Model.currentTicket.partnersReferralFee[
                            $scope.Model.currentTicket.idAccountsAsPartners[i]
                          ];
                        ctrl.ticketAccountsAsPartners.push({
                          idPartner: $scope.Model.currentTicket.idAccountsAsPartners[i],
                          partnerReferralFee: fee
                        });
                      }
                    } else {
                      ctrl.ticketAccountsAsPartners.push({
                        idPartner: '',
                        partnerReferralFee: ''
                      });
                    }
                  });
              }
              return null;
            };

            ctrl.getAccountsAsPartners();
            ctrl.ticketPartnerDelete = (idPartner, idx) => {
              ctrl.ticketPartners.splice(idx, 1);
              ctrl.idPartners.splice(ctrl.idPartners.indexOf(idPartner), 1);
              if (ctrl.partnersReferralFee[idPartner]) {
                delete ctrl.partnersReferralFee[idPartner];
              }
              if (!ctrl.ticketPartners.length) {
                ctrl.ticketPartners.push({ idPartner: '', partnerReferralFee: '' });
              }
            };
            ctrl.ticketAccountAsPartnerDelete = (idPartner, idx) => {
              ctrl.ticketAccountsAsPartners.splice(idx, 1);
              ctrl.idAccountsAsPartners.splice(ctrl.idAccountsAsPartners.indexOf(idPartner), 1);
              if (ctrl.accountAsPartnersReferralFee[idPartner]) {
                delete ctrl.accountAsPartnersReferralFee[idPartner];
              }
              if (!ctrl.ticketAccountsAsPartners.length) {
                ctrl.ticketAccountsAsPartners.push({ idPartner: '', partnerReferralFee: '' });
              }
            };
            ctrl.canSeePartner = (idPartner) => {
              const idsPartners = _.map(ctrl.partners, 'id');
              return idsPartners.indexOf(idPartner) > -1;
            };
            ctrl.onJobStatusChange = (jobsToCreate) => {
              ctrl.jobsToCreate = jobsToCreate;
            };
            ctrl.updateTicketLoanBT = () => {
              _.forEach(ctrl.loan.compareProducts, (compareProduct, idx) => {
                if (compareProduct.isPreferred) {
                  ctrl.loan.compareProducts[idx] = ctrl.preferredProduct;
                }
              });
              _.forEach(ctrl.loan.reviewProducts, (reviewProduct) => {
                if (reviewProduct.isPreferred) {
                  _.forEach(reviewProduct.productSplits, (s, idx) => {
                    const split = s;
                    split.commissions = ctrl.preferredProduct.productSplits[idx].commissions;
                  });
                }
              });
            };
            ctrl.updateTicketLoan = (loanDetails) => {
              if (ctrl.workflow.isHomeLoan()) {
                ctrl.currentTicket.loan.details.dealLoanDetailsSplit = loanDetails;
              }
              if (ctrl.workflow.isAssetFinance()) {
                ctrl.currentTicket.assetFinance = loanDetails;
              }
              if (ctrl.workflow.isCommercialLoan()) {
                ctrl.currentTicket.commercialLoan = loanDetails;
              }
              if (ctrl.workflow.isPersonalLoan()) {
                ctrl.currentTicket.personalLoan = loanDetails;
              }
            };

            ctrl.areRequiredFieldsFilledInByWorkflowType = () => {
              let areRequiredFieldsFilledIn = false;
              switch (ctrl.workflow?.type?.name) {
                case WorkflowType?.asset_finance?.name:
                  areRequiredFieldsFilledIn = ctrl.hasAssetFinanceToolsEnabled
                    ? ctrl.preferredProduct?.commissions?.loanAccountNumber !== ''
                    : ctrl.currentTicket?.assetFinance?.finance?.accountNumber;
                  break;
                case WorkflowType?.commercial_loan?.name:
                  areRequiredFieldsFilledIn = _.every(
                    ctrl.currentTicket?.commercialLoan?.details
                      ?.dealCommercialLoanDetailsSplit || [],
                    (p) => p?.accountNumber !== ''
                  );
                  break;
                case WorkflowType?.home_loan?.name:
                  areRequiredFieldsFilledIn = ctrl.hasBrokerToolsEnabled
                    ? _.every(
                        ctrl.preferredProduct?.productSplits || [],
                        (p) => p?.commissions?.loanAccountNumber !== ''
                      )
                    : _.every(
                        ctrl.currentTicket?.loan?.details?.dealLoanDetailsSplit || [],
                        (p) => p?.accountNumber !== ''
                      );
                  break;
                case WorkflowType?.personal_loan?.name:
                  areRequiredFieldsFilledIn =
                    ctrl.currentTicket?.personalLoan?.details?.accountNumber;
                  break;
                default:
                  areRequiredFieldsFilledIn = true;
                  break;
              }
              return areRequiredFieldsFilledIn;
            };

            ctrl.canSubmit = () =>
              status === 'settled' || status === 'post_commissions'
                ? ctrl.statusHistory?.timeStamp &&
                  (ctrl.hasCommissionsPostingEnabled
                    ? ctrl.currentTicket?.submittedTimeStamp
                    : true) &&
                  (ctrl.hasCommissionsPostingEnabled && status === 'settled' && !ctrl.isGnz
                    ? ctrl.commissionUsername
                    : true)
                : ctrl.statusHistory?.timeStamp;

            ctrl.confirm = () => {
              ctrl.statusHistory.setTimeStamp();
              if (!ctrl.commissionUsername && !ctrl.isGnz) {
                uiService.toast({
                  text: {
                    p1: 'Commission Username',
                    p2: 'is required'
                  },
                  warn: true
                });
                return;
              }
              ctrl.isLoading = true;
              ctrl.currentTicket.settledTimeStamp = ctrl.statusHistory.timeStampSet;
              ctrl.currentTicket.assetFinance.id = ctrl.currentTicket.assetFinance.id
                ? ctrl.currentTicket.assetFinance.id
                : _.uuid();
              ctrl.currentTicket.assetFinance.vbiId = ctrl.currentTicket.assetFinance.vbiId
                ? ctrl.currentTicket.assetFinance.vbiId
                : _.uuid();
              ctrl.currentTicket.loan.id = ctrl.currentTicket.loan.id
                ? ctrl.currentTicket.loan.id
                : _.uuid();
              Promise.resolve()
                .then(() => {
                  if (ctrl.hasBrokerToolsEnabled) {
                    return homeLoanService.updateHomeLoan(ctrl.loan);
                  }
                  if (ctrl.hasAssetFinanceToolsEnabled) {
                    return $scope.saveAssetFinance({
                      compareProducts: ctrl.currentAssetFinance.compareProducts
                    });
                  }
                  return true;
                })
                .then(() => {
                  $timeout(() => {
                    ctrl.isLoading = false;
                    $mdDialog.hide({
                      submittedTimeStamp: ctrl.currentTicket.submittedTimeStamp,
                      settledTimeStamp: ctrl.currentTicket.settledTimeStamp,
                      idPartners: ctrl.idPartners,
                      loan: ctrl.loan,
                      idAccountsAsPartners: ctrl.idAccountsAsPartners,
                      partnersReferralFee: ctrl.partnersReferralFee,
                      ticketLoan: ctrl.currentTicket.loan,
                      commercialLoan: ctrl.currentTicket.commercialLoan,
                      personalLoan: ctrl.currentTicket.personalLoan,
                      assetFinance: ctrl.currentTicket.assetFinance,
                      jobsToCreate: ctrl.jobsToCreate
                    });
                  }, 5000);
                });
            };
            ctrl.cancel = () => {
              $mdDialog.cancel();
            };
          }
        })
        .then((result) => {
          $scope.Model.currentTicket.settledTimeStamp = result.settledTimeStamp;
          $scope.Model.currentTicket.values.onceOfDueDate = result.settledTimeStamp;
          $scope.Model.currentTicket.submittedTimeStamp = result.submittedTimeStamp;
          $scope.Model.currentTicket.postToCommissions = true;
          $scope.Model.currentTicket.idPartners = result.idPartners;
          $scope.Model.currentTicket.idAccountsAsPartners = result.idAccountsAsPartners;
          $scope.Model.currentTicket.loan = result.loan;
          $scope.Model.currentTicket.commercialLoan = result.commercialLoan;
          $scope.Model.currentTicket.personalLoan = result.personalLoan;
          $scope.Model.currentTicket.assetFinance = result.assetFinance;
          $scope.Model.currentTicket.partnersReferralFee = result.partnersReferralFee;
          $scope.Model.isReady = false;

          notesService.clearCache();
          ticketsService.clearCache();

          ticketService
            .updateTicket({
              id: $scope.Model.currentTicket.id,
              idPartners: $scope.Model.currentTicket.idPartners,
              idAccountsAsPartners: $scope.Model.currentTicket.idAccountsAsPartners,
              loan: $scope.Model.currentTicket.loan,
              commercialLoan: $scope.Model.currentTicket.commercialLoan,
              personalLoan: $scope.Model.currentTicket.personalLoan,
              assetFinance: $scope.Model.currentTicket.assetFinance,
              partnersReferralFee: $scope.Model.currentTicket.partnersReferralFee,
              values: {
                onceOffDueDate: $scope.Model.currentTicket.values.onceOfDueDate
              },
              settledTimeStamp: $scope.Model.currentTicket.settledTimeStamp,
              submittedTimeStamp: $scope.Model.currentTicket.submittedTimeStamp,
              postToCommissions: true,
              isActive: $scope.Model.currentTicket.isActive
            })
            .then(async () => {
              $scope.Model.currentTicket.postToCommissions = false;
              if (result.jobsToCreate.length) {
                await $q.all(result.jobsToCreate.map((job) => jobService.createJob(job)));
                jobsService.clearCache();
              }
              initialize();
            });
        });
    } else {
      // This is temporary solution for MAG and SHF commission
      flexService.flexConnect({ idTicket: $scope.Model.currentTicket.id }).then((result) => {
        $scope.Model.isCreatingFlexOpportunity = false;
        if (result.status) {
          $scope.Model.currentTicket.integrations.flexId = result.flexId;
          uiService.toast({
            text: {
              p1: 'Successfully created Opportunity',
              p2: $scope.Model.currentTicket.getName(),
              p3: 'in Flex'
            },
            success: true
          });
        } else {
          uiService.toast({
            text: {
              p1: 'Cannot create Opportunity',
              p2: 'Error returned from Flex',
              p3: result.errorMessage
            },
            warn: true
          });

          eventService.lodgementResponseErrors({
            errors: result.errors,
            errorMessage: result.errorMessage,
            provider: 'Flex'
          });
        }
      });
      // This is temporary solution for MAG and SHF commission
    }
  };

  /*
   * Ticket view ~ Move ticket on board
   * --------------------------------------------------------------------------------
   */
  $scope.ticketMoveOnBoard = ($event, idStage) => {
    $event.stopPropagation();
    $mdDialog
      .show({
        targetEvent: $event,
        locals: {
          idStage
        },
        template: templateTicketMoveOnBoard,
        controllerAs: '$ctrl',
        controller() {
          this.idStage = idStage;
          this.confirm = () => {
            $mdDialog.hide({ idStage: this.idStage });
          };
          this.cancel = () => {
            $mdDialog.cancel();
          };
        }
      })
      .then((result) => {
        ticketsService.clearCache();
        notesService.clearCache();
        jobsService.clearCache();

        $scope.Model.currentTicket.idStage = result.idStage;
        ticketService
          .updateTicket({
            id: $scope.Model.currentTicket.id,
            idStage: $scope.Model.currentTicket.idStage
          })
          .then(() => {
            loadTicket();
            loadNotes().then(() => {
              loadAttachments();
            });
            loadJobs();
          });
      });
  };

  $scope.ticketHasPassedStage = (stage) => {
    const cIdx = _.findIndex($scope.Model.currentWorkflow.stages, (s) => s.id === stage.id);
    const tIdx = _.findIndex(
      $scope.Model.currentWorkflow.stages,
      (s) => $scope.Model.currentTicket.idStage === s.id
    );
    return cIdx <= tIdx;
  };

  $scope.ticketIsInStage = (stage) => $scope.Model.currentTicket.idStage === stage.id;

  $scope.isTicketEditAllowed = () =>
    ($rootScope.CurrentAccount.isAdministrator ||
      $rootScope.CurrentOrganization.permissions.usersCanEditDeals) &&
    $scope.isLenderExistingInTicketOwnersLenderAccreditations();

  $scope.isTicketMoveAllowed = () =>
    ($rootScope.CurrentAccount.isAdministrator ||
      $rootScope.CurrentOrganization.permissions.usersCanMoveDeals) &&
    $scope.isLenderExistingInTicketOwnersLenderAccreditations();

  $scope.ticketMoveOnBoardNotAllowed = () =>
    !$scope.isTicketMoveAllowed() ||
    $scope.Model.currentTicket.isWon ||
    $scope.Model.currentTicket.isLost ||
    $scope.Model.currentTicket.isFrozen ||
    !$scope.Model.currentTicket.isActive;

  /*
   * Ticket view ~ Move ticket to another workflow and Duplicate ticket
   * --------------------------------------------------------------------------------
   */
  $scope.ticketMoveToAnotherWorkflow = ({ event, isDuplicated }) => {
    event.stopPropagation();
    const ticket = isDuplicated
      ? angular.copy($scope.Model.currentTicket)
      : {
          id: $scope.Model.currentTicket.id,
          idWorkflow: $scope.Model.currentTicket.idWorkflow,
          idStage: $scope.Model.currentTicket.idStage,
          idOwner: $scope.Model.currentTicket.idOwner,
          name: $scope.Model.currentTicket.name
        };
    ticketService
      .ticketMoveToAnotherWorkflow({
        event,
        ticket,
        workflow: $scope.Model.currentWorkflow,
        workflows: $scope.Model.availableWorkflows,
        accounts: $scope.Model.teamMembers,
        isDuplicated
      })
      .then((result) => {
        ticketsService.clearCache();
        notesService.clearCache();
        jobsService.clearCache();
        uiService.toast({
          text: {
            p1: 'Deal',
            p2: result.ticketName,
            p3: isDuplicated
              ? 'has been duplicated and moved to Workflow'
              : 'has been moved to Workflow',
            p4: result.workflowName
          }
        });
        $timeout(() => {
          $state.transitionTo('deal', {
            id: result.idWorkflow,
            dd: result.idTicket
          });
        }, 1000);
      });
  };

  $scope.ticketDuplicate = ({ event }) => {
    event.stopPropagation();
    uiService.toast({
      text: {
        p1: `Duplication of the ${$scope.Model.currentTicket?.getName()} deal`,
        p2: 'is being prepared',
        p3: 'please wait'
      },
      progress: true
    });
    ticketService
      .duplicateTicket({ idTicket: $scope.Model.currentTicket?.id })
      .then((result) => {
        if (result?.status && result?.idTicket && result?.idWorkflow) {
          uiService.toast({
            text: {
              p1: 'Deal',
              p2: $scope.Model.currentTicket?.getName(),
              p3: 'has been duplicated'
            }
          });
          $timeout(() => {
            $state.transitionTo('deal', {
              id: result.idWorkflow,
              dd: result.idTicket
            });
          }, 1000);
        } else {
          uiService.toast({
            text: {
              p1: 'Deal',
              p2: $scope.Model.currentTicket?.getName(),
              p3: 'failed duplication'
            },
            warn: true
          });
        }
      });
  };

  /*
   * Ticket view ~ Pepper resolve
   * --------------------------------------------------------------------------------
   */
  $scope.canSeePepperResolve = () =>
    $scope.hasHomeLoanTools() &&
    $scope.Model.currentTicketOwner?.isPepperResolveEnabled() &&
    $rootScope.hasPepperResolveEnabled() &&
    ($scope.Model.currentTicket?.isLodged || $scope.Model.currentTicket?.isSubmitted) &&
    !$scope.Model.currentTicket.isSettled &&
    !$scope.Model?.currentTicket.isLost &&
    !$scope.Model.currentTicket?.isWon;

  $scope.pepperResolve = () => {
    uiService.toast({
      text: {
        p1: $scope.Model.currentTicket.getName(),
        p2: 'is being sent to Pepper Resolve',
        p3: 'This may take up to 1 minute.'
      }
    });

    pepperResolveService.send({ idTicket: $scope.Model.currentTicket.id }).then((result) => {
      ticketsService.clearCache();
      notesService.clearCache();

      if (!result.status) {
        uiService.toast({
          text: {
            p1: 'Error happened: ',
            p2: result.alertErrors.map((e) => e).join(''),
            p3: result.description
          }
        });
      }

      initialize();
    });
  };

  /*
   * Ticket view ~ Inline edit
   * --------------------------------------------------------------------------------
   */
  $scope.saveTicketByProperty = $mdUtil.debounce((data, property) => {
    switch (property) {
      case 'name':
        $scope.Model.currentTicket.name = data;
        $scope.Model.isEdit.ticketName = !$scope.Model.isEdit.ticketName;
        $scope.saveTicket({ name: $scope.Model.currentTicket.name });
        break;
      case 'value':
        $scope.Model.currentTicket.values.onceOff = parseInt(data, 10);
        $scope.Model.isEdit.ticketValue = !$scope.Model.isEdit.ticketValue;
        $scope.saveTicket({ values: $scope.Model.currentTicket.values });
        break;
      case 'dueDate':
        $scope.Model.currentTicket.values.onceOffDueDate = data;
        $scope.Model.isEdit.ticketCloseDate = !$scope.Model.isEdit.ticketCloseDate;
        $scope.saveTicket({ values: $scope.Model.currentTicket.values });
        break;
      case 'financeDueDate':
        $scope.Model.currentTicket.values.financeDueDate = data;
        $scope.Model.isEdit.ticketFinanceDueDate = !$scope.Model.isEdit.ticketFinanceDueDate;
        $scope.saveTicket({ values: $scope.Model.currentTicket.values });
        break;
      case 'description':
        $scope.Model.currentTicket.description = data;
        $scope.Model.isEdit.ticketDescription = !$scope.Model.isEdit.ticketDescription;
        $scope.saveTicket({ description: $scope.Model.currentTicket.description });
        break;
      case 'checklist':
        $scope.Model.currentTicket.checklist = data;
        $scope.saveTicket({ checklist: $scope.Model.currentTicket.checklist });
        break;
      case 'submittedTimeStamp':
        $scope.Model.currentTicket.submittedTimeStamp = data;
        $scope.saveTicket({
          submittedTimeStamp: $scope.Model.currentTicket.submittedTimeStamp
        });
        break;
      case 'settledTimeStamp':
        $scope.Model.currentTicket.settledTimeStamp = data;
        $scope.saveTicket({
          settledTimeStamp: $scope.Model.currentTicket.settledTimeStamp
        });
        break;
      case 'loanApplicationNumber':
        $scope.Model.currentTicket.loan.details.loanApplicationNumber = data;
        $scope.saveTicket({
          loan: {
            details: {
              loanApplicationNumber:
                $scope.Model.currentTicket.loan.details.loanApplicationNumber
            }
          }
        });
        break;
      default:
        break;
    }
  }, 1500);

  $scope.canSeeIdLenderApplication = () =>
    ($scope.hasHomeLoanTools() || $scope.hasAssetFinanceTools()) &&
    $scope.isDealImportedAndNotArchived();

  $scope.canEditIdLenderApplication = () =>
    $scope.isTicketEditAllowed() &&
    ($scope.Model.currentHomeLoan.id !== '' || $scope.Model.currentAssetFinance.id !== '') &&
    ($scope.hasHomeLoanTools() || $scope.hasAssetFinanceTools()) &&
    $scope.isDealImportedAndNotArchived();

  $scope.saveLoanIdLenderApplication = $mdUtil.debounce(() => {
    $scope.Model.isEdit.loanIdLenderApplication = !$scope.Model.isEdit.loanIdLenderApplication;

    if ($scope.Model.currentWorkflow.isHomeLoan()) {
      $scope.saveHomeLoan({
        idLenderApplication: $scope.Model.idLenderApplication
      });
    }
    if ($scope.Model.currentWorkflow.isAssetFinance()) {
      $scope.saveAssetFinance({
        idLenderApplication: $scope.Model.idLenderApplication
      });
    }
  }, 1500);

  /*
   * Ticket view ~ Important list actions
   * --------------------------------------------------------------------------------
   */
  $scope.importantItemPin = ($event, item) => {
    $event.stopPropagation();
    if (item.docType.name === '__datum_note') {
      $scope.notePin($event, item);
    }
  };

  $scope.importantItemToggle = (item) => {
    if (item.docType.name === '__datum_job') {
      $scope.jobToggle(item);
    }
  };

  $scope.importantItemShareClient = ($event, item) => {
    $event.stopPropagation();
    if (item.docType.name === '__datum_note') {
      $scope.noteShareClient($event, item);
    }
  };
  $scope.importantItemSharePartner = ($event, item) => {
    $event.stopPropagation();
    if (item.docType.name === '__datum_note') {
      $scope.noteSharePartner($event, item);
    }
  };
  $scope.importantLabelsSelect = ($event, item) => {
    $event.stopPropagation();
    if (item.docType.name === '__datum_note') {
      $scope.noteLabelsSelect($event, item);
    } else if (item.docType.name === '__datum_job') {
      $scope.jobLabelsSelect($event, item);
    }
  };
  $scope.importantItemEdit = ($event, item) => {
    $event.stopPropagation();
    if (item.docType.name === '__datum_note') {
      $scope.noteEdit($event, item);
    } else if (item.docType.name === '__datum_job') {
      $scope.jobEdit($event, item);
    }
  };
  $scope.importantItemDelete = ($event, item) => {
    if (item.docType.name === '__datum_note') {
      $scope.noteDelete($event, item);
    } else if (item.docType.name === '__datum_job') {
      $scope.jobDelete($event, item);
    }
  };

  $scope.listImportantItemsReady = (list) => {
    $scope.Model.list.importants = list;
  };

  /*
   * Ticket view ~ All list actions
   * --------------------------------------------------------------------------------
   */
  $scope.itemPin = ($event, item) => {
    $event.stopPropagation();
    if (item.docType.name === '__datum_note') {
      $scope.notePin($event, item);
    } else if (item.docType.name === '__definition_document') {
      $scope.attachmentPin($event, item);
    }
  };

  $scope.itemToggle = (item) => {
    if (item.docType.name === '__datum_job') {
      $scope.jobToggle(item);
    }
  };
  $scope.itemShareClient = ($event, item) => {
    $event.stopPropagation();
    if (item.docType.name === '__datum_note') {
      $scope.noteShareClient($event, item);
    } else if (item.docType.name === '__definition_document') {
      $scope.attachmentShareClient($event, item);
    }
  };

  $scope.itemSharePartner = ($event, item) => {
    $event.stopPropagation();
    if (item.docType.name === '__datum_note') {
      $scope.noteSharePartner($event, item);
    } else if (item.docType.name === '__definition_document') {
      $scope.attachmentSharePartner($event, item);
    }
  };

  $scope.itemLabelsSelect = ($event, item) => {
    $event.stopPropagation();
    if (item.docType.name === '__datum_note') {
      $scope.noteLabelsSelect($event, item);
    } else if (item.docType.name === '__datum_job') {
      $scope.jobLabelsSelect($event, item);
    } else if (item.docType.name === '__definition_document') {
      $scope.attachmentLabelsSelect($event, item);
    }
  };

  $scope.itemEdit = ($event, item) => {
    $event.stopPropagation();
    if (item.docType.name === '__datum_note') {
      $scope.noteEdit($event, item);
    } else if (item.docType.name === '__datum_job') {
      $scope.jobEdit($event, item);
    }
  };

  $scope.itemDelete = ($event, item) => {
    $event.stopPropagation();
    if (item.docType.name === '__datum_note') {
      $scope.noteDelete($event, item);
    } else if (item.docType.name === '__datum_job') {
      $scope.jobDelete($event, item);
    } else if (item.docType.name === '__definition_document') {
      $scope.attachmentDelete($event, item);
    }
  };

  $scope.itemLock = ($event, item) => {
    $event.stopPropagation();
    if (item.docType.name === '__definition_document') {
      $scope.attachmentLock($event, item);
    }
  };

  $scope.itemDownload = ($event, item) => {
    $event.stopPropagation();
    if (item.docType.name === '__definition_document') {
      $scope.attachmentDownload($event, item);
    }
  };

  $scope.itemDownloadPdf = ($event, item) => {
    $event.stopPropagation();
    if (item.docType.name === '__definition_document') {
      $scope.attachmentDownloadPdf($event, item);
    }
  };

  $scope.listTicketReady = (list) => {
    $scope.Model.list.ticket = list;
  };

  /*
   * Ticket view ~ Change Labels
   * --------------------------------------------------------------------------------
   */
  $scope.ticketLabelsSelect = ($event, ticket) => {
    eventService.dialogLabelSelect({
      event: $event,
      labels: $scope.Model.availableTicketLabels,
      selectedLabels: ticket.idLabels,
      data: ticket
    });
  };

  $scope.labelsSelected = (selectedLabels, dataOfSelectedLabels) => {
    const data = dataOfSelectedLabels;
    if (data.docType.name === '__datum_ticket') {
      $scope.Model.isTicketLabelSelected = false;
      $scope.Model.currentTicket.idLabels = selectedLabels;
      $scope.saveTicket({ idLabels: $scope.Model.currentTicket.idLabels });
      $timeout(() => {
        $scope.Model.isTicketLabelSelected = true;
      });
    } else if (data.docType.name === '__datum_note') {
      data.idLabels = selectedLabels;
      notesService.clearCache();
      noteService.updateNote(data);
    } else if (data.docType.name === '__datum_job') {
      data.idLabels = selectedLabels;
      $scope.Model.list.jobs.setDataReplace(data);
      jobsService.clearCache();
      jobService.updateJob(data);
    } else if (data.docType.name === '__definition_document') {
      data.idLabels = selectedLabels;
      if (data.idNote !== undefined) {
        const note = $scope.getNote(data.idNote);
        if (note && note.attachments && note.attachments.length) {
          const idx = note.attachments.findIndex((a) => a.id === data.id);
          if (idx > -1) {
            note.attachments[idx] = data;
            notesService.clearCache();
            noteService.updateNote(note);
          }
        }
      } else if (
        $scope.Model.currentTicket.attachments &&
        $scope.Model.currentTicket.attachments.length
      ) {
        const idx = $scope.Model.currentTicket.attachments.findIndex((a) => a.id === data.id);
        if (idx > -1) {
          $scope.Model.currentTicket.attachments[idx] = data;
          $scope.saveTicket({ attachments: $scope.Model.currentTicket.attachments });
        }
      }
      $scope.Model.list.attachments.setDataReplace(data);
    }
  };

  /*
   * Ticket view ~ List note events
   * --------------------------------------------------------------------------------
   */
  $scope.noteEdit = ($event, note) => {
    eventService.noteEdit({
      event: $event,
      note,
      list: $scope.Model.list.notes,
      url: NOTE.API.UPLOAD,
      ticket: $scope.Model.currentTicket,
      title: 'Drag & Drop file(s) here, or click to browse',
      allowedMimeTypes: '',
      allowedExtensions: ''
    });
  };

  $scope.noteEdited = (noteEdited) => {
    const note = noteEdited;
    notesService.clearCache();
    const iIdx = helperService.findIndexById($scope.Model.importantItems, note.id);
    const nIdx = helperService.findIndexById($scope.Model.availableNotes, note.id);
    const aIdx = helperService.findIndexById($scope.Model.allItems, note.id);

    if (note.isNew) {
      if (note.isPinned) {
        if (iIdx === -1) {
          $scope.Model.importantItems.push(note);
        }
      } else {
        if ($scope.Model.activeTabList !== 0 && $scope.Model.activeTabList !== 1) {
          $scope.Model.allItems.push(note);
          $scope.Model.availableNotes.push(note);
        }
        if ($scope.Model.activeTabList === 0) {
          $scope.Model.list.ticket.setDataAppend(note);
          $scope.Model.availableNotes.push(note);
        }
        if ($scope.Model.activeTabList === 1) {
          $scope.Model.list.notes.setDataAppend(note);
          $scope.Model.allItems.push(note);
        }
      }
      delete note.isNew;
      $scope.Model.activeTab = undefined;
    } else if (note.isPinned) {
      if (iIdx > -1) {
        $scope.Model.importantItems.splice(iIdx, 1);
        $scope.Model.importantItems.splice(iIdx, 0, note);
      } else {
        $scope.Model.importantItems.push(note);
      }
      if (nIdx > -1) {
        $scope.Model.availableNotes.splice(nIdx, 1);
      }
      if (aIdx > -1) {
        $scope.Model.allItems.splice(aIdx, 1);
      }
    } else {
      if (iIdx > -1) {
        $scope.Model.importantItems.splice(iIdx, 1);
      }
      if ($scope.Model.activeTabList === 0) {
        if (aIdx > -1) {
          $scope.Model.list.ticket.setDataReplace(note);
        } else {
          $scope.Model.list.ticket.setDataAppend(note);
        }
        if (nIdx > -1) {
          $scope.Model.availableNotes.splice(nIdx, 1);
          $scope.Model.availableNotes.splice(nIdx, 0, note);
        } else {
          $scope.Model.availableNotes.push(note);
        }
      }
      if ($scope.Model.activeTabList === 1) {
        if (nIdx > -1) {
          $scope.Model.list.notes.setDataReplace(note);
        } else {
          $scope.Model.list.notes.setDataAppend(note);
        }
        if (aIdx > -1) {
          $scope.Model.allItems.splice(aIdx, 1);
          $scope.Model.allItems.splice(aIdx, 0, note);
        } else {
          $scope.Model.allItems.push(note);
        }
      }
      if ($scope.Model.activeTabList !== 0 && $scope.Model.activeTabList !== 1) {
        $scope.Model.allItems.push(note);
        $scope.Model.availableNotes.push(note);
      }
    }
    $timeout(() => {
      loadAttachments();
    });
  };

  $scope.noteDelete = ($event, note) => {
    $event.stopPropagation();
    const deleteTimeout = $timeout(() => {
      notesService.clearCache();
      const iIdx = helperService.findIndexById($scope.Model.importantItems, note.id);
      const nIdx = helperService.findIndexById($scope.Model.availableNotes, note.id);
      const aIdx = helperService.findIndexById($scope.Model.allItems, note.id);

      if (iIdx > -1) {
        $scope.Model.importantItems.splice(iIdx, 1);
      }
      if ($scope.Model.activeTabList === 0) {
        if (aIdx > -1) {
          $scope.Model.list.ticket.removeData(note);
        }
        if (nIdx > -1) {
          $scope.Model.availableNotes.splice(nIdx, 1);
        }
      }
      if ($scope.Model.activeTabList === 1) {
        if (nIdx > -1) {
          $scope.Model.list.notes.removeData(note);
        }
        if (aIdx > -1) {
          $scope.Model.allItems.splice(aIdx, 1);
        }
      }
      if ($scope.Model.activeTabList !== 0 && $scope.Model.activeTabList !== 1) {
        if (nIdx > -1) {
          $scope.Model.availableNotes.splice(nIdx, 1);
        }
        if (aIdx > -1) {
          $scope.Model.allItems.splice(aIdx, 1);
        }
      }
      noteService.deleteNote({ id: note.id });
      $timeout(() => {
        loadAttachments();
      });
      uiService.toast({
        text: {
          p1: 'Note',
          p2: note.getExcerpt(),
          p3: 'has been deleted'
        }
      });
    }, 5250);
    uiService
      .toast({
        text: {
          p1: 'Note',
          p2: note.getExcerpt(),
          p3: 'will be deleted'
        },
        warn: true,
        action: 'UNDO'
      })
      .then((action) => {
        if (action) {
          $timeout.cancel(deleteTimeout);
          uiService.toast({
            text: {
              p1: 'Note',
              p2: note.getExcerpt(),
              p3: 'deletion has been undone'
            }
          });
        }
      });
  };

  $scope.notePin = ($event, notePinned) => {
    const note = notePinned;
    $event.stopPropagation();
    notesService.clearCache();
    note.isPinned = !note.isPinned;
    noteService.updateNote(note);
    const iIdx = helperService.findIndexById($scope.Model.importantItems, note.id);
    const nIdx = helperService.findIndexById($scope.Model.availableNotes, note.id);
    const aIdx = helperService.findIndexById($scope.Model.allItems, note.id);

    if (note.isPinned) {
      if (iIdx === -1) {
        $scope.Model.importantItems.push(note);
      }
      if ($scope.Model.activeTabList === 0) {
        $scope.Model.list.ticket.removeData(note);
        if (nIdx > -1) {
          $scope.Model.availableNotes.splice(nIdx, 1);
        }
      }
      if ($scope.Model.activeTabList === 1) {
        $scope.Model.list.notes.removeData(note);
        if (aIdx > -1) {
          $scope.Model.allItems.splice(aIdx, 1);
        }
      }
    } else {
      if (iIdx > -1) {
        $scope.Model.importantItems.splice(iIdx, 1);
      }
      if ($scope.Model.activeTabList === 0) {
        $scope.Model.list.ticket.setDataAppend(note);
        if (nIdx === -1) {
          $scope.Model.availableNotes.push(note);
        }
      }
      if ($scope.Model.activeTabList === 1) {
        $scope.Model.list.notes.setDataAppend(note);
        if (aIdx === -1) {
          $scope.Model.allItems.push(note);
        }
      }
      if ($scope.Model.activeTabList !== 0 && $scope.Model.activeTabList !== 1) {
        if (nIdx === -1) {
          $scope.Model.availableNotes.push(note);
        }
        if (aIdx === -1) {
          $scope.Model.allItems.push(note);
        }
      }
    }
  };

  $scope.noteShareClient = ($event, noteSharedToClient) => {
    $event.stopPropagation();
    const note = noteSharedToClient;
    notesService.clearCache();
    note.isShared = !note.isShared;
    for (let n = 0; n < note.attachments.length; n += 1) {
      delete note.attachments[n].idNote;
      note.attachments[n].isShared = note.isShared;
    }
    noteService.updateNote(note);
  };

  $scope.noteSharePartner = ($event, noteSharedToPartner) => {
    $event.stopPropagation();
    const note = noteSharedToPartner;
    notesService.clearCache();
    note.isSharedPartner = !note.isSharedPartner;
    for (let n = 0; n < note.attachments.length; n += 1) {
      delete note.attachments[n].idNote;
      note.attachments[n].isSharedPartner = note.isSharedPartner;
    }
    noteService.updateNote(note);
  };

  $scope.noteLabelsSelect = ($event, note) => {
    eventService.dialogLabelSelect({
      event: $event,
      labels: $scope.Model.availableNoteLabels,
      selectedLabels: note.idLabels,
      data: note
    });
  };

  $scope.listNoteReady = (list) => {
    $scope.Model.list.notes = list;
  };

  $scope.notesFilter = ($event, type, label, owner) => {
    $event.stopPropagation();
    if (type !== '' && label !== '' && owner !== '') {
      $scope.Model.filters.currentNoteType =
        type === null ? $scope.Model.filters.currentNoteType : type;
      $scope.Model.filters.currentNoteLabel =
        label === null ? $scope.Model.filters.currentNoteLabel : label;
      $scope.Model.filters.currentNoteOwner =
        owner === null ? $scope.Model.filters.currentNoteOwner : owner;
      $scope.Model.filters.currentNoteTypeDisplay =
        $scope.Model.filters.currentNoteType !== '' &&
        $scope.Model.filters.currentNoteType !== null
          ? $scope.Model.filters.currentNoteType.capitalizeFirstLetter()
          : 'Everything';
      $scope.Model.filters.currentNoteLabelDisplay =
        $scope.Model.filters.currentNoteLabel !== '' &&
        $scope.Model.filters.currentNoteLabel !== null
          ? $scope
              .getLabel($scope.Model.filters.currentNoteLabel)
              .getName()
              .capitalizeFirstLetter()
          : 'All';
      $scope.Model.filters.currentNoteOwnerDisplay =
        $scope.Model.filters.currentNoteOwner !== '' &&
        $scope.Model.filters.currentNoteOwner !== null
          ? $scope.Model.filters.currentNoteOwner.capitalizeFirstLetter()
          : 'Owner';
      $scope.Model.availableNotes = $filter('stNotesFilter')(
        $scope.Model.filteredNotes,
        $scope.Model.filters.currentNoteType,
        $scope.Model.filters.currentNoteLabel,
        $scope.Model.filters.currentNoteOwner
      );
      $scope.Model.list.notes.setData($scope.Model.availableNotes);
    } else {
      $scope.Model.filters.currentNoteType = '';
      $scope.Model.filters.currentNoteLabel = '';
      $scope.Model.filters.currentNoteOwner = '';
      $scope.Model.filters.currentNoteTypeDisplay = 'Everything';
      $scope.Model.filters.currentNoteLabelDisplay = 'All';
      $scope.Model.filters.currentNoteOwnerDisplay = 'Owner';
      $scope.Model.availableNotes = $filter('stNotesFilter')(
        $scope.Model.filteredNotes,
        $scope.Model.filters.currentNoteType,
        $scope.Model.filters.currentNoteLabel,
        $scope.Model.filters.currentNoteOwner
      );
      $scope.Model.list.notes.setData($scope.Model.availableNotes);
    }
  };

  /*
   * Ticket view ~ List job events
   * --------------------------------------------------------------------------------
   */
  $scope.jobEdit = ($event, job) => {
    eventService.jobEdit({
      event: $event,
      job,
      isJob: true,
      showAccounts: true,
      showTicket: false,
      isTasksPage: false,
      stage: null,
      jobTypes: $scope.Model.availableJobTypes,
      accounts: $filter('filter')(
        $scope.Model.availableAccounts,
        (account) => $scope.Model.currentWorkflow.idTeamMembers.indexOf(account.id) > -1
      ),
      workflow: $scope.Model.currentWorkflow,
      ticket: $scope.Model.currentTicket
    });
  };

  $scope.jobEdited = (jobEdited) => {
    const job = jobEdited;
    jobsService.clearCache();
    const iIdx = helperService.findIndexById($scope.Model.importantItems, job.id);
    const nIdx = helperService.findIndexById($scope.Model.availableJobs, job.id);
    const aIdx = helperService.findIndexById($scope.Model.allItems, job.id);
    if (job.isNew) {
      if (
        job.isJobOverdue($rootScope.CurrentTimeZone()) ||
        job.isJobDue($rootScope.CurrentTimeZone()) ||
        job.isPinned
      ) {
        $scope.Model.importantItems.push(job);
      } else {
        if ($scope.Model.activeTabList !== 0 && $scope.Model.activeTabList !== 2) {
          $scope.Model.allItems.push(job);
          $scope.Model.availableJobs.push(job);
        }
        if ($scope.Model.activeTabList === 0) {
          $scope.Model.list.ticket.setDataAppend(job);
          $scope.Model.availableJobs.push(job);
        }
        if ($scope.Model.activeTabList === 2) {
          $scope.Model.list.jobs.setDataAppend(job);
          $scope.Model.allItems.push(job);
        }
      }
      delete job.isNew;
      $scope.Model.activeTab = undefined;
    } else if (
      job.isJobOverdue($rootScope.CurrentTimeZone()) ||
      job.isJobDue($rootScope.CurrentTimeZone()) ||
      job.isPinned
    ) {
      if (iIdx > -1) {
        $scope.Model.importantItems.splice(iIdx, 1);
        $scope.Model.importantItems.splice(iIdx, 0, job);
      } else {
        $scope.Model.importantItems.push(job);
      }
      if ($scope.Model.activeTabList === 0) {
        $scope.Model.list.ticket.removeData(job);
        if (aIdx > -1) {
          $scope.Model.allItems.splice(aIdx, 1);
        }
      }
      if ($scope.Model.activeTabList === 2) {
        $scope.Model.list.jobs.removeData(job);
        if (aIdx > -1) {
          $scope.Model.allItems.splice(aIdx, 1);
        }
      }
    } else {
      if (iIdx > -1) {
        $scope.Model.importantItems.splice(iIdx, 1);
      }
      if ($scope.Model.activeTabList !== 0 && $scope.Model.activeTabList !== 2) {
        $scope.Model.allItems.push(job);
        $scope.Model.availableJobs.push(job);
      }
      if ($scope.Model.activeTabList === 0) {
        if (nIdx > -1) {
          $scope.Model.availableJobs.splice(nIdx, 1);
          $scope.Model.availableJobs.splice(nIdx, 0, job);
        }
        if (aIdx > -1) {
          $scope.Model.list.ticket.setDataReplace(job);
        } else {
          $scope.Model.list.ticket.setDataAppend(job);
        }
      }
      if ($scope.Model.activeTabList === 2) {
        if (nIdx > -1) {
          $scope.Model.list.jobs.setDataReplace(job);
        } else {
          $scope.Model.list.jobs.setDataAppend(job);
        }
        if (aIdx > -1) {
          $scope.Model.allItems.splice(aIdx, 1);
          $scope.Model.allItems.splice(aIdx, 0, job);
        } else {
          $scope.Model.allItems.push(job);
        }
      }
    }
    if (job.isCompleted) {
      $timeout(() => {
        if (
          job.isJobOverdue($rootScope.CurrentTimeZone()) ||
          job.isJobDue($rootScope.CurrentTimeZone()) ||
          job.isPinned
        ) {
          if (iIdx > -1) {
            $scope.Model.importantItems.splice(iIdx, 1);
          }
        } else {
          if ($scope.Model.activeTabList !== 0 && $scope.Model.activeTabList !== 2) {
            $scope.Model.allItems.splice(aIdx, 1);
            $scope.Model.availableJobs.splice(nIdx, 1);
          }
          if ($scope.Model.activeTabList === 0) {
            $scope.Model.list.ticket.removeData(job);
            if (nIdx > -1) {
              $scope.Model.availableJobs.splice(nIdx, 1);
            }
          }
          if ($scope.Model.activeTabList === 2) {
            $scope.Model.list.jobs.removeData(job);
            if (aIdx > -1) {
              $scope.Model.allItems.splice(aIdx, 1);
            }
          }
        }
        $scope.Model.isJobReady = false;
        loadJobs();
      }, 5000);
    }
  };

  $scope.jobDelete = ($event, data) => {
    $event.stopPropagation();
    jobsService.clearCache();
    const selectedJobs = data ? [data] : $scope.Model.list.jobs.getSelected();
    const deleteTimeout = $timeout(() => {
      for (let j = 0; j < selectedJobs.length; j += 1) {
        const selectedJob = selectedJobs[j];
        const iIdx = helperService.findIndexById($scope.Model.importantItems, selectedJob.id);
        const nIdx = helperService.findIndexById($scope.Model.availableJobs, selectedJob.id);
        const aIdx = helperService.findIndexById($scope.Model.allItems, selectedJob.id);

        if (iIdx > -1) {
          $scope.Model.importantItems.splice(iIdx, 1);
        }
        if ($scope.Model.activeTabList !== 0 && $scope.Model.activeTabList !== 2) {
          if (aIdx > -1) {
            $scope.Model.allItems.splice(aIdx, 1);
          }
          if (nIdx > -1) {
            $scope.Model.availableJobs.splice(nIdx, 1);
          }
        }
        if ($scope.Model.activeTabList === 0) {
          if (aIdx > -1) {
            $scope.Model.list.ticket.removeData(selectedJob);
          }
          if (nIdx > -1) {
            $scope.Model.availableJobs.splice(nIdx, 1);
          }
        }
        if ($scope.Model.activeTabList === 2) {
          if (nIdx > -1) {
            $scope.Model.list.jobs.removeData(selectedJob);
          }
          if (aIdx > -1) {
            $scope.Model.allItems.splice(aIdx, 1);
          }
        }
        jobService.deleteJob({ id: selectedJob.id });
      }
      $timeout(() => {
        $scope.Model.list.hasJobSelection = false;
        if ($scope.Model.activeTabList === 2) {
          $scope.Model.list.jobs.deselectedData($scope.Model.list.jobs.getSelected());
        }
        loadJobs();
      });
    }, 5250);
    uiService
      .toast({
        text: {
          p1: selectedJobs.length.formatWithoutCurrency(),
          p2: 'selected task(s) will be',
          p3: 'deleted'
        },
        warn: true,
        action: 'UNDO'
      })
      .then((action) => {
        if (action) {
          $timeout.cancel(deleteTimeout);
          uiService.toast({
            text: {
              p1: selectedJobs.length.formatWithoutCurrency(),
              p2: 'selected task(s) deletion',
              p3: 'undone'
            }
          });
          $scope.Model.list.hasJobSelection = false;
          $scope.Model.list.attachments.deselectedData(
            $scope.Model.list.attachments.getSelected()
          );
        }
      });
  };

  $scope.jobDuplicate = () => {
    jobsService.clearCache();
    actionService.duplicateDocuments(
      $scope.Model.list.jobs.getSelected(),
      jobService.readJob,
      jobService.createJob,
      $scope.Model.list.jobs.setDataAppend,
      'name',
      ' copy',
      'job(s)'
    );
  };

  $scope.jobComplete = () => {
    $scope.jobToggle($scope.Model.list.jobs.getSelected());
  };

  $scope.jobUncomplete = () => {
    $scope.jobToggle($scope.Model.list.jobs.getSelected());
  };

  $scope.jobToggled = (job) => {
    $timeout(() => {
      const iIdx = helperService.findIndexById($scope.Model.importantItems, job.id);
      const nIdx = helperService.findIndexById($scope.Model.availableJobs, job.id);
      const aIdx = helperService.findIndexById($scope.Model.allItems, job.id);
      if (
        job.isJobOverdue($rootScope.CurrentTimeZone()) ||
        job.isJobDue($rootScope.CurrentTimeZone()) ||
        job.isPinned
      ) {
        if (iIdx > -1) {
          $scope.Model.importantItems.splice(iIdx, 1);
        } else {
          $scope.Model.importantItems.push(job);
        }
        if ($scope.Model.activeTabList !== 0 && $scope.Model.activeTabList !== 2) {
          if (aIdx > -1) {
            $scope.Model.allItems.splice(aIdx, 1);
          }
          if (nIdx > -1) {
            $scope.Model.availableJobs.splice(nIdx, 1);
          }
        }
        if ($scope.Model.activeTabList === 0) {
          $scope.Model.list.ticket.removeData(job);
          if (nIdx > -1) {
            $scope.Model.availableJobs.splice(nIdx, 1);
          }
        }
        if ($scope.Model.activeTabList === 2) {
          $scope.Model.list.jobs.removeData(job);
          if (aIdx > -1) {
            $scope.Model.allItems.splice(aIdx, 1);
          }
        }
      } else {
        if (iIdx > -1) {
          $scope.Model.importantItems.splice(iIdx, 1);
        }
        if ($scope.Model.activeTabList !== 0 && $scope.Model.activeTabList !== 2) {
          if (aIdx > -1) {
            $scope.Model.allItems.splice(aIdx, 1);
            $scope.Model.allItems.splice(aIdx, 0, job);
          } else {
            $scope.Model.allItems.push(job);
          }
          if (nIdx > -1) {
            $scope.Model.availableJobs.splice(nIdx, 1);
            $scope.Model.availableJobs.splice(nIdx, 0, job);
          } else {
            $scope.Model.availableJobs.push(job);
          }
        }
        if ($scope.Model.activeTabList === 0) {
          if (nIdx > -1) {
            $scope.Model.availableJobs.splice(nIdx, 1);
            $scope.Model.availableJobs.splice(nIdx, 0, job);
          } else {
            $scope.Model.availableJobs.push(job);
          }
          if (aIdx > -1) {
            $scope.Model.list.ticket.setDataReplace(job);
          } else {
            $scope.Model.list.ticket.setDataAppend(job);
          }
        }
        if ($scope.Model.activeTabList === 2) {
          if (nIdx > -1) {
            $scope.Model.list.jobs.setDataReplace(job);
          } else {
            $scope.Model.list.jobs.setDataAppend(job);
          }
          if (aIdx > -1) {
            $scope.Model.allItems.splice(aIdx, 1);
            $scope.Model.allItems.splice(aIdx, 0, job);
          } else {
            $scope.Model.allItems.push(job);
          }
        }
      }
      $scope.Model.isJobReady = false;
      loadJobs();
    }, 5000);
  };

  $scope.jobToggle = (jobs) => {
    jobsService.clearCache();
    const selectedJobs = jobs instanceof Array ? jobs : [jobs];
    for (let j = 0; j < selectedJobs.length; j += 1) {
      const selectedJob = selectedJobs[j];
      selectedJob.isCompleted = !selectedJob.isCompleted;
      jobService.updateJob({
        id: selectedJob.id,
        isCompleted: selectedJob.isCompleted,
        jobProgress: selectedJob.isCompleted
          ? $scope.Model.availableJobProgresses[2]
          : $scope.Model.availableJobProgresses[0]
      });
      $scope.jobToggled(selectedJob);
    }
  };

  $scope.jobLabelsSelect = ($event, job) => {
    eventService.dialogLabelSelect({
      event: $event,
      labels: $scope.Model.availableJobLabels,
      selectedLabels: job.idLabels,
      data: job
    });
  };

  $scope.listJobChange = (list, data, isSelected) => {
    $scope.Model.list.hasJobSelection = isSelected || list.isSelectedAny();
  };

  $scope.listJobReady = (list) => {
    $scope.Model.list.jobs = list;
  };

  $scope.toggleJobsList = (isJobCompleted) => {
    $scope.Model.list.isJobCompleted = isJobCompleted;
    jobsService.clearCache();
    loadJobs();
  };

  /*
   * Ticket view ~ List attachments events
   * --------------------------------------------------------------------------------
   */
  $scope.pdfDocumentCreated = () => {
    notesService.clearCache();
    $scope.cancelledAdding();
    loadNotes().then(() => {
      loadAttachments();
      $timeout(() => {
        $scope.toggleTabList(3);
      });
    });
  };

  $scope.createPdf = (pdfType) => {
    if ($scope.hasAssetFinanceTools()) {
      if (pdfType === $scope.Model.availablePdfTypes[0]) {
        pdfService
          .createPdf({
            contacts: $scope.Model.ticketClients,
            contactLabels: $scope.Model.availableContactLabels,
            lenders: $scope.Model.availableLendersPerCountry,
            ticket: $scope.Model.currentTicket,
            ticketOwner: $scope.Model.currentTicketOwner,
            loan: $scope.Model.currentAssetFinance,
            workflow: $scope.Model.currentWorkflow,
            pdfType,
            isView: false
          })
          .then(() => {
            $scope.pdfDocumentCreated();
          });
      }
      if (pdfType === $scope.Model.availablePdfTypes[1]) {
        pdfService
          .createPdf({
            contacts: $scope.Model.ticketClients,
            contactLabels: $scope.Model.availableContactLabels,
            lenders: $scope.Model.availableLendersPerCountry,
            ticket: $scope.Model.currentTicket,
            ticketOwner: $scope.Model.currentTicketOwner,
            loan: $scope.Model.currentAssetFinance,
            workflow: $scope.Model.currentWorkflow,
            pdfType,
            isView: false
          })
          .then(() => {
            $scope.pdfDocumentCreated();
          });
      }
      if (pdfType === $scope.Model.availablePdfTypes[7]) {
        pdfService
          .createPdf({
            contacts: $scope.Model.ticketClients,
            financeProposal: $scope.Model.currentAssetFinance?.financeProposal || {},
            ticket: $scope.Model.currentTicket,
            pdfType,
            isView: false
          })
          .then(() => {
            $scope.pdfDocumentCreated();
          });
      }
      if (pdfType === $scope.Model.availablePdfTypes[8]) {
        pdfService
          .createPdf({
            lenders: $scope.Model.availableLenders,
            documents: $scope.Model.availableLendersDocuments,
            ticket: $scope.Model.currentTicket,
            ticketOwner: $scope.Model.currentTicketOwner,
            loan: $scope.Model.currentAssetFinance,
            workflow: $scope.Model.currentWorkflow,
            pdfType,
            isView: false
          })
          .then(() => {
            $scope.pdfDocumentCreated();
          });
      }
    }
    if ($scope.hasHomeLoanTools()) {
      if (pdfType === $scope.Model.availablePdfTypes[0]) {
        pdfService
          .createPdf({
            contacts: $scope.Model.ticketClients,
            contactLabels: $scope.Model.availableContactLabels,
            lenders: $scope.Model.availableLendersPerCountry,
            ticket: $scope.Model.currentTicket,
            ticketOwner: $scope.Model.currentTicketOwner,
            loan: $scope.Model.currentHomeLoan,
            workflow: $scope.Model.currentWorkflow,
            pdfType,
            isView: false
          })
          .then(() => {
            $scope.pdfDocumentCreated();
          });
      }
      if (pdfType === $scope.Model.availablePdfTypes[2]) {
        pdfService
          .createPdf({
            fundingWorksheets: $scope.Model.currentHomeLoan?.fundingWorksheets || {},
            homeLoanSecurities:
              $scope.Model.currentHomeLoan?.securityDetails?.securitySplits || [],
            ticket: $scope.Model.currentTicket,
            pdfType,
            isView: false
          })
          .then(() => {
            $scope.pdfDocumentCreated();
          });
      }
      if (pdfType === $scope.Model.availablePdfTypes[3]) {
        const selectedLenders = _.filter(
          $scope.Model.availableLenders || [],
          (l) =>
            _.indexOf($scope.Model.currentHomeLoan?.maximumBorrowing?.idLenders, l?.id) > -1
        );
        $scope.getMaximumBorrowing().then(() => {
          pdfService
            .createPdf({
              maximumBorrowing: $scope.Model.maximumBorrowing,
              lenders: $scope.Model.availableLendersPerCountry,
              filteredLenders: selectedLenders,
              documents: $scope.Model.availableLendersDocuments,
              contacts: $scope.Model.availablePersonOnlyClients,
              spouses: $scope.Model.availableSpouses,
              ticket: $scope.Model.currentTicket,
              pdfType,
              isView: false
            })
            .then(() => {
              $timeout(() => {
                $scope.pdfDocumentCreated();
              });
            });
        });
      }
      if (pdfType === $scope.Model.availablePdfTypes[4]) {
        pdfService
          .createPdf({
            compareProducts: $scope.Model.currentHomeLoan?.compareProducts || [],
            reviewProducts: $scope.Model.currentHomeLoan?.reviewProducts || [],
            lenders: $scope.Model.availableLenders || [],
            documents: $scope.Model.availableLendersDocuments || [],
            fundingWorksheets: $scope.Model.currentHomeLoan?.fundingWorksheets || {},
            searchFields: $scope.Model.currentHomeLoan?.searchFields || {},
            ticket: $scope.Model.currentTicket,
            pdfType,
            isView: false
          })
          .then(() => {
            $scope.pdfDocumentCreated();
          });
      }
      if (pdfType === $scope.Model.availablePdfTypes[5]) {
        pdfService
          .createPdf({
            refinanceAnalysis: $scope.Model.currentHomeLoan?.refinanceAnalysis,
            ticket: $scope.Model.currentTicket,
            pdfType,
            isView: false
          })
          .then(() => {
            $scope.pdfDocumentCreated();
          });
      }
    }
  };

  $scope.attachmentEdited = (attachments) => {
    ticketsService.clearCache();
    if (attachments && attachments.length) {
      const isNew = attachments.find((a) => a.isNew);
      for (let a = 0; a < attachments.length; a += 1) {
        const attachment = attachments[a];
        const nIdx = helperService.findIndexById(
          $scope.Model.availableAttachments,
          attachment.id
        );
        const aIdx = helperService.findIndexById($scope.Model.allItems, attachment.id);
        if ($scope.Model.activeTabList === 0) {
          if (isNew) {
            $scope.Model.list.ticket.setDataAppend(attachment);
            $scope.Model.availableAttachments.push(attachment);
          } else {
            if (aIdx > -1) {
              $scope.Model.list.ticket.setDataReplace(attachment);
            }
            if (nIdx > -1) {
              $scope.Model.availableAttachments.splice(nIdx, 1);
              $scope.Model.availableAttachments.splice(nIdx, 0, attachment);
            }
          }
        }
        if ($scope.Model.activeTabList === 3) {
          if (isNew) {
            $scope.Model.list.attachments.setDataAppend(attachment);
            $scope.Model.allItems.push(attachment);
          } else {
            if (nIdx > -1) {
              $scope.Model.list.attachments.setDataReplace(attachment);
            }
            if (aIdx > -1) {
              $scope.Model.allItems.splice(aIdx, 1);
              $scope.Model.allItems.splice(aIdx, 0, attachment);
            }
          }
        }
        if ($scope.Model.activeTabList !== 0 && $scope.Model.activeTabList !== 3) {
          if (isNew !== undefined) {
            $scope.Model.availableAttachments.push(attachment);
            $scope.Model.allItems.push(attachment);
          } else {
            if (nIdx > -1) {
              $scope.Model.availableAttachments.splice(nIdx, 1);
              $scope.Model.availableAttachments.splice(nIdx, 0, attachment);
            }
            if (aIdx > -1) {
              $scope.Model.allItems.splice(aIdx, 1);
              $scope.Model.allItems.splice(aIdx, 0, attachment);
            }
          }
        }
        delete attachment.isNew;
        $scope.Model.currentTicket.attachments.push(attachment);
      }
      $scope.saveTicket({ attachments: $scope.Model.currentTicket.attachments });
      $timeout(() => {
        loadAttachments();
        $scope.toggleTabList(3);
      });
    } else {
      uiService.toast({
        text: {
          p1: 'There',
          p2: 'are no',
          p3: 'files'
        },
        warn: true
      });
    }
  };

  $scope.toggleCombinePdf = () => {
    if ($scope.Model.list.attachments.getSelectedCount()) {
      $scope.Model.list.attachments.deselectedData($scope.Model.list.attachments.getSelected());
    }
  };

  $scope.isThereAnyPdfAttachment = () => {
    let total = 0;
    const len = $scope.Model?.availableAttachments?.length || 0;
    for (let a = 0; a < len; a += 1) {
      const attachment = $scope.Model.availableAttachments[a];
      if (attachment?.getFileExtension()?.toLowerCase() === 'pdf') {
        total += 1;
      }
    }
    return total >= 2;
  };

  $scope.attachmentPdfCombine = ($event) => {
    $event.stopPropagation();
    const attachments = $scope.Model.list.attachments.getSelected();
    if (attachments?.length && $scope.Model.currentTicket?.id) {
      documentsService
        .combinePdf({ idTicket: $scope.Model.currentTicket.id, documents: attachments })
        .then((response) => {
          if (response?.status) {
            $scope.Model.list.isCombinePdfSelected = false;
            $scope.Model.isAttachmentsReady = false;
            loadNotes().then(() => {
              const idAccounts = $scope.collectIdAccounts();
              loadAccounts(idAccounts).then(() => {
                loadAttachments();
                $timeout(() => {
                  if ($scope.Model.activeTabList === 3) {
                    $scope.Model.list.hasAttachmentSelection = false;
                    if ($scope.Model.list && $scope.Model.list.attachments) {
                      $scope.Model.list.attachments.deselectedData(
                        $scope.Model.list.attachments.getSelected()
                      );
                    }
                  }
                  $timeout(() => {
                    $scope.toggleTabList(3);
                  });
                });
              });
            });
          } else if (!response?.status && response?.size) {
            uiService.toast({
              text: {
                p1: 'The total of selected documents',
                p2: 'size exceed',
                p3: 'the limit of 25MB'
              },
              warn: true
            });
          } else {
            uiService.toast({
              text: {
                p1: 'PDF combine request',
                p2: 'preparation',
                p3: 'has failed'
              },
              warn: true
            });
          }
        });
    }
  };

  $scope.attachmentMerge = (status) => {
    notesService.clearCache();
    if (status) {
      $scope.Model.isAttachmentsReady = false;
      loadNotes().then(() => {
        const idAccounts = $scope.collectIdAccounts();
        loadAccounts(idAccounts).then(() => {
          $timeout(() => {
            if ($scope.Model.activeTabList === 3) {
              $scope.Model.list.hasAttachmentSelection = false;
              if ($scope.Model.list && $scope.Model.list.attachments) {
                $scope.Model.list.attachments.deselectedData(
                  $scope.Model.list.attachments.getSelected()
                );
              }
            }
            loadAttachments();
            $timeout(() => {
              $scope.toggleTabList(3);
            });
          });
        });
      });
    }
  };

  $scope.attachmentRequestSignature = ($event, attachment, type, isNonEmbedded) => {
    $event.stopPropagation();
    $mdDialog
      .show({
        targetEvent: $event,
        locals: {
          clients: $scope.Model.ticketClients.filter((c) => c.getEmail() !== ''),
          contacts: $scope.Model.ticketContacts.filter((c) => c.getEmail() !== ''),
          accounts: $scope.Model.availableAccounts,
          idOwner: $scope.Model.currentTicket.idOwner
        },
        template: templateTicketSignatureRequest,
        controllerAs: '$ctrl',
        controller(clients, contacts, accounts, idOwner) {
          const ctrl = this;
          ctrl.idClients = [];
          ctrl.idContacts = [];
          ctrl.idAccounts = [];
          ctrl.attachment = attachment;
          ctrl.clients = clients;
          ctrl.contacts = contacts;
          ctrl.accounts = accounts;
          ctrl.idOwner = idOwner;
          ctrl.currentTimeZone = $rootScope.CurrentTimeZone();
          ctrl.currentLocale = $rootScope.CurrentLocale();
          ctrl.idClients = _.map(ctrl.clients, 'id');
          ctrl.confirm = () => {
            if (
              (ctrl.idClients && ctrl.idClients.length) ||
              (ctrl.idContacts && ctrl.idContacts.length) ||
              (ctrl.idAccounts && ctrl.idAccounts.length)
            ) {
              $mdDialog.hide({
                idClients: ctrl.idClients,
                idContacts: ctrl.idContacts,
                idAccounts: ctrl.idAccounts,
                attachment: ctrl.attachment,
                type,
                isNonEmbedded
              });
            } else {
              uiService.toast({
                text: {
                  p1: 'One or more',
                  p2: 'person(s)',
                  p3: 'must be selected'
                },
                warn: true
              });
            }
          };
          ctrl.cancel = () => {
            $mdDialog.cancel();
          };
        }
      })
      .then((result) => {
        const data = result;
        uiService.toast({
          text: {
            p1: 'Signature(s) request',
            p2: 'is being prepared',
            p3: 'please wait'
          },
          progress: true,
          warn: true,
          delay: 60000
        });
        data.idTicket = $scope.Model.currentTicket.id;
        attachmentsService.signatureRequest(data).then((res) => {
          if (!res.status) {
            const alert = helperService.errorsAlert({
              errors: res?.errors || [],
              errorMessage: res?.errorMessage || '',
              title: data?.type?.capitalizeFirstLetter()
            });
            eventService.alertDialog({ alert });
          } else if (data?.isNonEmbedded) {
            uiService.toast({
              text: {
                p1: 'Signature(s) request',
                p2: 'has been',
                p3: 'successfully sent'
              },
              success: true
            });
          } else {
            uiService.toast({
              text: {
                p1: 'Signature(s) request',
                p2: 'editor',
                p3: 'will open momentarily'
              }
            });
            eventService.dialogESign({ event: $event, url: res.url });
          }
        });
      });
  };

  $scope.attachmentBulkDownload = ($event) => {
    $event.stopPropagation();
    const attachments = $scope.Model.list.attachments.getSelected();
    const hasVideo = _.some(
      attachments,
      (a) => a.idNote !== undefined && a.idNote !== '' && a.noteType === 'video'
    );
    if (!hasVideo) {
      uiService.toast({
        text: {
          p1: 'Preparing file(s)',
          p2: 'for download',
          p3: 'this can take a while ...'
        },
        progress: true
      });
      fileFactory.bulkDownload({
        url: TICKET.API.BULK_DOWNLOAD,
        name: $scope.Model.currentTicket.getName(),
        attachments
      });
    } else {
      uiService.toast({
        text: {
          p1: 'Video files',
          p2: 'are unsupported',
          p3: 'in bulk download ...'
        },
        warn: true
      });
    }
  };

  $scope.attachmentDownload = ($event, attachment) => {
    $event.stopPropagation();
    if (attachment.idNote !== undefined && attachment.idNote !== '') {
      if (attachment.noteType.name !== 'video') {
        fileFactory
          .getDownloadUrl({
            url: NOTE.API.DOWNLOAD,
            file: attachment.file,
            name: attachment.name
          })
          .then((downloadUrl) => {
            fileFactory.download(downloadUrl);
          });
      } else {
        fileFactory
          .getDownloadVideoUrl({
            url: NOTE.API.DOWNLOAD_VIDEO,
            idAttachment: attachment.id,
            file: attachment.file,
            name: attachment.name
          })
          .then((downloadUrl) => {
            fileFactory.download(downloadUrl);
          });
      }
    } else {
      fileFactory
        .getDownloadUrl({
          url: TICKET.API.DOWNLOAD,
          file: attachment.file,
          name: attachment.name
        })
        .then((downloadUrl) => {
          fileFactory.download(downloadUrl);
        });
    }
  };

  $scope.attachmentDownloadPdf = ($event, attachment) => {
    $event.stopPropagation();
    if (attachment.idNote !== undefined && attachment.idNote !== '') {
      if (attachment.noteType.name !== 'video') {
        fileFactory
          .getDownloadUrl({
            url: NOTE.API.DOWNLOAD_PDF,
            file: attachment.file,
            name: attachment.name
          })
          .then((downloadUrl) => {
            fileFactory.download(downloadUrl, true);
          });
      } else {
        uiService.toast({
          text: {
            p1: 'File',
            p2: attachment.getName(),
            p3: 'cannot be downloaded as PDF'
          }
        });
      }
    } else {
      fileFactory
        .getDownloadUrl({
          url: TICKET.API.DOWNLOAD_PDF,
          file: attachment.file,
          name: attachment.name
        })
        .then((downloadUrl) => {
          fileFactory.download(downloadUrl, true);
        });
    }
  };

  $scope.attachmentPreview = ($event, attachment) => {
    eventService.filePreview({
      event: $event,
      file: attachment,
      type: attachment?.idNote ? 'notes' : 'deals'
    });
  };

  $scope.attachmentRedactTFN = ($event, attachment) => {
    $event.stopPropagation();
    $mdDialog
      .show({
        targetEvent: $event,
        template: templateRedactDocument,
        controllerAs: '$ctrl',
        controller() {
          const self = this;
          self.confirm = () => {
            $mdDialog.hide(attachment);
          };
          self.cancel = () => {
            $mdDialog.cancel();
          };
        }
      })
      .then((a) => {
        if (a) {
          uiService.toast({
            text: {
              p1: 'TFN redaction',
              p2: 'in document(s)',
              p3: 'is in progress'
            },
            progress: true
          });
          attachmentsService
            .redactTFN({ idTicket: $scope.Model.currentTicket.id, attachment: a })
            .then((res) => {
              if (!res.status) {
                const alert = helperService.errorsAlert({
                  errors: res?.errors || [],
                  errorMessage: res?.errorMessage || '',
                  title: 'TFN redact'
                });
                eventService.alertDialog({ alert });
              } else {
                uiService.toast({
                  text: {
                    p1: 'TFN redaction',
                    p2: 'in document(s)',
                    p3: 'has finished'
                  }
                });
                uiService.scopeApply(() => {
                  notesService.clearCache();
                  ticketsService.clearCache();
                  initialize();
                }, 100);
              }
            });
        }
      });
  };

  $scope.attachmentShareClient = ($event, attachmentToShare) => {
    $event.stopPropagation();
    const attachment = attachmentToShare;
    if (attachment.idNote !== undefined && attachment.idNote !== '') {
      const note = $scope.getNote(attachment.idNote);
      for (let n = 0; n < note.attachments.length; n += 1) {
        if (note.attachments[n].id === attachment.id) {
          note.attachments[n].isShared = !note.attachments[n].isShared;
          attachment.isShared = note.attachments[n].isShared;
        }
      }
      noteService.updateNote(note).then((result) => {
        if (result.status) {
          uiService.toast({
            text: {
              p1: 'File',
              p2: attachment.getName(),
              p3: attachment.isShared ? 'has been shared' : 'has been unshared'
            }
          });
        }
      });
    } else {
      for (let n = 0; n < $scope.Model.currentTicket.attachments.length; n += 1) {
        if ($scope.Model.currentTicket.attachments[n].id === attachment.id) {
          $scope.Model.currentTicket.attachments[n].isShared =
            !$scope.Model.currentTicket.attachments[n].isShared;
          attachment.isShared = $scope.Model.currentTicket.attachments[n].isShared;
        }
      }
      ticketService
        .updateTicket({
          id: $scope.Model.currentTicket.id,
          attachments: $scope.Model.currentTicket.attachments
        })
        .then((result) => {
          if (result.status) {
            uiService.toast({
              text: {
                p1: 'File',
                p2: attachment.getName(),
                p3: attachment.isShared ? 'has been shared' : 'has been unshared'
              }
            });
          }
        });
    }
  };

  $scope.attachmentSharePartner = ($event, attachmentToShare) => {
    $event.stopPropagation();
    const attachment = attachmentToShare;
    if (attachment.idNote !== undefined && attachment.idNote !== '') {
      const note = $scope.getNote(attachment.idNote);
      for (let n = 0; n < note.attachments.length; n += 1) {
        if (note.attachments[n].id === attachment.id) {
          note.attachments[n].isSharedPartner = !note.attachments[n].isSharedPartner;
          attachment.isSharedPartner = note.attachments[n].isSharedPartner;
        }
      }
      noteService.updateNote(note).then((result) => {
        if (result.status) {
          uiService.toast({
            text: {
              p1: 'File',
              p2: attachment.getName(),
              p3: attachment.isSharedPartner ? 'has been shared' : 'has been unshared'
            }
          });
        }
      });
    } else {
      for (let n = 0; n < $scope.Model.currentTicket.attachments.length; n += 1) {
        if ($scope.Model.currentTicket.attachments[n].id === attachment.id) {
          $scope.Model.currentTicket.attachments[n].isSharedPartner =
            !$scope.Model.currentTicket.attachments[n].isSharedPartner;
          attachment.isSharedPartner =
            $scope.Model.currentTicket.attachments[n].isSharedPartner;
        }
      }
      ticketService
        .updateTicket({
          id: $scope.Model.currentTicket.id,
          attachments: $scope.Model.currentTicket.attachments
        })
        .then((result) => {
          if (result.status) {
            uiService.toast({
              text: {
                p1: 'File',
                p2: attachment.getName(),
                p3: attachment.isSharedPartner ? 'has been shared' : 'has been unshared'
              }
            });
          }
        });
    }
  };

  $scope.attachmentLock = ($event, attachmentToLock) => {
    $event.stopPropagation();
    const attachment = attachmentToLock;
    if (attachment.idNote !== undefined && attachment.idNote !== '') {
      const note = $scope.getNote(attachment.idNote);
      const noteAttachment = _.find(note.attachments, (a) => a.id === attachment.id);
      if (noteAttachment && noteAttachment.id) {
        noteAttachment.isLocked = !noteAttachment.isLocked;
        attachment.isLocked = noteAttachment.isLocked;
        noteService.updateNote(note).then((result) => {
          if (result.status) {
            uiService.toast({
              text: {
                p1: 'File',
                p2: attachment.getName(),
                p3: attachment.isLocked ? 'has been locked' : 'has been unlocked'
              }
            });
          }
        });
      }
    } else {
      const ticketAttachment = _.find(
        $scope.Model.currentTicket.attachments,
        (a) => a.id === attachment.id
      );
      if (ticketAttachment && ticketAttachment.id) {
        ticketAttachment.isLocked = !ticketAttachment.isLocked;
        attachment.isLocked = ticketAttachment.isLocked;
        ticketService
          .updateTicket({
            id: $scope.Model.currentTicket.id,
            attachments: $scope.Model.currentTicket.attachments
          })
          .then((result) => {
            if (result.status) {
              uiService.toast({
                text: {
                  p1: 'File',
                  p2: attachment.getName(),
                  p3: attachment.isLocked ? 'has been locked' : 'has been unlocked'
                }
              });
            }
          });
      }
    }
  };

  $scope.attachmentPin = ($event, attachmentToPin) => {
    $event.stopPropagation();
    const attachment = attachmentToPin;
    if (attachment.idNote !== undefined && attachment.idNote !== '') {
      const note = $scope.getNote(attachment.idNote);
      const noteAttachment = _.find(note.attachments, (a) => a.id === attachment.id);
      if (noteAttachment && noteAttachment.id) {
        noteAttachment.isPinned = !attachment.isPinned;
        noteService.updateNote(note);
      }
    } else {
      const ticketAttachment = _.find(
        $scope.Model.currentTicket.attachments,
        (a) => a.id === attachment.id
      );
      if (ticketAttachment && ticketAttachment.id) {
        ticketAttachment.isPinned = !attachment.isPinned;
        ticketService.updateTicket({
          id: $scope.Model.currentTicket.id,
          attachments: $scope.Model.currentTicket.attachments
        });
      }
    }
  };

  $scope.attachmentRename = ($event, data) => {
    eventService.attachmentRename({
      event: $event || null,
      attachment: data
    });
  };

  $scope.attachmentRenamed = (attachment) => {
    if (attachment.idNote !== undefined && attachment.idNote !== '') {
      const note = $scope.getNote(attachment.idNote);
      const noteAttachment = _.find(note.attachments, (a) => a.id === attachment.id);
      if (noteAttachment && noteAttachment.id) {
        noteAttachment.name = attachment.name;
        noteService.updateNote(note);
      }
    } else {
      const ticketAttachment = _.find(
        $scope.Model.currentTicket.attachments,
        (a) => a.id === attachment.id
      );
      if (ticketAttachment && ticketAttachment.id) {
        ticketAttachment.name = attachment.name;
        ticketService.updateTicket({
          id: $scope.Model.currentTicket.id,
          attachments: $scope.Model.currentTicket.attachments
        });
      }
    }
    $timeout(() => {
      $scope.Model.list.hasAttachmentSelection = false;
      $scope.Model.list.attachments.deselectedData($scope.Model.list.attachments.getSelected());
      loadAttachments();
    });
  };

  $scope.attachmentDelete = ($event, attachment) => {
    $event.stopPropagation();
    let selectedAttachments = [];
    if (attachment && !attachment.isLocked) {
      selectedAttachments.push(attachment);
    } else {
      const filteredSelectedAttachments = _.filter(
        $scope.Model.list.attachments.getSelected(),
        (a) => !a.isLocked
      );
      selectedAttachments = filteredSelectedAttachments;
    }
    if (selectedAttachments.length) {
      const deleteTimeout = $timeout(() => {
        for (let a = 0; a < selectedAttachments.length; a += 1) {
          const selectedAttachment = selectedAttachments[a];
          if (selectedAttachment.idNote !== undefined) {
            const note = $scope.getNote(selectedAttachment.idNote);
            note.attachments.splice(note.attachments.indexOf(selectedAttachment), 1);
            noteService.updateNote(note);
          } else {
            const idx = helperService.findIndexById(
              $scope.Model.currentTicket.attachments,
              selectedAttachment.id
            );
            $scope.Model.currentTicket.attachments.splice(idx, 1);
            ticketService.updateTicket({
              id: $scope.Model.currentTicket.id,
              attachments: $scope.Model.currentTicket.attachments
            });
          }

          const nIdx = helperService.findIndexById(
            $scope.Model.availableAttachments,
            selectedAttachment.id
          );
          const aIdx = helperService.findIndexById(
            $scope.Model.allItems,
            selectedAttachment.id
          );
          if ($scope.Model.activeTabList === 0) {
            if (aIdx > -1) {
              $scope.Model.list.ticket.removeData(selectedAttachment);
            }
            if (nIdx > -1) {
              $scope.Model.availableAttachments.splice(nIdx, 1);
            }
          }
          if ($scope.Model.activeTabList === 3) {
            if (nIdx > -1) {
              $scope.Model.list.attachments.removeData(selectedAttachment);
            }
            if (aIdx > -1) {
              $scope.Model.allItems.splice(aIdx, 1);
            }
          }
        }
        $timeout(() => {
          if ($scope.Model.activeTabList === 3) {
            $scope.Model.list.hasAttachmentSelection = false;
            $scope.Model.list.attachments.deselectedData(
              $scope.Model.list.attachments.getSelected()
            );
          }
          loadAttachments();
        });
      }, 5250);
      uiService
        .toast({
          text: {
            p1: selectedAttachments.length.formatWithoutCurrency(),
            p2: 'selected file(s) will be',
            p3: 'deleted'
          },
          warn: true,
          action: 'UNDO'
        })
        .then((action) => {
          if (action) {
            $timeout.cancel(deleteTimeout);
            uiService.toast({
              text: {
                p1: selectedAttachments.length.formatWithoutCurrency(),
                p2: 'selected required document(s) deletion',
                p3: 'undone'
              }
            });
            $scope.Model.list.hasAttachmentSelection = false;
            $scope.Model.list.attachments.deselectedData(
              $scope.Model.list.attachments.getSelected()
            );
          }
        });
    } else {
      uiService.toast({
        text: {
          p1: 'Deleting',
          p2: 'is disabled for',
          p3: 'locked files'
        },
        warn: true
      });
    }
  };

  $scope.attachmentLabelsSelect = ($event, attachment) => {
    eventService.dialogLabelSelect({
      event: $event,
      labels: $scope.Model.availableFileLabels,
      selectedLabels: attachment.idLabels,
      data: attachment
    });
  };

  $scope.listAttachmentChange = (list, data, isSelected) => {
    $scope.Model.list.hasAttachmentSelection = isSelected || list.isSelectedAny();
  };

  $scope.listAttachmentReady = (list) => {
    $scope.Model.list.attachments = list;
  };

  $scope.isComplianceTypeExist = (typeName) => {
    const idLabels = _.uniq(_.flatten(_.map($scope.Model.availableAttachments, 'idLabels')));
    return _.some(idLabels, (l) =>
      $scope.getLabel(l) !== undefined
        ? $scope.getLabel(l).getName().toLowerCase() === typeName.toLowerCase()
        : false
    );
  };

  $scope.hasFeesAndCharges = () =>
    _.every(
      $scope?.Model?.currentHomeLoan?.compliance?.feesAndCharges,
      (fAC) => fAC.name !== '' && fAC.amount > 0 && fAC.feePayable !== ''
    );

  $scope.getSetAvailableComplianceTypes = () => {
    const idx = _.findIndex($scope.Model.availableComplianceTypes, (c) => c.id === 6);
    if (idx > -1) {
      $scope.Model.availableComplianceTypes[idx].isRequired = !$scope.hasFeesAndCharges();
      $scope.Model.availableComplianceTypes[idx].isRequiredForCompliance =
        !$scope.hasFeesAndCharges();
    }
  };

  /*
   * Ticket view ~ List checklists events
   * --------------------------------------------------------------------------------
   */
  $scope.checklistAdded = (checklists, isSingle) => {
    $scope.Model.isChecklistReady = false;
    if (isSingle) {
      $scope.Model.currentTicket.checklist.push(checklists);
      uiService.toast({
        text: {
          p1: 'Required document',
          p2: checklists.getName(),
          p3: 'has been added'
        }
      });
    } else {
      let countDocs = 0;
      for (let i = 0; i < checklists.length; i += 1) {
        for (let j = 0; j < checklists[i].items.length; j += 1) {
          const checklistItem = angular.copy(checklists[i].items[j]);
          checklistItem.id = _.uuid();
          checklistItem.timeStamp = dateTimeService.epoch();
          $scope.Model.currentTicket.checklist.push(checklistItem);
          countDocs += 1;
        }
      }
      uiService.toast({
        text: {
          p1: `${countDocs} required`,
          p2: 'documents',
          p3: 'have been added'
        }
      });
    }
    $timeout(() => {
      $scope.Model.isChecklistReady = true;
      $scope.Model.list.hasChecklistSelection = false;
      $scope.saveTicketByProperty($scope.Model.currentTicket.checklist, 'checklist');
    });
  };

  $scope.checklistItemEdit = ($event, checklistItemToEdit) => {
    $event.stopPropagation();
    $mdDialog
      .show({
        targetEvent: $event,
        locals: {
          checklistItem: checklistItemToEdit
            ? angular.copy(checklistItemToEdit)
            : ChecklistItem.blank(),
          isNew: !checklistItemToEdit
        },
        template: templateTicketEditChecklistItem,
        controllerAs: '$ctrl',
        controller(scope, checklistItem, isNew) {
          const ctrl = this;
          ctrl.currentTimeZone = $rootScope.CurrentTimeZone();
          ctrl.currentLocale = $rootScope.CurrentLocale();
          ctrl.checklistItem = checklistItem;
          ctrl.isNew = isNew;
          ctrl.confirm = () => {
            if (ctrl.checklistItem.name !== '') {
              $mdDialog.hide({ checklistItem: ctrl.checklistItem, isNew });
            } else {
              uiService.toast({
                text: {
                  p1: 'Required document',
                  p2: 'name',
                  p3: 'cannot be empty'
                },
                warn: true
              });
            }
          };
          ctrl.cancel = () => {
            $mdDialog.cancel();
          };
        }
      })
      .then((result) => {
        $scope.Model.isChecklistReady = false;
        if (result.isNew) {
          $scope.Model.currentTicket.checklist.push(result.checklistItem);
          $timeout(() => {
            $scope.Model.isChecklistReady = true;
          });
        } else {
          const idx = _.findIndex(
            $scope.Model.currentTicket.checklist,
            (c) => c.id === result.checklistItem.id
          );
          $timeout(() => {
            $scope.Model.currentTicket.checklist.splice(idx, 1);
            $scope.Model.currentTicket.checklist.push(result.checklistItem);
            $scope.Model.isChecklistReady = true;
          });
        }
        $timeout(() => {
          $scope.Model.list.hasChecklistSelection = false;
          $scope.saveTicketByProperty($scope.Model.currentTicket.checklist, 'checklist');
        });
      });
  };

  $scope.checklistItemDelete = ($event, data) => {
    $event.stopPropagation();
    const selectedChecklistItems = data ? [data] : $scope.Model.list.checklist.getSelected();
    const deleteTimeout = $timeout(() => {
      $scope.Model.isChecklistReady = false;
      for (let c = 0; c < selectedChecklistItems.length; c += 1) {
        $scope.Model.currentTicket.checklist.splice(
          $scope.Model.currentTicket.checklist.indexOf(selectedChecklistItems[c]),
          1
        );
      }
      $timeout(() => {
        $scope.Model.isChecklistReady = true;
        $scope.Model.list.hasChecklistSelection = false;
        $scope.Model.list.checklist.deselectedData($scope.Model.list.checklist.getSelected());
        $scope.saveTicketByProperty($scope.Model.currentTicket.checklist, 'checklist');
      });
    }, 5250);
    uiService
      .toast({
        text: {
          p1: selectedChecklistItems.length.formatWithoutCurrency(),
          p2: 'selected required document(s) will be',
          p3: 'deleted'
        },
        warn: true,
        action: 'UNDO'
      })
      .then((action) => {
        if (action) {
          $timeout.cancel(deleteTimeout);
          uiService.toast({
            text: {
              p1: selectedChecklistItems.length.formatWithoutCurrency(),
              p2: 'selected required document(s) deletion',
              p3: 'undone'
            }
          });
          $scope.Model.list.hasChecklistSelection = false;
          $scope.Model.list.checklist.deselectedData($scope.Model.list.checklist.getSelected());
        }
      });
  };

  $scope.checklistItemToggled = ($event, data) => {
    $event.stopPropagation();
    for (let c = 0; c < $scope.Model.currentTicket.checklist.length; c += 1) {
      if ($scope.Model.currentTicket.checklist[c].id === data.id) {
        $scope.Model.currentTicket.checklist[c].isPartial = data.isPartial;
        $scope.Model.currentTicket.checklist[c].isCompleted = data.isCompleted;
      }
    }
    $timeout(() => {
      $scope.saveTicketByProperty($scope.Model.currentTicket.checklist, 'checklist');
    });
  };

  $scope.listChecklistChange = (list, data, isSelected) => {
    $scope.Model.list.hasChecklistSelection = isSelected || list.isSelectedAny();
  };

  $scope.listChecklistReady = (list) => {
    $scope.Model.list.checklist = list;
  };

  /*
   * Ticket view ~ List activity
   * --------------------------------------------------------------------------------
   */
  $scope.listActivityReady = (list) => {
    $scope.Model.list.activity = list;
  };

  /*
   * Ticket view ~ Asset finance
   * --------------------------------------------------------------------------------
   */
  $scope.saveAssetFinance = (data) => {
    $scope.Model.currentAssetFinance.deleteDateObject();
    const assetFinance = data;
    assetFinance.id = $scope.Model.currentAssetFinance.id;
    if (assetFinance.id !== '') {
      return assetFinanceService.updateAssetFinancePartial(assetFinance).then((result) => {
        if (result.status) {
          uiService.toast({
            text: {
              p1: 'Asset finance for deal',
              p2: $scope.Model.currentTicket.getName(),
              p3: 'has been updated'
            },
            success: true
          });
        }
      });
    }
    return null;
  };

  $scope.getNetAmountFinanced = () =>
    assetFinanceService.getCurrentNetAmountFinanced({
      assetDetails: $scope.Model.currentAssetFinance.assetDetails,
      financeProposal: $scope.Model.currentAssetFinance.financeProposal
    });

  $scope.getTerm = () =>
    helperService.getTitleOfSelectedTermInMonths({
      term: $scope.Model.currentAssetFinance?.financeProposal?.term
    });

  $scope.getTotalAssociatedFees = () => {
    if (
      $scope.isDealOwnerBroker() &&
      $scope.hasBrokerToolsEnabled() &&
      $scope.hasAssetFinanceTools() &&
      $scope?.Model?.currentAssetFinance?.financeProposal?.associatedFees?.length
    ) {
      return $scope.Model.currentAssetFinance.financeProposal.associatedFees.reduce(
        (memo, num) => memo + helperService.isNumber(num.amountWithGst, true),
        0
      );
    }
    return '-';
  };

  $scope.getAssetFinanceVendorType = () => {
    if (
      $scope.isDealOwnerBroker() &&
      $scope.hasBrokerToolsEnabled() &&
      $scope.hasAssetFinanceTools() &&
      $scope?.Model?.currentAssetFinance?.assetDetails?.length
    ) {
      return helperService.getAssetFinanceVendorType(
        $scope.Model.currentAssetFinance.assetDetails[0]?.vendor?.type
      );
    }
    return '-';
  };

  /*
   * Ticket view ~ Video conference
   * --------------------------------------------------------------------------------
   */
  $scope.videoConferenceInvite = ($event) => {
    eventService.videoConferenceInvite({
      event: $event,
      clients: _.filter($scope.Model.ticketClients, (client) => client.getEmail() !== ''),
      contacts: _.filter($scope.Model.ticketContacts, (contact) => contact.getEmail() !== ''),
      accounts: $scope.Model.availableAccounts,
      partners: $scope.Model.ticketPartners,
      currentAccount: $rootScope.CurrentAccount,
      idTicket: $scope.Model.currentTicket.id,
      idWorkflow: $scope.Model.currentWorkflow.id
    });
  };

  $scope.videoConferenceInvited = (url) => {
    $timeout(() => {
      $scope.Model.videoConferenceUrl = url;
    }, 200);
  };

  $scope.startVideoConference = () => {
    $window.open($scope.Model.videoConferenceUrl, '_blank', '');
    $timeout(() => {
      $scope.Model.videoConferenceUrl = null;
    });
  };

  $scope.cancelVideoConference = () => {
    $scope.Model.videoConferenceUrl = null;
  };

  /*
   * Ticket view ~ List connect events
   * --------------------------------------------------------------------------------
   */
  $scope.openConnectCall = (contact) => {
    eventService.connectCall({ contact });
  };

  $scope.openConnectSms = (contact) => {
    eventService.connectSms({ contact });
  };

  /*
   * Ticket view ~ Share ticket on client portal
   * --------------------------------------------------------------------------------
   */
  $scope.getIsStageReadOnly = (idStage) => {
    let stage;
    if ($scope.Model.currentWorkflow.stages && $scope.Model.currentWorkflow.stages.length) {
      stage = $scope.Model.currentWorkflow.stages.find((s) => s.id === idStage);
    }
    return stage ? stage.isFactFindEditable : true;
  };

  $scope.toggleSharingOnClientPortal = ($event, ticketClient, hasAccessToClientPortal) => {
    const client = ticketClient;
    $mdDialog
      .show({
        targetEvent: $event,
        locals: {
          currentTicket: $scope.Model.currentTicket,
          currentTicketOwner: $scope.Model.currentTicketOwner,
          currentClient: client,
          allSections: helperService.getAllClientPortalSections(),
          availableSections: helperService.getAvailableClientPortalSections({
            workflow: $scope.Model.currentWorkflow
          }),
          hasAccess: hasAccessToClientPortal,
          haveSamePhones:
            $scope.Model.currentTicketOwner.getPhone().onlyNumbers() ===
            client.getPhone().onlyNumbers(),
          isStageReadOnly: $scope.getIsStageReadOnly($scope.Model.currentTicket.idStage)
        },
        template: templateTicketShareOnClientPortal,
        controllerAs: '$ctrl',
        controller(
          currentTicket,
          currentTicketOwner,
          currentClient,
          allSections,
          availableSections,
          hasAccess,
          haveSamePhones,
          isStageReadOnly
        ) {
          const ctrl = this;
          ctrl.isDev = $rootScope.isDev();
          ctrl.currentOrganization = $rootScope.CurrentOrganization;
          ctrl.hasPrivacyDisclosure =
            $rootScope.CurrentOrganization?.features?.configClientPortal?.display?.privacy
              ?.visible &&
            $rootScope.CurrentOrganization?.features?.configClientPortal?.display?.privacy?.url;
          ctrl.currentTicket = currentTicket;
          ctrl.currentTicketOwner = currentTicketOwner;
          ctrl.currentClient = currentClient;
          ctrl.allSections = allSections;
          ctrl.availableSections = availableSections;
          ctrl.hasAccess = hasAccess;
          ctrl.haveSamePhones = haveSamePhones;
          ctrl.isStageReadOnly = isStageReadOnly;
          ctrl.clientPortalView = 'standard';
          ctrl.clientProfileAllSection = false;
          ctrl.clientProfile = new TicketSharedWithClientProfile();
          ctrl.clientProfile.idClient = ctrl.currentClient.id;
          ctrl.clientProfileSection = {};

          ctrl.clientPortalViewToggle = () => {
            ctrl.clientProfileAllSection = false;
            const len = ctrl.availableSections?.length;
            for (let s = 1; s < len; s += 1) {
              ctrl.clientProfileSection[s + 1] = false;
            }
            if (ctrl.clientPortalView === 'open_banking') {
              ctrl.toggleAllSections();
              ctrl.clientProfile.integrations.isBankStatementsEnabled = false;
              ctrl.clientProfile.integrations.isMogoEnabled = false;
              ctrl.clientProfile.integrations.isCashDeckEnabled = false;
              ctrl.clientProfile.integrations.isOpenBankingEnabled = true;
            }
            if (ctrl.clientPortalView === 'standard') {
              ctrl.clientProfile.integrations.isOpenBankingEnabled = false;
            }
          };

          ctrl.isClientProfileSectionDisabled = (section) =>
            section?.name === TicketSharedWithClientProfileType.details.name;

          ctrl.isClientProfileSectionChecked = (section) => {
            if (ctrl.clientPortalView === 'standard') {
              return (
                section?.name === TicketSharedWithClientProfileType.details.name ||
                section?.name === TicketSharedWithClientProfileType.documents.name
              );
            }
            return false;
          };

          ctrl.toggleAllSections = () => {
            ctrl.clientProfileAllSection = !ctrl.clientProfileAllSection;
            if (ctrl.clientPortalView === 'open_banking') {
              ctrl.clientProfile.sections = [];
            }
            const len = ctrl.availableSections?.length;
            for (let s = 0; s < len; s += 1) {
              const availableSection = ctrl.availableSections[s];
              if (ctrl.clientPortalView === 'open_banking') {
                ctrl.clientProfile.sections.push(
                  new TicketSharedWithClientProfileSection({ section: availableSection })
                );
                ctrl.clientProfileSection[s + 1] = true;
              }

              if (ctrl.clientPortalView === 'standard') {
                const idx = _.findIndex(
                  ctrl.clientProfile.sections,
                  (obj) => obj?.section?.name === availableSection?.name
                );
                if (
                  ctrl.clientProfile.sections[idx]?.section?.name !==
                    ctrl.allSections[0].name &&
                  ctrl.clientProfile.sections[idx]?.section?.name !== ctrl.allSections[10].name
                ) {
                  if (ctrl.clientProfileAllSection) {
                    ctrl.clientProfile.sections.push(
                      new TicketSharedWithClientProfileSection({ section: availableSection })
                    );
                    ctrl.clientProfileSection[s + 1] = true;
                  } else {
                    ctrl.clientProfile.sections.splice(idx, 1);
                    ctrl.clientProfileSection[s + 1] = false;
                  }
                }
              }
            }
          };

          ctrl.toggleSection = ({ section }) => {
            const idx = _.findIndex(
              ctrl.clientProfile.sections,
              (obj) => obj.section?.name === section?.name
            );
            if (idx === -1) {
              ctrl.clientProfile.sections.push(
                new TicketSharedWithClientProfileSection({ section })
              );
            } else {
              ctrl.clientProfile.sections.splice(idx, 1);
            }
          };

          ctrl.hasTicketOwnerEnabledAnyIntegrations = () =>
            ctrl.currentTicketOwner.isBankStatementsEnabled() ||
            ctrl.currentTicketOwner.isCashDeckEnabled() ||
            ($rootScope.isDev() && ctrl.currentTicketOwner.isMogoEnabled());

          ctrl.confirm = () => {
            if (!ctrl.hasAccess) {
              clientAccessService
                .grant({
                  idContact: currentClient.id,
                  idTicket: currentTicket.id,
                  clientProfile: ctrl.clientProfile
                })
                .then((result) => {
                  if (result.status) {
                    uiService.toast({
                      text: {
                        p1: 'Client',
                        p2: currentClient.getName(),
                        p3: 'invited to Client Portal'
                      }
                    });
                  } else {
                    uiService.toast({
                      text: {
                        p1: 'Client',
                        p2: currentClient.getName(),
                        p3: 'invited invitation failed'
                      },
                      warn: true
                    });
                  }
                });
            } else {
              clientAccessService
                .revoke({ idContact: currentClient.id, idTicket: currentTicket.id })
                .then((result) => {
                  if (result) {
                    uiService.toast({
                      text: {
                        p1: 'Revoked access for',
                        p2: currentClient.getName(),
                        p3: 'to the Client Portal'
                      }
                    });
                  } else {
                    uiService.toast({
                      text: {
                        p1: 'Revoking access for',
                        p2: currentClient.getName(),
                        p3: 'to the Client Portal failed'
                      },
                      warn: true
                    });
                  }
                });
            }

            $mdDialog.hide();
          };
          ctrl.cancel = () => {
            $mdDialog.cancel();
          };
        }
      })
      .then(() => {
        $timeout(() => {
          clientAccessService
            .hasAccess({
              idTicket: $scope.Model.currentTicket.id,
              idContact: client.id
            })
            .then((res) => {
              client.hasAccessToClientPortal = res;
            });
        }, 3500);
      });
  };

  $scope.interviewOnClientPortal = ($event, ticketClient) => {
    const client = ticketClient;
    $mdDialog.show({
      targetEvent: $event,
      locals: {
        currentTicket: $scope.Model.currentTicket,
        currentTicketOwner: $scope.Model.currentTicketOwner,
        currentClient: client,
        allSections: helperService.getAllClientPortalSections(),
        availableSections: helperService.getAvailableClientPortalSections({
          workflow: $scope.Model.currentWorkflow
        }),
        isStageReadOnly: $scope.getIsStageReadOnly($scope.Model.currentTicket.idStage)
      },
      template: templateTicketInterviewOnClientPortal,
      controllerAs: '$ctrl',
      controller(
        currentTicket,
        currentTicketOwner,
        currentClient,
        allSections,
        availableSections,
        isStageReadOnly
      ) {
        const ctrl = this;
        ctrl.isDev = $rootScope.isDev();
        ctrl.currentTicket = currentTicket;
        ctrl.currentTicketOwner = currentTicketOwner;
        ctrl.currentClient = currentClient;
        ctrl.allSections = allSections;
        ctrl.availableSections = availableSections;
        ctrl.isStageReadOnly = isStageReadOnly;
        ctrl.clientProfileAllSection = false;
        ctrl.clientProfile = new TicketSharedWithClientProfile();
        ctrl.clientProfile.idClient = ctrl.currentClient.id;
        ctrl.clientProfileSection = {};

        ctrl.toggleAllSections = () => {
          ctrl.clientProfileAllSection = !ctrl.clientProfileAllSection;
          const len = ctrl.availableSections?.length;
          for (let s = 0; s < len; s += 1) {
            const availableSection = ctrl.availableSections[s];
            if (ctrl.clientProfileAllSection) {
              ctrl.clientProfile.sections.push(
                new TicketSharedWithClientProfileSection({ section: availableSection })
              );
              ctrl.clientProfileSection[s + 1] = true;
            } else {
              ctrl.clientProfile.sections = [];
              ctrl.clientProfileSection[s + 1] = false;
            }
          }
        };
        ctrl.toggleSection = ({ section }) => {
          const idx = _.findIndex(
            ctrl.clientProfile.sections,
            (obj) => obj.section?.name === section?.name
          );
          if (idx === -1) {
            ctrl.clientProfile.sections.push(
              new TicketSharedWithClientProfileSection({ section })
            );
          } else {
            ctrl.clientProfile.sections.splice(idx, 1);
          }
        };
        $timeout(() => {
          ctrl.toggleAllSections();
        }, 250);

        ctrl.confirm = () => {
          clientAccessService
            .interview({
              idContact: currentClient.id,
              idTicket: currentTicket.id,
              clientProfile: ctrl.clientProfile
            })
            .then((result) => {
              if (result?.status && result?.token) {
                uiService.toast({
                  text: {
                    p1: 'Client',
                    p2: currentClient.getName(),
                    p3: 'Interview is starting'
                  }
                });
                const url = [
                  window?.instanceConfiguration?.urlClientPortal,
                  $.param({ token: result.token })
                ].join('?');
                $timeout(() => {
                  window.open(url, '_blank');
                });
              } else {
                uiService.toast({
                  text: {
                    p1: 'Client',
                    p2: currentClient.getName(),
                    p3: 'Interview has failed'
                  },
                  warn: true
                });
              }
            });
          $mdDialog.hide();
        };
        ctrl.cancel = () => {
          $mdDialog.cancel();
        };
      }
    });
  };

  /*
   * Ticket view ~ Send email
   * --------------------------------------------------------------------------------
   */
  $scope.emailSend = ({ event, contact }) => {
    event.stopPropagation();
    const isOneRecipient = contact !== undefined;
    const accounts = _.filter(
      $scope.Model.availableTicketAccounts,
      (a) => $scope.Model.currentTicket?.idAccountsAsPartners?.indexOf(a.id) === -1
    );
    const partners = !isOneRecipient
      ? $scope.Model.ticketPartners.concat(
          _.filter(
            $scope.Model.availableTicketAccounts,
            (a) => $scope.Model.currentTicket?.idAccountsAsPartners?.indexOf(a.id) > -1
          )
        )
      : [];
    eventService.emailSend({
      event,
      clients: !isOneRecipient ? $scope.Model.ticketClients : [],
      contacts: !isOneRecipient ? $scope.Model.ticketContacts : [],
      accounts,
      partners,
      attachments: $scope.Model.availableAttachments,
      messages: _.chain($scope.Model.availableMessages).sortNatural('name').value(),
      ticket: $scope.Model.currentTicket,
      contact
    });
  };

  $scope.emailSent = (data) => {
    notesService.clearCache();
    if (data?.status) {
      loadNotes().then(() => {
        $scope.toggleTabList(1);
      });
    }
    uiService.toast({
      text: {
        p1: 'E-mail',
        p2: data?.subject,
        p3: data?.status ? 'has been sent' : 'could not be sent'
      },
      warn: !data.status
    });
  };

  /*
   * Ticket view ~ Drive integration
   * --------------------------------------------------------------------------------
   */
  $scope.driveUploadOrSyncFinished = (data) => {
    if (data?.driveType && data?.driveTitle && !_.isEmpty(data?.folder) && data?.folder?.id) {
      const idx = _.findIndex(
        $scope.Model.currentTicket[`${data?.driveType}Syncs`] || [],
        (s) => s?.idAccount === $rootScope.CurrentAccount?.id
      );
      if (idx > -1) {
        $scope.Model.currentTicket[`${data.driveType}Syncs`][idx].idAccount =
          $rootScope.CurrentAccount?.id;
        $scope.Model.currentTicket[`${data.driveType}Syncs`][idx].idFolder = data.folder.id;
      } else {
        $scope.Model.currentTicket[`${data.driveType}Syncs`].push({
          idAccount: $rootScope.CurrentAccount?.id,
          idFolder: data.folder.id
        });
      }
      ticketService
        .updateTicket({
          id: $scope.Model.currentTicket.id,
          [`${data.driveType}Syncs`]: $scope.Model.currentTicket[`${data.driveType}Syncs`]
        })
        .then(() => {
          uiService.toast({
            text: {
              p1: 'Files from this Deal',
              p2: 'will be synced to',
              p3: `the ${data?.folder?.name || 'N/A'} folder on ${data?.driveTitle}`
            },
            success: true
          });
        });
    }
    $scope.Model.list?.attachments?.deselectedData(
      $scope.Model.list?.attachments?.getSelected()
    );
  };

  $scope.isDriveEnabled = (driveType) =>
    $rootScope.CurrentAccount[`is${driveType.capitalizeFirstLetter()}Enabled`]();

  /*
   * Ticket view ~ BankStatements, Mogo, idSMart
   * --------------------------------------------------------------------------------
   */
  $scope.illionBankStatementsFinished = () => {
    notesService.clearCache();
    loadNotes();
  };
  $scope.mogoFinished = () => {
    notesService.clearCache();
    loadNotes();
  };
  $scope.idSmartFinished = () => {
    notesService.clearCache();
    contactsService.clearCache();
    initialize();
  };

  /*
   * Ticket view ~ Scroll to desired content
   * --------------------------------------------------------------------------------
   */
  $scope.toggleTicketSummaryContent = () => {
    $scope.Model.showTicketSummary = !$scope.Model.showTicketSummary;
  };

  /*
   * Ticket view ~ Back
   * --------------------------------------------------------------------------------
   */
  $scope.back = () => {
    $state.transitionTo('board', { id: $stateParams.id });
  };

  /*
   * Ticket view ~ Save ticket
   * --------------------------------------------------------------------------------
   */
  $scope.saveTicket = (data) => {
    const ticket = data;
    ticket.id = $scope.Model.currentTicket.id;
    ticket.name = $scope.Model.currentTicket.name;
    ticketService.updateTicket(ticket).then((result) => {
      ticketsService.clearCache();
      if (result.status) {
        uiService.toast({
          text: {
            p1: 'Deal',
            p2: $scope.Model.currentTicket.getName(),
            p3: 'has been updated'
          },
          warn: false
        });
      }
    });
  };

  /*
   * Ticket view ~ Save home loan
   * --------------------------------------------------------------------------------
   */
  $scope.saveHomeLoan = (data) => {
    const homeLoan = data;
    homeLoan.id = $scope.Model.currentHomeLoan.id;
    $scope.Model.currentHomeLoan.deleteDateObject();
    if (homeLoan.id !== '') {
      homeLoanService.updateHomeLoanPartial(homeLoan).then((result) => {
        if (result.status) {
          uiService.toast({
            text: {
              p1: 'Broker tools for',
              p2: $scope.Model.currentTicket.getName(),
              p3: 'has been updated'
            },
            warn: false
          });
        }
      });
    }
  };
};
